<template>
  <div>
    <!-- select 2 demo -->

    <div class="d-flex">
      <!-- partial fee modal -->
      <b-modal
        id="modal-partial"
        cancel-variant="outline-secondary"
        hide-footer
        centered
        no-close-on-backdrop
        :title="$t('Partial Fee')"
      >
        <b-row class="">
          <b-col md="12">
            <b-form-group
              :label="$t('Enter Partial Fee %')"
              :invalid-feedback="$t('% should be between (0 - 100)')"
              ref="perc"
            >
              <b-form-input
                type="number"
                :placeholder="$t('Enter percentage')"
                v-model="partialPerc"
                @input="CheckPerc()"
                no-wheel
              />
            </b-form-group>
          </b-col>

          <b-col class="text-right">
            <b-button
              variant="primary"
              :disabled="partialrequest"
              @click="savePartialFee()"
            >
              <b-spinner v-if="partialrequest" small type="grow" />
              <span v-else class="align-middle">{{ $t("Create") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-modal>

      <!-- Custom fee dates (per fee lines) — when setting custom_fees_date is enabled -->
      <b-modal
        v-if="isCustomFeesDateEnabled"
        id="modal-custom-fees-date"
        :title="$t('Apply custom fee dates')"
        centered
        @hidden="resetCustomFeesDateForm"
      >
        <div class="custom-fees-modal-summary mb-2">
          <div v-if="loadingCustomFeesDateModal" class="text-center py-1">
            <b-spinner small type="grow" variant="primary" />
            <span class="ml-50 text-muted">{{ $t("Loading…") }}</span>
          </div>
          <template v-else>
            <div
              class="d-flex flex-nowrap align-items-center custom-fees-modal-badge-row overflow-auto pb-50"
            >
              <template v-if="customFeesDateHasSavedRecord">
                <span class="flex-shrink-0 small mr-75 align-middle">
                  <span class="font-weight-semibold text-dark">{{
                    $t("Saved")
                  }}</span
                  ><span class="font-weight-semibold text-dark">{{
                    $t(" dates of")
                  }}</span>
                </span>
              </template>
              <template v-if="customFeesDateSelectedDescriptors.length">
                <b-badge
                  v-for="(desc, idx) in customFeesDateSelectedDescriptors"
                  :key="'cfd-' + (desc.fid != null ? desc.fid : idx)"
                  variant="light-primary"
                  pill
                  class="flex-shrink-0 mr-50 font-weight-medium"
                >
                  {{ desc.badgeLabel }}
                </b-badge>
              </template>
              <span v-else class="text-muted small mb-0 flex-shrink-0">
                {{ $t("Selected fees") }}
              </span>
            </div>
          </template>
        </div>
        <b-row>
          <b-col md="12" class="mb-1">
            <b-form-group :label="$t('Issue Date')">
              <flat-pickr
                :config="config"
                v-model="customFeesDateForm.issueDate"
                class="form-control"
                :placeholder="$t('Select issue date')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12" class="mb-1">
            <b-form-group :label="$t('Due Date')">
              <flat-pickr
                :config="config"
                v-model="customFeesDateForm.dueDate"
                class="form-control"
                :placeholder="$t('Select due date')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12" class="mb-1">
            <b-form-group :label="$t('Expiry Date')">
              <flat-pickr
                :config="config"
                v-model="customFeesDateForm.expiryDate"
                class="form-control"
                :placeholder="$t('Select expiry date')"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <template #modal-footer>
          <b-button
            v-if="customFeesDateLoadedRecord && customFeesDateLoadedRecord.id"
            variant="outline-danger"
            :disabled="removingCustomFeesDate || savingCustomFeesDate"
            @click="removeCustomFeesDate()"
          >
            <b-spinner v-if="removingCustomFeesDate" small class="mr-50" />
            {{ $t("Remove") }}
          </b-button>
          <b-button
            variant="outline-secondary"
            @click="$bvModal.hide('modal-custom-fees-date')"
          >
            {{ $t("Cancel") }}
          </b-button>
          <b-button
            variant="primary"
            :disabled="
              savingCustomFeesDate ||
              removingCustomFeesDate ||
              loadingCustomFeesDateModal
            "
            @click="saveCustomFeesDate()"
          >
            <b-spinner v-if="savingCustomFeesDate" small class="mr-50" />
            {{ $t("Save") }}
          </b-button>
        </template>
      </b-modal>

      <b-modal
        id="modal-account"
        size="lg"
        :title="modalTitle"
        hide-footer
        centered
        no-close-on-backdrop
      >
        <AccountBranch
          :currentAccount="currentAccount"
          :campuses="campuses"
          :getCampus="getCampus"
        />

        <!-- below code is moved to AccountBranch component -->
        <!-- <b-button
          v-if="!branchForm"
          variant="primary"
          @click="addBranch()"
          class="mb-1"
        >
          Add Branch
        </b-button>

        <div v-if="branchForm">
          <b-form @submit.prevent>
            <b-row>
              <b-col md="6">
                <b-form-group
                  :label="$t('Branch Name')"
                  :invalid-feedback="$t('Branch Name is required')"
                  ref="b_name"
                >
                  <b-form-input
                    v-model.trim="branchObj.branch"
                    :placeholder="$t('Enter branch name')"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  :label="$t('Account Number')"
                  :invalid-feedback="$t('Account Number is required')"
                  ref="b_no"
                >
                  <b-form-input
                    v-model.trim="branchObj.accountNumber"
                    :placeholder="$t('Enter Account number')"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  :label="$t('Campuses')"
                  :invalid-feedback="$t('Campuses is required')"
                  ref="b_camp"
                >
                  <v-select
                    multiple
                    :closeOnSelect="false"
                    v-model="selectedCamp"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="[{ branch: 'All Campuses', id: 0 }, ...campuses]"
                    :clearable="false"
                    :reduce="(val) => val.id"
                    label="branch"
                    :placeholder="$t('Select campus')"
                    @input="setCampus()"
                  ></v-select>
                </b-form-group>
              </b-col>
            </b-row>

            <div class="text-right pb-1">
              <b-button
                type="submit"
                variant="success"
                :disabled="savingBranch"
                @click="saveBranch()"
              >
                <b-spinner v-if="savingBranch" small type="grow" />
                <span v-else>{{$t('Save')}}</span>
              </b-button>
              <b-button
                variant="outline-secondary"
                :disabled="savingBranch"
                @click="branchForm = false"
                class="ml-2"
              >
                Cancel
              </b-button>
            </div>
          </b-form>
        </div>

        <div v-else>
          <b-table
            sticky-header="400px"
            :items="branchItems"
            :fields="branchFields"
            responsive
            hover
            :busy="branchLoading"
            show-empty
            small
          >
            <template #table-busy>
              <div class="d-flex justify-content-center my-3">
                <b-spinner
                  style="width: 2rem; height: 2rem"
                  type="grow"
                  variant="primary"
                  label="Spinning"
                ></b-spinner>
              </div>
            </template>

            <template #cell(campuses)="data">
              <b-badge
                variant="light-primary"
                v-for="cc in data.item.linkedCampuses.split(',')"
                :key="cc"
                class="m-25"
              >
                <span>{{ getCampus(cc) }}</span>
              </b-badge>
            </template>
            <template #cell(actions)="data">
              <b-button
                variant="primary"
                class="btn-icon"
                @click="editBranch(data.item)"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
            </template>
          </b-table>
        </div> -->
      </b-modal>

      <b-modal
        id="modal-upload"
        cancel-variant="outline-secondary"
        hide-footer
        centered
        no-close-on-backdrop
        :title="$t('Upload')"
      >
        <b-form>
          <b-form-group
            :label="$t('Date Column')"
            :invalid-feedback="$t('Date Column is required')"
            ref="dt_col"
          >
            <b-form-input v-model="uploadSettings.dateColumn" />
          </b-form-group>
        </b-form>
        <b-row class="mt-2">
          <b-col class="d-flex justify-content-end">
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="primary"
              :disabled="savingSettings"
            >
              <b-spinner v-if="savingSettings" small type="grow" />
              <span v-else class="align-middle">{{ $t("Save") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-modal>

      <b-modal
        id="modal-receipt"
        cancel-variant="outline-secondary"
        hide-footer
        centered
        no-close-on-backdrop
        :title="$t('Deleted Receipts')"
        size="lg"
        body-class="pl-0 pr-0"
      >
        <b-table
          class=""
          sticky-header
          :items="receiptData"
          :fields="receiptFields"
          responsive
          hover
          :busy="recLoading"
          show-empty
          small
        >
          <template #table-busy>
            <div class="d-flex justify-content-center mb-3 mt-5">
              <b-spinner
                style="width: 3rem; height: 3rem"
                type="grow"
                variant="primary"
                label="Spinning"
              ></b-spinner>
            </div>
          </template>

          <template #head()="scope">
            <div :class="scope.label == 'actions' ? 'text-center' : ''">
              {{ $t(scope.label) }}
            </div>
          </template>

          <template #cell(gr)="data">
            {{ data.item.stdd.grNo }}
          </template>
          <template #cell(name)="data">
            {{ data.item.stdd.name }}
          </template>
          <template #cell(class)="data">
            {{ formatClassSection(data.item) }}
          </template>
          <template #cell(feeType)="data">
            {{ data.item.feesType.feeType }}
          </template>
          <template #cell(monthYear)="data">
            <b-badge variant="light-primary">
              {{ data.item.fees.monthYear }}
            </b-badge>
            <br />
            <b-badge
              v-if="data.item.fees.status == 'hold'"
              variant="light-danger mt-25"
            >
              On Hold
            </b-badge>
          </template>
          <template #cell(lateFee)="data">
            <b-badge variant="light-primary">
              {{ data.item.fees.lateFee }}
            </b-badge>
          </template>
          <template #cell(timelyDiscount)="data">
            <b-badge variant="light-primary">
              {{ data.item.fees.timelyDiscount }}
            </b-badge>
          </template>
          <template #cell(balance)="data">
            <b-badge variant="light-primary">
              {{ data.item.fees.balance }}
            </b-badge>
          </template>
        </b-table>
      </b-modal>

      <b-modal
        id="modal-slip"
        cancel-variant="outline-secondary"
        hide-footer
        centered
        no-close-on-backdrop
        :title="$t('Print Slips')"
      >
        <b-row class="">
          <b-col md="6">
            <b-form-group
              :label="$t('From')"
              :invalid-feedback="$t('From is required')"
              ref="slip_from"
            >
              <b-form-input
                type="number"
                v-model.trim="slipObj.from"
                :placeholder="$t('Enter Slip No')"
                no-wheel
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('Till')"
              :invalid-feedback="$t('Till is required')"
              ref="slip_till"
            >
              <b-form-input
                type="number"
                v-model.trim="slipObj.till"
                :placeholder="$t('Enter Slip No')"
                no-wheel
              />
            </b-form-group>
          </b-col>

          <b-col class="text-right">
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="primary"
              :disabled="printingSlip"
              @click="printBulk()"
            >
              <b-spinner v-if="printingSlip" small type="grow" />
              <span v-else class="align-middle">{{ $t("Print") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-modal>

      <b-modal
        id="modal-exempt"
        cancel-variant="outline-secondary"
        hide-footer
        centered
        no-close-on-backdrop
        :title="$t('Exempt Fee')"
      >
        <b-row class="">
          <b-col md="12" v-if="showExDate">
            <b-form-group
              :label="$t('Date')"
              :invalid-feedback="$t('date is required.')"
              ref="ex_date"
            >
              <flat-pickr
                ref="ex_date"
                :config="config"
                v-model="exObj.date"
                class="form-control"
                :placeholder="$t('Select Date')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Reason')"
              :invalid-feedback="$t('Reason is required')"
              ref="ex_reason"
            >
              <b-form-textarea
                :placeholder="$t('Enter reason')"
                rows="3"
                v-model.trim="exObj.reason"
              />
            </b-form-group>
          </b-col>

          <b-col class="text-right">
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="primary"
              :disabled="exempting"
              @click="ExemptWithNote()"
            >
              <b-spinner v-if="exempting" small type="grow" />
              <span v-else class="align-middle"> {{ $t("Exempt") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-modal>

      <b-modal
        id="modal-request"
        cancel-variant="outline-secondary"
        hide-footer
        centered
        no-close-on-backdrop
        :title="$t('Request')"
        @hidden="resetLeaveReq"
      >
        <b-row class="">
          <b-col md="12">
            <b-form-group :label="$t('Request Date')" ref="req_date">
              <flat-pickr
                disabled
                ref="req_date"
                :config="config"
                v-model="reqObj.request_date"
                class="form-control"
                :placeholder="$t('Select Date')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Reason') + ' *'"
              :invalid-feedback="$t('Reason is required')"
              ref="req_reason"
            >
              <b-form-textarea
                :placeholder="$t('Enter reason')"
                rows="3"
                v-model.trim="reqObj.reason"
                @focusout="CheckReqReason()"
              />
            </b-form-group>
          </b-col>

          <b-col class="text-right">
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="primary"
              :disabled="savingReq"
              @click="saveLeaveReq()"
            >
              <b-spinner v-if="savingReq" small type="grow" />
              <span v-else class="align-middle"> {{ $t("Save") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-modal>

      <!-- Edit Date Modal -->
      <b-modal
        v-model="isEditDateModalVisible"
        :title="$t('Edit Receiving Date')"
        size="sm"
        centered
        hide-footer
      >
        <b-form v-if="editFee">
          <h6 class="mb-50">Slip No# {{ editFee.billID }}</h6>
          <h6 class="mb-50">
            {{ $t("Receiving Date") }}:
            {{
              new Date(editFee.rcvdDate).toLocaleDateString("en-UK", {
                year: "numeric",
                day: "numeric",
                month: "short",
              })
            }}
          </h6>
          <hr />

          <b-row>
            <b-col md="12">
              <b-form-group
                :label="$t('New Receiving Date')"
                :invalid-feedback="$t('Date is required')"
                ref="edit_date"
              >
                <flat-pickr
                  v-model="editFee.newDate"
                  class="form-control"
                  :config="config"
                  :placeholder="$t('Select date')"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <div class="d-flex justify-content-end mt-2">
            <b-button
              variant="primary"
              @click="handleEditDate"
              :disabled="isUpdatingDate"
            >
              <b-spinner v-if="isUpdatingDate" small type="grow" />
              {{ isUpdatingDate ? $t("Updating...") : $t("Update") }}
            </b-button>
          </div>
        </b-form>
      </b-modal>

      <b-modal
        v-model="holdReasonModalVisible"
        :title="$t('Hold reason')"
        size="md"
        centered
        ok-only
        ok-variant="primary"
        body-class="p-0"
        footer-class="border-top-0 pt-0"
        :ok-title="$t('Close')"
      >
        <div class="hold-reason-modal">
          <div class="hold-reason-modal__banner">
            <div class="hold-reason-modal__banner-icon">
              <feather-icon icon="PauseCircleIcon" size="22" />
            </div>
            <div class="hold-reason-modal__banner-text">
              <span class="hold-reason-modal__banner-title">
                {{ $t("Fee on hold") }}
              </span>
              <span
                v-if="holdReasonModalHoldTill"
                class="hold-reason-modal__banner-date"
              >
                {{ $t("Hold till") }}
                <strong>{{
                  formatHoldTillDate(holdReasonModalHoldTill)
                }}</strong>
              </span>
            </div>
          </div>

          <div class="hold-reason-modal__content">
            <div
              v-if="holdReasonModalStudent || holdReasonModalClassSection"
              class="hold-reason-modal__student"
            >
              <feather-icon icon="UserIcon" size="15" />
              <span>
                <template v-if="holdReasonModalStudent">{{
                  holdReasonModalStudent
                }}</template>
                <template v-if="holdReasonModalClassSection">
                  <span v-if="holdReasonModalStudent" class="mx-25">·</span>
                  {{ holdReasonModalClassSection }}
                </template>
              </span>
            </div>

            <div class="hold-reason-modal__reason-label">
              {{ $t("Reason") }}
            </div>
            <div class="hold-reason-modal__reason-box">
              {{ holdReasonModalText || "—" }}
            </div>
          </div>
        </div>
      </b-modal>

      <b-sidebar
        id="sidebar-right"
        ref="mySidebar"
        bg-variant="white"
        v-model="showUpload"
        sidebar-class="sidebar-lg"
        right
        no-header
        backdrop
        shadow
      >
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h5 class="mb-0">{{ $t("Upload") }}</h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="showUpload = false"
          />
        </div>
        <b-form class="p-2" @submit.prevent>
          <b-row>
            <b-col md="12">
              <b-form-group
                :label="$t('Collection Account')"
                :invalid-feedback="$t('Collection account is required')"
                ref="up_acc"
              >
                <v-select
                  v-model="uploadObj.accountID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="accTypes"
                  :reduce="(opt) => opt.id"
                  label="account"
                  :clearable="false"
                  ref="up_acc"
                  :placeholder="$t('Select account type')"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-button
                :variant="uploadObj.isTransport ? 'primary' : 'outline-primary'"
                block
                @click="uploadObj.isTransport = true"
              >
                Transport
              </b-button>
            </b-col>
            <b-col md="6" class="pl-md-0">
              <b-button
                :variant="
                  !uploadObj.isTransport ? 'primary' : 'outline-primary'
                "
                block
                @click="uploadObj.isTransport = false"
              >
                Tuition Fee / Other
              </b-button>
            </b-col>

            <b-col md="12" class="mt-2">
              <!-- <b-button
                v-if="uploadedData.length > 0"
                variant="outline-primary"
                block
                @click="uploadedData = []"
              >
                Clear
              </b-button> -->
              <b-button
                variant="primary"
                @click="$refs.fileProfile.click()"
                :disabled="importing"
                block
              >
                <input
                  type="file"
                  hidden
                  ref="fileProfile"
                  @change="uploadNew()"
                  accept=".xls,.xlsx"
                />
                <!-- @change="uploadOther()" -->
                <b-spinner v-if="importing" small type="grow" />
                <span v-else>{{ $t("Upload") }}</span>
              </b-button>
            </b-col>

            <b-col md="12" class="mt-2">
              <b-button
                variant="success"
                @click="$refs.validProfile.click()"
                :disabled="validating"
                block
              >
                <input
                  type="file"
                  hidden
                  ref="validProfile"
                  @change="uploadValidate()"
                  accept=".xls,.xlsx"
                />
                <b-spinner v-if="validating" small type="grow" />
                <span v-else>{{ $t("Validate File") }}</span>
              </b-button>
            </b-col>

            <!-- <b-col md="12" class="mt-2">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="success"
                :disabled="savingUpload"
                block
                @click="saveUpload()"
              >
                <b-spinner v-if="savingUpload" small type="grow" />
                <span v-else>{{$t('Save')}}</span>
              </b-button>
            </b-col> -->
          </b-row>
        </b-form>
      </b-sidebar>

      <b-sidebar
        id="sidebar-right"
        ref="mySidebar"
        bg-variant="white"
        v-model="showSettings"
        sidebar-class="sidebar-lg"
        right
        no-header
        backdrop
        shadow
      >
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h5 class="mb-0">{{ $t("Settings") }}</h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="showSettings = false"
          />
        </div>
        <b-form class="p-2" @submit.prevent>
          <b-row>
            <b-col md="4" class="pr-0">
              <b-form-checkbox id="checkbox1" v-model="settings.printSlip">
                <h5 class="">{{ $t("Print Slip") }}</h5>
              </b-form-checkbox>
            </b-col>
            <b-col md="4" class="pr-0">
              <b-form-checkbox id="checkbox2" v-model="settings.sendSMS">
                <h5 class="">{{ $t("Send SMS") }}</h5>
              </b-form-checkbox>
            </b-col>
            <b-col md="4" v-if="noticeObj" class="pr-0">
              <b-form-checkbox v-model="noticeObj.valueBool">
                <h5 class="">{{ noticeObj.value }}</h5>
              </b-form-checkbox>
            </b-col>
            <b-col md="12" v-if="cHeadObj" class="mt-1">
              <b-form-checkbox v-model="cHeadObj.valueBool">
                <h5 class="">{{ cHeadObj.value }}</h5>
              </b-form-checkbox>
            </b-col>

            <b-col md="12" class="mt-1">
              <b-form-group
                :label="$t('Print by')"
                :invalid-feedback="$t('Print by is required')"
                ref="printby"
              >
                <v-select
                  ref="printby"
                  v-model="settings.printBy"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="printOptions"
                  :clearable="false"
                  label="text"
                  :reduce="(val) => val.value"
                  :placeholder="$t('Select')"
                />
              </b-form-group>
            </b-col>

            <b-col md="12" class="" v-if="subObj && subObj.valueBool">
              <b-form-group
                :invalid-feedback="$t('Fees to Print is required')"
                ref="to_print"
              >
                <div class="d-flex justify-content-between pb-50">
                  <label class="bv-no-focus-ring col-form-label p-0">{{
                    $t("Fees to Print")
                  }}</label>
                  <b-badge
                    variant="primary"
                    pill
                    class="cursor-pointer"
                    @click="toPrint = []"
                    >{{ $t("Clear All") }}</b-badge
                  >
                </div>
                <v-select
                  class="set_multi"
                  ref="to_print"
                  multiple
                  :closeOnSelect="false"
                  v-model="toPrint"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="[{ id: 0, feeType: 'All' }, ...allfeeType]"
                  label="feeType"
                  :reduce="(val) => val.id"
                  :placeholder="$t('Select')"
                  @input="setAll()"
                />
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-form-group
                :label="$t('Issue Date')"
                :invalid-feedback="$t('issue date is required')"
                ref="issue"
              >
                <flat-pickr
                  ref="issue"
                  :config="config"
                  v-model="settings.issueDate"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                :label="$t('Due Date')"
                :invalid-feedback="$t('due date is required')"
                ref="due"
              >
                <flat-pickr
                  ref="due"
                  :config="config"
                  v-model="settings.dueDate"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                />
              </b-form-group>
            </b-col>
            <b-col md="12" v-if="secondDueDate && secondDueDate.valueBool">
              <b-form-group
                :label="$t('2nd Due Date')"
                :invalid-feedback="$t('due date is required')"
                ref="second_due"
              >
                <flat-pickr
                  :config="config"
                  v-model="secondDueDate.value"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                :label="$t('Expiry Date')"
                :invalid-feedback="$t('expiry date is required')"
                ref="exp"
              >
                <flat-pickr
                  ref="exp"
                  :config="config"
                  v-model="settings.expiryDate"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                />
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-form-group
                :label="$t('Late fee')"
                :invalid-feedback="$t('Late fee is required')"
                ref="late"
              >
                <b-form-input
                  type="number"
                  v-model="settings.lateFee"
                  :placeholder="$t('Enter late fee')"
                  no-wheel
                />
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-form-group
                :label="$t('Tax Percentage (%)')"
                :invalid-feedback="$t('Tax percentage is required')"
                ref="taxPercentage"
                v-if="taxObj && taxObj.valueBool"
              >
                <b-form-input
                  type="number"
                  v-model="taxObj.valueNumber"
                  :placeholder="$t('Enter tax percentage')"
                  min="0"
                  max="100"
                  step="0.01"
                  no-wheel
                />
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-form-group
                :invalid-feedback="$t('timely discount is required')"
                ref="dis"
              >
                <div class="d-flex justify-content-between pb-50">
                  <label class="bv-no-focus-ring col-form-label p-0">{{
                    $t("Timely Discount")
                  }}</label>
                  <span
                    >{{ $t("Till") }}:
                    <b-badge variant="primary" pill>
                      {{
                        new Date(settings.dueDate).toLocaleDateString("en-UK", {
                          year: "numeric",
                          day: "numeric",
                          month: "short",
                        })
                      }}
                    </b-badge>
                  </span>
                </div>
                <b-form-input
                  type="number"
                  v-model="settings.timelyDiscount"
                  :placeholder="$t('Enter timely discount')"
                  no-wheel
                />
              </b-form-group>
            </b-col>

            <b-col md="12" v-if="annualObj">
              <b-form-group
                :label="$t('Annual Discount Date')"
                :invalid-feedback="$t('Annual Discount Date is required')"
                ref="annual_discount"
              >
                <flat-pickr
                  :config="config"
                  v-model="annualObj.value"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                />
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-form-group
                :label="$t('Bank Name')"
                :invalid-feedback="$t('Bank Name is required')"
                ref="bank"
              >
                <b-form-input
                  v-model="settings.bankName"
                  :placeholder="$t('Enter bank name')"
                />
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-form-group
                :label="$t('Title of account')"
                :invalid-feedback="$t('Title of account is required')"
                ref="acc_title"
              >
                <b-form-input
                  v-model="settings.titleOfAccount"
                  :placeholder="$t('Enter title of account')"
                />
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-form-group
                :label="$t('Account Number')"
                :invalid-feedback="$t('Account Number is required')"
                ref="accNo"
              >
                <b-form-input
                  v-model="settings.accountNumber"
                  :placeholder="$t('Enter account number')"
                />
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-form-group
                :label="$t('Fee Challan Instructions')"
                :invalid-feedback="$t('Please enter fee challan instruction')"
                ref="instr"
              >
                <b-form-textarea
                  ref="instr"
                  :placeholder="$t('Please write instruction for fee challan')"
                  v-model="settings.instructions"
                  rows="4"
                ></b-form-textarea>
              </b-form-group>
            </b-col>

            <b-col md="12" class="">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="success"
                @click="saveSettings()"
                :disabled="request"
                block
              >
                <b-spinner v-if="request" small type="grow" />
                <span v-else> {{ $t(sidebarButton) }} </span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-sidebar>

      <b-sidebar
        id="sidebar-right"
        ref="mySidebar"
        bg-variant="white"
        v-model="showDiscount"
        sidebar-class="sidebar-lg"
        right
        no-header
        backdrop
        shadow
      >
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h5 class="mb-0">{{ $t("Discount") }}</h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hideDiscount()"
          />
        </div>
        <b-form class="p-2" @submit.prevent>
          <b-row class="">
            <b-col md="12">
              <b-form-group :label="$t('Current Balance')" ref="currBal">
                <b-form-input
                  disabled
                  :placeholder="$t('Current Balance')"
                  ref="currBal"
                  v-model="currentBalance"
                />
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-form-group
                :label="$t('Discount')"
                :invalid-feedback="$t('Invalid amount entered')"
                ref="discount"
              >
                <b-form-input
                  type="number"
                  :placeholder="$t('Enter discount amount')"
                  ref="discount"
                  v-model="disObj.discountAmount"
                  @input="validateDiscount()"
                  no-wheel
                />
              </b-form-group>
            </b-col>

            <b-col md="12" v-if="settings.timelyDiscount > 0">
              <b-form-group
                :label="$t('Timely Discount')"
                :invalid-feedback="$t('Invalid amount entered')"
                ref="timely"
              >
                <b-form-input
                  type="number"
                  :placeholder="$t('Enter discount amount')"
                  ref="timely"
                  v-model="disObj.timelyDiscount"
                  @input="validateTimely()"
                  no-wheel
                />
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-form-group :label="$t('Net Balance')" ref="netBal">
                <b-form-input
                  disabled
                  :placeholder="$t('Net Balance')"
                  ref="netBal"
                  v-model="netBalance"
                />
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-form-group
                :label="$t('Note')"
                :invalid-feedback="$t('Note is required')"
                ref="dis_note"
              >
                <b-form-textarea
                  :placeholder="$t('Enter note')"
                  rows="3"
                  v-model="disObj.discountNote"
                />
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="success"
                class="mt-1"
                @click="AddDiscount()"
                :disabled="request"
                block
              >
                <b-spinner v-if="request" small type="grow" />
                <span v-else> {{ $t(sidebarButton) }} </span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-sidebar>

      <b-sidebar
        id="sidebar-right"
        ref="mySidebar"
        bg-variant="white"
        v-model="visibility2"
        sidebar-class="sidebar-lg"
        right
        no-header
        backdrop
        shadow
      >
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h5 class="mb-0">{{ $t("Installments") }}</h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="visibility2 = false"
          />
        </div>
        <b-form class="p-2" @submit.prevent>
          <b-row class="mt-1">
            <b-col md="12">
              <b-form-group :label="$t('Current Balance')" ref="currBal">
                <b-form-input
                  disabled
                  :placeholder="$t('Current Balance')"
                  ref="currBal"
                  v-model="instCurrent"
                />
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-form-group
                :label="$t('Installment Amount')"
                :invalid-feedback="$t('Invalid amount entered')"
                ref="instAmount"
              >
                <b-form-input
                  type="number"
                  :placeholder="$t('Enter amount')"
                  ref="instAmount"
                  v-model="instObj.amount"
                  @input="checkInstallment()"
                  no-wheel
                />
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="success"
                @click="saveInstallment()"
                :disabled="request"
                block
              >
                <b-spinner v-if="request" small type="grow" />
                <span v-else>{{ $t("Create Installment") }}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-sidebar>

      <b-sidebar
        id="sidebar-Fee"
        bg-variant="white"
        v-model="visibility"
        sidebar-class="sidebar-lg"
        right
        no-header
        backdrop
        shadow
      >
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h5 class="mb-0">
            {{ $t(sidebarTitle) }}
          </h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hideSideBar()"
          />
        </div>
        <b-form class="p-2" @submit.prevent>
          <b-row class="">
            <b-col md="12">
              <b-form-group
                :label="$t('Status')"
                :invalid-feedback="$t('Status is required')"
              >
                <v-select
                  v-model="searchStatus"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="statusOptions"
                  :clearable="false"
                  label="text"
                  :reduce="(opt) => opt.value"
                  :placeholder="$t('Select')"
                />
              </b-form-group>
            </b-col>
            <b-col md="12" class="mb-1">
              <b-input-group>
                <b-input-group-prepend
                  is-text
                  @click="loadSearch()"
                  class="cursor-pointer"
                >
                  <feather-icon icon="SearchIcon" />
                </b-input-group-prepend>

                <b-form-input
                  v-model="searchQuery"
                  @keyup.enter="loadSearch()"
                  :placeholder="$t('Search by name or gr# or contact')"
                >
                </b-form-input>
              </b-input-group>
            </b-col>
            <b-col md="12" class="mb-1">
              <b-input-group>
                <b-input-group-prepend
                  is-text
                  @click="loadbyFather()"
                  class="cursor-pointer"
                >
                  <feather-icon icon="SearchIcon" />
                </b-input-group-prepend>

                <b-form-input
                  v-model="searchFather"
                  @keyup.enter="loadbyFather()"
                  :placeholder="$t(`Search by ${fSearch} name`)"
                >
                </b-form-input>

                <!-- boundary="viewport" -->
                <b-input-group-append>
                  <b-dropdown
                    variant="primary"
                    right
                    toggle-class="px-75 text-capitalize"
                  >
                    <template #button-content>
                      {{ fSearch }}
                    </template>
                    <b-dropdown-item
                      v-for="item in [
                        { text: 'Father', value: 'father' },
                        { text: 'Mother', value: 'mother' },
                      ]"
                      :key="item.value"
                      @click="selectSearch(item.value)"
                      :active="fSearch === item.value"
                    >
                      <div>{{ item.text }}</div>
                    </b-dropdown-item>
                  </b-dropdown>
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>
        </b-form>

        <b-table
          class=""
          show-empty
          :busy="studentLoading"
          ref="studentSelect"
          :items="searchData"
          :fields="fields2"
          responsive
          hover
          selectable
          select-mode="single"
          @row-selected="onRowSelected"
        >
          <template #table-busy>
            <div class="d-flex justify-content-center mb-3 mt-5">
              <b-spinner
                style="width: 3rem; height: 3rem"
                type="grow"
                variant="primary"
                label="Spinning"
              ></b-spinner>
            </div>
          </template>

          <template #head()="scope">
            <div>
              {{ $t(scope.label) }}
            </div>
          </template>

          <template #cell(student)="data">
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                  size="48"
                  :src="data.item.picture"
                  variant="light-primary"
                />
              </template>

              <b-badge variant="light-primary" class="mb-25">
                {{ data.item.name }}
              </b-badge>
              <span class="font-weight-bold d-block text-nowrap mb-25">
                <b-badge variant="light-primary">
                  F/N: {{ data.item.father_name }}
                </b-badge>
              </span>
              <!-- v-if="showMother && showMother.valueBool" -->
              <span class="font-weight-bold d-block text-nowrap mb-25">
                <b-badge variant="light-primary">
                  M/N: {{ data.item.mother_name }}
                </b-badge>
              </span>
              <small class="text-muted">
                <b-badge variant="light-primary">
                  {{
                    reportDomain === "myskoolhpgs" ||
                    reportDomain === "myskoolprofectus"
                      ? "CID"
                      : "GR"
                  }}
                  - {{ data.item.grNo }}
                </b-badge>
                <b-badge variant="light-primary" class="ml-50">
                  {{ data.item.meta_class }}
                </b-badge>
              </small>
            </b-media>
          </template>
          <template #cell(class)="data">
            <span class="font-weight-bold d-block text-nowrap">
              {{ data.item.meta_class }}
            </span>
          </template>
          <template #cell(details)="data">
            <p>
              <b><span>Name: </span> </b>{{ data.item.name }}
            </p>
            <p>
              <b><span>Father: </span></b> {{ data.item.father_name }}
            </p>
            <p>
              <b><span>Class: </span></b> {{ data.item.meta_class }}
            </p>
          </template>
        </b-table>
      </b-sidebar>

      <b-sidebar
        id="sidebar-Fee"
        bg-variant="white"
        v-model="accountbar"
        sidebar-class="sidebar-lg"
        right
        no-header
        backdrop
        shadow
      >
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h5 class="mb-0">{{ $t("Collection Account") }}</h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="accountbar = false"
          />
        </div>

        <b-form class="p-2" @submit.prevent>
          <!-- <b-row class="mt-1" v-if="!addingAcc">
            <b-col md="12">
              <b-button variant="primary" @click="addingAcc = true">
                Add Account
              </b-button>
            </b-col>
          </b-row> -->
          <b-row class="d-flex align-items-center">
            <b-col md="12">
              <b-form-group
                :label="$t('Account Name')"
                :invalid-feedback="$t('Account name is required')"
              >
                <b-form-input
                  ref="accname"
                  v-model.trim="accountObj.account"
                  :placeholder="$t('Enter collection account name')"
                  @focusout="checkAccount()"
                >
                </b-form-input>
              </b-form-group>
            </b-col>
            <!-- v-if="entryObj && entryObj.valueBool" -->
            <b-col md="12">
              <b-form-group
                :label="$t('Link with')"
                :invalid-feedback="$t('Account is required')"
              >
                <v-select
                  ref="coa"
                  v-model="accountObj.accountID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="coAccounts"
                  :reduce="(opt) => opt.id"
                  :clearable="true"
                  label="title"
                  :placeholder="$t('Select account')"
                  @input="setCOA"
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-button
                variant="success"
                class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
                @click="saveAcc()"
                :disabled="savingacc"
                block
              >
                <b-spinner v-if="savingacc" small type="grow" />
                <!-- <feather-icon v-else :icon="accIcon" /> -->
                <span v-else>{{ $t("Save") }}</span>
              </b-button>
            </b-col>
          </b-row>
          <b-table
            class="mt-2"
            show-empty
            :items="accTypes"
            :fields="accFields"
            responsive
            hover
            small
          >
            <template #head()="scope">
              <div :class="scope.label === 'actions' ? 'text-right' : ''">
                {{ $t(scope.label) }}
              </div>
            </template>

            <template #cell(actions)="data">
              <div class="text-right">
                <b-button
                  v-if="
                    reportDomain === 'myskoolhpgs' &&
                    !['cash', 'cheque', 'paypro', 'online'].some((word) =>
                      data.item.account.toLowerCase().includes(word)
                    )
                  "
                  variant="outline-primary"
                  class="btn-icon mr-75"
                  @click="showAccBranch(data.item)"
                >
                  <feather-icon icon="HomeIcon" />
                </b-button>
                <b-button
                  variant="primary"
                  class="btn-icon mr-50"
                  @click="editAcc(data.item)"
                >
                  <feather-icon icon="EditIcon" />
                </b-button>
                <!-- <b-button
                  variant="outline-danger"
                  class="btn-icon"
                  @click="deleteAcc(data.item)"
                >
                  <feather-icon icon="Trash2Icon" />
                </b-button> -->
              </div>
            </template>
          </b-table>
        </b-form>
      </b-sidebar>

      <b-sidebar
        id="sidebar-right"
        ref="mySidebar"
        bg-variant="white"
        v-model="visibility3"
        sidebar-class="sidebar-lg"
        right
        no-header
        backdrop
        shadow
      >
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h5 class="mb-0">{{ $t("Hold Fees") }}</h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="visibility3 = false"
          />
        </div>
        <b-form class="p-2" @submit.prevent>
          <b-row class="mt-1">
            <b-col md="12">
              <b-form-group
                :label="$t('Date')"
                :invalid-feedback="$t('Date is required')"
                ref="commit_date"
              >
                <flat-pickr
                  ref="commit_date"
                  :config="config"
                  v-model="commitObj.date"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                />
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-form-group
                :label="$t('Reason')"
                :invalid-feedback="$t('Reason')"
                ref="reason"
              >
                <b-form-textarea
                  ref="reason"
                  :placeholder="$t('Write reason for holding')"
                  v-model.trim="commitObj.reason"
                  rows="4"
                ></b-form-textarea>
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="success"
                @click="saveCommitment()"
                :disabled="pSaving"
                block
              >
                <b-spinner v-if="pSaving" small type="grow" />
                <span v-else>{{ $t("Save") }}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-sidebar>

      <b-sidebar
        id="sidebar-right"
        ref="mySidebar"
        bg-variant="white"
        v-model="hisOpen"
        sidebar-class="sidebar-lg"
        right
        no-header
        backdrop
        shadow
      >
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h5 class="mb-0">{{ $t("Fee History") }}</h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hisOpen = false"
          />
        </div>
        <b-form class="p-2" @submit.prevent>
          <b-row class="mt-1">
            <b-col md="12">
              <b-form-group
                :label="$t('Date')"
                :invalid-feedback="$t('Date is required')"
                ref="his_date"
              >
                <flat-pickr
                  ref="his_date"
                  :config="config2"
                  v-model="rangeDate"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                  @on-change="setHisDate()"
                />
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                @click="printHistory()"
                :disabled="hisPrinting"
                block
              >
                <b-spinner v-if="hisPrinting" small type="grow" />
                <span v-else>{{ $t("Show") }}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-sidebar>

      <b-sidebar
        id="sidebar-Fee"
        bg-variant="white"
        v-model="visibility4"
        sidebar-class="sidebar-lg"
        right
        no-header
        backdrop
        shadow
      >
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h5 class="mb-0">{{ $t("Manage Organizations") }}</h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="visibility4 = false"
          />
        </div>

        <b-form class="p-2" @submit.prevent>
          <b-row class="d-flex align-items-center">
            <b-col md="12">
              <b-form-group
                :label="$t('Organization Name')"
                :invalid-feedback="$t('Organization name is required')"
              >
                <b-form-input
                  ref="org_name"
                  v-model.trim="orgObj.title"
                  :placeholder="$t('Enter organization name')"
                  @focusout="checkOrg()"
                >
                </b-form-input>
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-button
                variant="success"
                class="btn-icon mt-1"
                @click="saveOrg()"
                :disabled="savingOrg"
                block
              >
                <b-spinner v-if="savingOrg" small type="grow" />
                <span v-else>{{ $t("Save") }}</span>
              </b-button>
            </b-col>
          </b-row>
          <b-table
            class="mt-2"
            show-empty
            :items="orgList"
            :fields="orgFields"
            responsive
            hover
          >
            <template #head()="scope">
              <div :class="scope.label === 'actions' ? 'text-right' : ''">
                {{ $t(scope.label) }}
              </div>
            </template>

            <template #cell(actions)="data">
              <div class="text-right">
                <b-button
                  variant="primary"
                  class="btn-icon mr-0 ml-sm-1 mb-1 mb-sm-0"
                  @click="editOrg(data.item)"
                >
                  <feather-icon icon="EditIcon" />
                </b-button>
                <!-- <b-button
                  variant="outline-danger"
                  class="btn-icon mr-0 ml-sm-1 mb-1 mb-sm-0"
                  @click="deleteOrg(data.item.id)"
                >
                  <feather-icon icon="Trash2Icon" />
                </b-button> -->
              </div>
            </template>
          </b-table>
        </b-form>
      </b-sidebar>

      <!-- Table Top -->
      <b-col md="9" style="padding: 0">
        <b-card>
          <b-row>
            <b-col md="12" v-if="createForm">
              <b-card class="card mt-1 rightCard">
                <h3>{{ $t("Create Fee") }}</h3>
                <hr />
                <b-row>
                  <b-col md="12">
                    <b-form-group
                      :label="$t('Select Fee Type')"
                      :invalid-feedback="$t('fee type is required')"
                      ref="type"
                    >
                      <a class="my-buttons font-weight-bold">
                        <span v-if="!showAll" @click="showAll = true">{{
                          $t("Show More")
                        }}</span>
                        <span v-else @click="showAll = false">{{
                          $t("Show Less")
                        }}</span>
                      </a>
                      <div
                        :class="{ 'my-collapsing': !showAll }"
                        style="
                          border: 1px solid lightgray;
                          padding: 5px;
                          border-radius: 5px;
                        "
                      >
                        <div
                          v-if="dataLoading"
                          class="d-flex justify-content-center align-items-center mt-50"
                        >
                          <b-spinner
                            small
                            style="width: 1.5rem; height: 1.5rem"
                          />
                        </div>

                        <template v-else>
                          <b-button
                            style="margin: 5px"
                            class="btn-icon"
                            v-for="fee in campusFeeType"
                            :key="fee.id"
                            :variant="
                              variantFeetype(fee.id)
                                ? 'primary'
                                : 'outline-primary'
                            "
                            @click="selectFeetype(fee.id, fee.recurrence)"
                          >
                            {{ fee.feeType }}
                          </b-button>
                        </template>
                      </div>
                    </b-form-group>
                  </b-col>
                  <b-col md="12" class="" v-if="false">
                    <!-- v-if="subObj && subObj.valueBool && showOnBehalf" -->
                    <b-form-group
                      :label="$t('Late on Behalf of')"
                      :invalid-feedback="$t('Please select fee type')"
                      ref="late_type"
                    >
                      <a class="my-buttons font-weight-bold">
                        <span v-if="!showAllLate" @click="showAllLate = true">{{
                          $t("Show More")
                        }}</span>
                        <span v-else @click="showAllLate = false">{{
                          $t("Show Less")
                        }}</span>
                      </a>
                      <div
                        :class="{ 'my-collapsing': !showAllLate }"
                        style="
                          border: 1px solid lightgray;
                          padding: 5px;
                          border-radius: 5px;
                        "
                      >
                        <b-button
                          style="margin: 5px"
                          class="btn-icon"
                          v-for="fee in campusFeeType.filter(
                            (el) => el.recurrence != 'after due date'
                          )"
                          :key="fee.id"
                          :variant="
                            collection.onBehalf == fee.id
                              ? 'primary'
                              : 'outline-primary'
                          "
                          @click="selectOnBehalf(fee.id)"
                        >
                          {{ fee.feeType }}
                        </b-button>
                      </div>
                    </b-form-group>
                  </b-col>
                  <b-col md="10">
                    <b-form-group
                      :label="$t('Select Months')"
                      :invalid-feedback="$t('month is required')"
                      ref="months"
                    >
                      <div
                        style="
                          border: 1px solid lightgray;
                          padding: 5px;
                          border-radius: 5px;
                        "
                      >
                        <b-button
                          style="margin: 7px"
                          class="btn-icon"
                          v-for="mon in months"
                          :key="mon.id"
                          :variant="
                            variantMonth(mon.name)
                              ? 'primary'
                              : 'outline-primary'
                          "
                          @click="selectMonth(mon.name)"
                        >
                          {{ mon.name }}
                        </b-button>
                      </div>
                    </b-form-group>
                  </b-col>
                  <b-col md="2" class="">
                    <b-form-group
                      :label="$t('Select Year') + ' *'"
                      :invalid-feedback="$t('year is required')"
                      ref="year"
                    >
                      <v-select
                        v-model="collection.year"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="years"
                        :clearable="false"
                        ref="year"
                        label="name"
                        :placeholder="$t('Select year')"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col class="text-right mt-1">
                    <b-button
                      variant="success"
                      :disabled="saving || dataLoading || partialrequest"
                      class="mr-1"
                      @click="saveFee()"
                    >
                      <div v-if="saving">
                        <b-spinner
                          small
                          variant="light"
                          type="grow"
                          label="Spinning"
                        ></b-spinner>
                      </div>
                      <span v-else>{{ $t("Save") }}</span>
                    </b-button>

                    <b-button
                      v-if="partialObj && partialObj.valueBool"
                      variant="warning"
                      :disabled="saving || dataLoading || partialrequest"
                      class="mr-1"
                      @click="openPartial()"
                    >
                      <span>{{ $t("Create Partial Fee") }}</span>
                    </b-button>

                    <b-button variant="outline-secondary" @click="closeForm()">
                      {{ $t("Close") }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>

            <b-col md="12" v-else>
              <b-row class="mt-1 d-flex align-items-center">
                <b-col xl="7" lg="7" md="7" sm="12" cols="12" class="d-flex">
                  <!-- <b-form-group
                    v-if="schGr && schGr.valueBool"
                    :invalid-feedback="
                      searchType == 'grNo'
                        ? 'CID no is required.'
                        : 'GR no is required.'
                    "
                    class="mr-1"
                  >
                    <label class="m-0 pb-50">
                      <b-button
                        :variant="
                          searchType == 'grNo' ? 'primary' : 'outline-primary'
                        "
                        pill
                        class="btn-icon font-small-2 mr-50"
                        size="sm"
                        @click="searchType = 'grNo'"
                        >CID #</b-button
                      >
                      <b-button
                        :variant="
                          searchType == 'grNoLocal'
                            ? 'primary'
                            : 'outline-primary'
                        "
                        pill
                        class="btn-icon font-small-2"
                        size="sm"
                        @click="searchType = 'grNoLocal'"
                        >GR #</b-button
                      >
                    </label>
                    <b-form-input
                      v-model="myObj.gr"
                      class="form-control"
                      :placeholder="
                        searchType == 'grNo' ? 'Enter CID' : 'Enter GR No.'
                      "
                      @input="setLastChanged('gr')"
                      @keyup.enter="byGR()"
                      ref="grNo"
                    />
                  </b-form-group>
                   -->
                  <b-form-group
                    :label="
                      (reportDomain === 'myskoolhpgs' ||
                      reportDomain === 'myskoolprofectus'
                        ? $t('CID')
                        : idVisible.includes(reportDomain)
                        ? $t('ID')
                        : $t('GR')) + ' #'
                    "
                    :invalid-feedback="
                      reportDomain === 'myskoolhpgs' ||
                      reportDomain === 'myskoolprofectus'
                        ? $t('CID no is required')
                        : idVisible.includes(reportDomain)
                        ? $t('ID no is required')
                        : $t('GR no is required')
                    "
                    class="mr-1"
                  >
                    <b-form-input
                      v-model="myObj.gr"
                      class="form-control"
                      :placeholder="
                        reportDomain === 'myskoolhpgs' ||
                        reportDomain === 'myskoolprofectus'
                          ? $t('Enter CID')
                          : idVisible.includes(reportDomain)
                          ? $t('Enter ID')
                          : $t('Enter GR No')
                      "
                      @input="setLastChanged('gr')"
                      @keyup.enter="byGR()"
                      ref="grNo"
                    />
                  </b-form-group>
                  <!-- <b-form-group
                    label="GR #"
                    invalid-feedback="GR no is required."
                    class="mr-1"
                  >
                    <b-form-input
                      v-model="myObj.gr"
                      class="form-control"
                      placeholder="Enter GR number"
                      @input="setLastChanged('gr')"
                      @keyup.enter="byGR()"
                      ref="grNo"
                    />
                  </b-form-group> -->
                  <b-form-group
                    :label="$t('Family Code')"
                    :invalid-feedback="$t('Family Code is required')"
                    class="mr-1"
                  >
                    <b-form-input
                      v-model="myObj.familyCode"
                      class="form-control"
                      :placeholder="$t('Enter family code')"
                      ref="fCode"
                      @input="setLastChanged('family')"
                      @keyup.enter="byFamily()"
                    />
                  </b-form-group>
                  <b-form-group
                    :label="$t('Challan No')"
                    :invalid-feedback="$t('Challan No is required')"
                    class="mr-1"
                  >
                    <b-form-input
                      v-model="myObj.challanNo"
                      class="form-control"
                      type="number"
                      :placeholder="$t('Enter challan number')"
                      ref="challan"
                      @input="setLastChanged('challan')"
                      @keyup.enter="byChallan()"
                      no-wheel
                    />
                  </b-form-group>
                  <b-form-checkbox
                    v-model="auto"
                    switch
                    class="mt-2"
                    v-b-tooltip.hover.top
                    :title="$t('Auto Received')"
                  />
                </b-col>
                <!-- <b-col xl="2" lg="2" md="3" sm="12" cols="12">
                  <b-form-group
                    label="Family code"
                    invalid-feedback="Family code is required."
                  >
                    <b-form-input
                      v-model="myObj.familyCode"
                      class="form-control"
                      placeholder="Enter family code"
                      ref="fCode"
                      @keyup.enter="byFamily()"
                    />
                  </b-form-group>
                </b-col> -->
                <!-- <b-col
                  xl="3"
                  lg="4"
                  md="4"
                  sm="12"
                  cols="12"
                  class="d-flex pl-0"
                >
                  <b-form-group
                    label="Challan No"
                    invalid-feedback="Challan No is required."
                  >
                    <b-form-input
                      v-model="myObj.challanNo"
                      class="form-control"
                      type="number"
                      placeholder="Enter challan number"
                      ref="challan"
                      @keyup.enter="byChallan()"
                    />
                  </b-form-group>
                  <b-form-checkbox v-model="auto" switch class="ml-50" /> 
                </b-col> -->
                <b-col
                  xl="2"
                  lg="2"
                  md="2"
                  sm="12"
                  cols="12"
                  class="d-flex mb-50 mb-md-0 pl-md-0"
                >
                  <b-button
                    class="topButtons btn-icon mr-1"
                    style="width: 75%"
                    :disabled="dataLoading || gridLoading"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    @click="show()"
                  >
                    <span class="align-middle">{{ $t("Show") }}</span>
                  </b-button>
                  <b-button
                    class="topButtons btn-icon mr-1"
                    :disabled="dataLoading"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="outline-primary"
                    @click="showSidebar()"
                  >
                    <feather-icon icon="SearchIcon" />
                  </b-button>
                </b-col>

                <b-col xl="3" lg="3" md="3" sm="12" cols="12" v-if="rights.add">
                  <b-button
                    class="topButtons btn-icon"
                    block
                    :disabled="dataLoading"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    @click="showForm()"
                  >
                    <span class="align-middle">{{ $t("Create Fee") }}</span>
                  </b-button>
                </b-col>
              </b-row>
              <b-row class="mt-1">
                <b-col md="6">
                  <b-button
                    v-if="rights.edit && receiveObj.feesIDs.length > 0"
                    variant="primary"
                    class="btn-icon mr-1"
                    @click="openCom()"
                    :disabled="unholding || pSaving"
                  >
                    {{ $t("Hold") }}
                  </b-button>
                  <b-button
                    v-if="rights.edit && receiveObj.feesIDs.length > 0"
                    variant="primary"
                    class="btn-icon"
                    @click="unHoldFee()"
                    :disabled="unholding || pSaving"
                  >
                    {{ $t("UnHold") }}
                  </b-button>
                  <b-button
                    v-if="
                      (rights.edit || rights.add) &&
                      isCustomFeesDateEnabled &&
                      myObj &&
                      myObj.id > 0
                    "
                    variant="outline-primary"
                    class="btn-icon ml-1"
                    @click="openCustomFeesDateModal()"
                    :disabled="
                      savingCustomFeesDate ||
                      dataLoading ||
                      gridLoading ||
                      loadingCustomFeesDateLoad
                    "
                  >
                    {{ $t("Apply custom fee dates") }}
                  </b-button>
                </b-col>
                <b-col md="6" class="text-right">
                  <b-button
                    variant="outline-primary"
                    class="btn-icon mr-1"
                    @click="printFeeReminderTop()"
                  >
                    {{ $t("Fee Reminder") }}
                  </b-button>
                  <b-button
                    variant="outline-primary"
                    class="btn-icon mr-1"
                    @click="printLedger()"
                  >
                    {{ $t("Ledger") }}
                  </b-button>
                  <b-button
                    variant="outline-primary"
                    class="btn-icon"
                    @click="getReport()"
                  >
                    {{ $t("Print Report") }}
                  </b-button>
                  <!-- <b-button
                    variant="outline-primary"
                    class="btn-icon ml-1"
                    @click="$refs.fileProfile.click()"
                    :disabled="importing"
                  >
                    <input
                      type="file"
                      hidden
                      ref="fileProfile"
                      @change="upload()"
                      accept=".xls,.xlsx"
                    />
                    Upload
                  </b-button> -->
                  <b-button
                    variant="outline-primary"
                    class="btn-icon ml-1"
                    @click="OpenModal()"
                  >
                    {{ $t("Upload") }}
                  </b-button>
                  <b-button
                    variant="outline-primary"
                    class="btn-icon ml-1"
                    @click="openSlipModal()"
                    v-b-tooltip.hover.top
                    :title="$t('Print Slips')"
                  >
                    <feather-icon icon="FileTextIcon" />
                  </b-button>
                  <b-button
                    v-if="currLedgObj && currLedgObj.valueBool"
                    variant="outline-primary"
                    class="btn-icon ml-1"
                    @click="loadLedger()"
                    :disabled="ledgLoading"
                    v-b-tooltip.hover.top
                    :title="$t('Student Ledger')"
                  >
                    <b-spinner
                      v-if="ledgLoading"
                      small
                      variant="primary"
                      label="Spinning"
                    />
                    <feather-icon v-else icon="FileIcon" />
                  </b-button>

                  <!-- <b-button
                    variant="outline-primary"
                    class="btn-icon ml-1"
                    @click="showDeleted()"
                  >
                    Receipts
                  </b-button> -->
                </b-col>
                <b-col md="2">
                  <b-form-checkbox
                    v-if="false"
                    id="checkbox"
                    v-model="allSelect"
                    @input="checkSelect()"
                  >
                    <h5 class="" v-if="!allSelect">{{ $t("Select all") }}</h5>
                    <h5 class="" v-else>{{ $t("Unselect all") }}</h5>
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <!-- <b-button @click="selectAllRows" variant="primary"
                >Select all</b-button
              >
              <b-button @click="clearSelected" variant="primary"
                >Clear selected</b-button
              > -->

              <b-table
                ref="selectableTable"
                class="mt-1"
                :busy="gridLoading"
                show-empty
                :items="items"
                :fields="computedFields"
                responsive
                hover
                small
                selectable
                :select-mode="'multi'"
                selected-variant="secondary"
                @row-selected="onChallanRowSelect"
              >
                <template #table-busy>
                  <div class="d-flex justify-content-center mb-3 mt-5">
                    <b-spinner
                      style="width: 3rem; height: 3rem"
                      type="grow"
                      variant="primary"
                      label="Spinning"
                    ></b-spinner>
                  </div>
                </template>

                <template #head()="scope">
                  <div :class="scope.label === 'actions' ? 'text-right' : ''">
                    {{ $t(scope.label) }}
                  </div>
                </template>

                <template #cell(gr)="data">
                  {{ data.item.stdd.grNo }}
                </template>
                <template #cell(name)="data">
                  {{ data.item.stdd.name }}
                </template>
                <template #cell(class)="data">
                  {{ formatClassSection(data.item) }}
                </template>
                <template #cell(feeType)="data">
                  {{ data.item.feesType.feeType }}
                </template>
                <template #cell(monthYear)="data">
                  <b-badge variant="light-primary">
                    {{ data.item.fees.monthYear }}
                  </b-badge>
                  <br />
                  <b-badge
                    v-if="data.item.fees.status == 'hold'"
                    variant="light-danger mt-25"
                  >
                    On Hold
                  </b-badge>
                </template>
                <template #cell(lateFee)="data">
                  <b-badge variant="light-primary">
                    {{ data.item.fees.lateFee }}
                  </b-badge>
                </template>
                <template #cell(timelyDiscount)="data">
                  <b-badge variant="light-primary">
                    {{ data.item.fees.timelyDiscount }}
                  </b-badge>
                </template>
                <template #cell(balance)="data">
                  <b-badge variant="light-primary">
                    {{ data.item.fees.balance }}
                  </b-badge>
                </template>

                <template #cell(holdReason)="data">
                  <span
                    v-if="!getHoldReasonText(data.item.fees)"
                    class="text-muted"
                    >—</span
                  >
                  <button
                    v-else
                    type="button"
                    class="hold-reason-chip"
                    v-b-tooltip.hover.bottomleft
                    :title="$t('View full hold reason')"
                    @click.stop="openHoldReasonModal(data.item)"
                  >
                    <feather-icon
                      icon="PauseCircleIcon"
                      size="13"
                      class="hold-reason-chip__icon"
                    />
                    <span class="hold-reason-chip__text">
                      {{
                        truncateHoldReason(
                          getHoldReasonText(data.item.fees),
                          32
                        )
                      }}
                    </span>
                  </button>
                </template>

                <template #cell(actions)="data">
                  <div class="d-flex justify-content-center">
                    <b-button
                      v-if="
                        role.toLowerCase() == 'administrator' || rights.edit
                      "
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="primary"
                      class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
                      @click="openDiscount(data.item)"
                    >
                      {{ $t("Discount") }}
                    </b-button>
                    <b-button
                      v-if="
                        role.toLowerCase() == 'administrator' || rights.edit
                      "
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="outline-primary"
                      class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
                      v-b-tooltip.hover.bottomleft
                      :title="$t('Installment')"
                      @click="openInst(data.item)"
                    >
                      <feather-icon icon="ShuffleIcon" />
                    </b-button>
                    <b-button
                      v-if="
                        role.toLowerCase() == 'administrator' || rights.edit
                      "
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="outline-primary"
                      class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
                      v-b-tooltip.hover.bottomleft
                      :title="$t('Fee Exempt')"
                      @click="openExempt(data.item.fees.id)"
                    >
                      <!-- @click="Exempt(data.item.fees.id)" -->
                      <feather-icon icon="StarIcon" />
                    </b-button>
                    <b-button
                      v-if="
                        approvalList.includes('remove-fee') && rights.delete
                      "
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      variant="outline-warning"
                      class="btn-icon mr-1"
                      v-b-tooltip.hover.bottomright
                      :title="$t('Delete Request')"
                      @click="openRequest(data.item)"
                    >
                      <feather-icon icon="LogOutIcon" />
                    </b-button>
                    <b-button
                      v-else-if="
                        role.toLowerCase() == 'administrator' || rights.delete
                      "
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="outline-danger"
                      class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
                      v-b-tooltip.hover.bottomright
                      :title="$t('Delete')"
                      @click="deleteFee(data.item.fees.id)"
                    >
                      <feather-icon icon="Trash2Icon" />
                    </b-button>
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-card>

        <b-card class="pl-1 pr-1" v-if="!rights.hideFee">
          <b-row align-h="between">
            <div class="d-flex flex-wrap align-items-center">
              <h2 class="ml-1">
                {{ $t("Fee History") }}
                <feather-icon
                  class="ml-50 cursor-pointer"
                  icon="PrinterIcon"
                  size="18"
                  @click="openPrint()"
                  v-b-tooltip.hover.right
                  :title="$t('Print')"
                />
              </h2>
              <b-badge
                v-if="prevLedgObj && prevLedgObj.valueBool && showLedg"
                variant="success"
                class="ml-1 px-1 cursor-pointer"
                pill
                @click="openLedger()"
              >
                {{ $t("View Previous Ledger") }}
              </b-badge>
            </div>
            <feather-icon
              v-if="!$store.state.history"
              class="cursor-pointer"
              icon="ArrowDownIcon"
              size="28"
              @click="showHistory()"
            />
            <feather-icon
              v-else
              class="cursor-pointer"
              icon="ArrowUpIcon"
              size="28"
              @click="hideHistory()"
            />
          </b-row>

          <b-collapse id="collapse-1" v-model="$store.state.history">
            <hr class="border-top-dark" />
            <b-table
              class="mt-1"
              :busy="historyLoading"
              show-empty
              :items="history"
              :fields="hisFields"
              responsive
              hover
              small
            >
              <template #table-busy>
                <div class="d-flex justify-content-center mb-3 mt-5">
                  <b-spinner
                    style="width: 3rem; height: 3rem"
                    type="grow"
                    variant="primary"
                    label="Spinning"
                  ></b-spinner>
                </div>
              </template>
              <template #head()="scope">
                <div>
                  {{ $t(scope.label) }}
                </div>
              </template>

              <template #cell(billID)="data">
                <b-badge
                  v-if="data.item.fees.billID <= 0"
                  variant="light-danger"
                >
                  {{ data.item.fees.status }}
                </b-badge>
                <b-badge variant="light-primary" v-else>
                  {{ data.item.fees.billID }}
                </b-badge>
              </template>
              <template #cell(rcvdDate)="data">
                <b-badge variant="light-primary">
                  {{
                    new Date(data.item.fees.rcvdDate).toLocaleDateString(
                      "en-UK",
                      {
                        year: "numeric",
                        day: "numeric",
                        month: "short",
                      }
                    )
                  }}
                </b-badge>
              </template>
              <template #cell(feeType)="data">
                {{ data.item.feesType.feeType }}
              </template>
              <template #cell(class)="data">
                {{ formatClassSection(data.item) }}
              </template>
              <template #cell(discount)="data">
                <b-badge variant="light-primary">
                  {{ data.item.fees.discount }}
                </b-badge>
              </template>
              <template #cell(monthYear)="data">
                <b-badge variant="light-primary">
                  {{ data.item.fees.monthYear }}
                </b-badge>
              </template>
              <template #cell(rcvd)="data">
                <b-badge variant="light-primary">
                  {{
                    data.item.fees.billID == 0
                      ? data.item.fees.exempted
                      : data.item.fees.rcvd
                  }}
                </b-badge>
              </template>
              <template #cell(rcvdBy)="data">
                <b-badge variant="light-primary" class="mb-25">
                  {{ getUser(data.item.fees.rcvdBy) }}
                </b-badge>
                <div>
                  <b-badge variant="light-primary">
                    {{ getAcc(data.item.fees.accountID) }}
                  </b-badge>
                </div>
                <div
                  v-if="
                    data.item.fees.holdReason &&
                    ['myskooliota', 'myskooliota2'].includes(reportDomain)
                  "
                  class="mt-25"
                >
                  <b-badge variant="light-primary">
                    {{
                      new Date(data.item.fees.holdReason).toLocaleDateString(
                        "en-UK",
                        {
                          year: "numeric",
                          day: "numeric",
                          month: "short",
                        }
                      )
                    }}
                  </b-badge>
                </div>
              </template>

              <template #cell(actions)="data">
                <!-- class="mr-3 text-right" -->
                <div class="d-flex">
                  <b-button
                    v-if="data.item.fees.billID > 0"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="btn-icon mr-1"
                    v-b-tooltip.hover.bottomleft
                    :title="$t('Print')"
                    @click="
                      printSlip(
                        data.item.fees.billID,
                        total,
                        data.item.fees.campusID
                      )
                    "
                  >
                    <feather-icon icon="PrinterIcon" />
                  </b-button>

                  <b-button
                    v-if="
                      editRcvDate &&
                      editRcvDate.valueBool &&
                      rights.editDate &&
                      data.item.fees.billID > 0
                    "
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="btn-icon mr-1"
                    v-b-tooltip.hover.bottomleft
                    :title="$t('Edit Date')"
                    @click="openEditDate(data.item.fees)"
                  >
                    <feather-icon icon="EditIcon" />
                  </b-button>

                  <b-button
                    v-if="
                      resendObj &&
                      resendObj.valueBool &&
                      data.item.fees.billID > 0
                    "
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="outline-primary"
                    class="btn-icon mr-1"
                    v-b-tooltip.hover.bottomleft
                    title="Send Slip"
                    @click="
                      sendSlip(data.item.fees.billID, data.item.fees.campusID)
                    "
                    :disabled="sending"
                  >
                    <feather-icon icon="MessageCircleIcon" />
                  </b-button>

                  <b-button
                    v-if="
                      (role.toLowerCase() == 'administrator' ||
                        rights.delete) &&
                      data.item.fees.billID == 0
                    "
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="outline-danger"
                    class="btn-icon mr-1"
                    v-b-tooltip.hover.bottomright
                    :title="$t('Unexempt')"
                    @click="UnExempt(data.item.fees.id)"
                  >
                    <feather-icon icon="XIcon" />
                  </b-button>

                  <b-button
                    v-else-if="
                      (role.toLowerCase() == 'administrator' ||
                        rights.delete) &&
                      data.item.fees.billID > 0
                    "
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="outline-danger"
                    class="btn-icon mr-1"
                    v-b-tooltip.hover.bottomright
                    :title="$t('Cancel')"
                    @click="CancelFee(data.item.fees.billID)"
                  >
                    <feather-icon icon="XIcon" />
                  </b-button>
                </div>
              </template>
            </b-table>
          </b-collapse>
        </b-card>
      </b-col>

      <b-col md="3" style="padding: 0; padding-left: 1.2rem">
        <b-card class="">
          <b-row align-h="end" v-if="!shouldHideSettings">
            <b-col md="2">
              <b-spinner small v-if="loadSetting" />
              <feather-icon
                v-else
                icon="SettingsIcon"
                style="width: 20px; height: 20px; cursor: pointer"
                v-b-tooltip.hover.left
                :title="$t('Settings')"
                @click="openSettings(true)"
              />
            </b-col>
          </b-row>
          <br />
          <div
            class="student-profile-block"
            :class="{
              'student-profile-block--clickable': canOpenStudentProfile,
            }"
            :title="
              canOpenStudentProfile ? $t('View Student\'s Profile') : undefined
            "
            @click="openStudentProfile"
          >
            <b-row align-h="center" v-if="fromGr">
              <b-img
                v-if="myObj.pic == null || myObj.pic == ''"
                src="https://cdn.cloudious.net/file-1677912450367-333289208.png"
                style="
                  width: 70px;
                  height: 70px;
                  object-fit: cover;
                  border-radius: 50%;
                "
              />
              <b-img
                v-else
                :src="myObj.pic"
                style="
                  width: 70px;
                  height: 70px;
                  object-fit: cover;
                  border-radius: 50%;
                "
              />
            </b-row>

            <b-row align-h="center" v-else>
              <b-col md="6">
                <swiper
                  ref="myswiper"
                  class="swiper-navigations"
                  :options="swiperOptions"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  @slideChange="slidechange"
                >
                  <swiper-slide v-for="(data, index) in students" :key="index">
                    <div class="d-flex justify-content-center">
                      <b-img
                        v-if="data.pic"
                        :src="data.pic"
                        fluid
                        style="
                          width: 70px;
                          height: 70px;
                          object-fit: cover;
                          border-radius: 50%;
                        "
                      />
                      <b-img
                        v-else
                        src="https://cdn.cloudious.net/file-1677912450367-333289208.png"
                        fluid
                        style="
                          width: 70px;
                          height: 70px;
                          object-fit: cover;
                          border-radius: 50%;
                        "
                      />
                    </div>
                  </swiper-slide>

                  <div
                    slot="button-next"
                    class="swiper-button-next my-btn"
                    @click.stop
                  />
                  <div
                    slot="button-prev"
                    class="swiper-button-prev my-btn"
                    @click.stop
                  />
                </swiper>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col md="12">
                <h5
                  class="text-center"
                  v-if="
                    ['myskoolpublicschool', 'myskoolbeprince'].includes(
                      reportDomain
                    ) && myObj.id
                  "
                >
                  <b-badge variant="primary"> ID# {{ myObj.id }} </b-badge>
                </h5>
                <h5 class="text-center" v-if="myObj.name">
                  <span class="label">{{ myObj.name }}</span>
                </h5>
                <h5 class="text-center" v-if="myObj.fatherName">
                  <span class="label">F/N: {{ myObj.fatherName }}</span>
                </h5>
                <template v-if="reportDomain == 'myskoolkentschool'">
                  <div class="text-center mb-25">
                    <b-badge variant="light-primary">{{
                      myObj.contact_father || ""
                    }}</b-badge>
                  </div>
                  <div class="text-center">
                    <b-badge variant="light-primary">{{
                      myObj.contact_mother || ""
                    }}</b-badge>
                  </div>
                </template>
                <hr />
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <h5 v-if="myObj.meta_class" class="text-center">
                  <span class="label mb-50"
                    >{{ myObj.meta_class }} - {{ myObj.meta_section }}</span
                  >
                </h5>
                <h5 class="text-center mb-0">
                  <b-badge variant="light-primary">{{ myObj.status }}</b-badge>
                </h5>
                <div v-if="myObj.campusID" class="text-center mt-50">
                  <b-badge variant="light-primary">
                    {{ getCampus(myObj.campusID) }}
                  </b-badge>
                </div>
                <div
                  v-if="reportDomain === 'myskoolaba' && myObj.id"
                  class="text-center mt-50"
                >
                  <div v-if="concessionCategoryLoading">
                    <b-spinner small variant="primary" />
                  </div>
                  <div v-else-if="studentConcessionCategory">
                    <span class="label d-block font-small-3 text-muted mb-25">
                      Concession Category
                    </span>
                    <b-badge variant="light-warning">
                      {{ studentConcessionCategory }}
                    </b-badge>
                  </div>
                </div>
                <hr />
              </b-col>
            </b-row>
          </div>
          <b-row
            v-if="
              reportDomain === 'myskooliuss' && noticeObj && noticeObj.valueBool
            "
          >
            <b-col md="12" class="text-center mb-2">
              <b-badge
                variant="light-primary"
                pill
                class="d-inline-flex align-items-center px-3 py-1"
                style="font-size: 14px; cursor: pointer"
                @click="showFreeshipAlert()"
              >
                <feather-icon
                  icon="InfoIcon"
                  size="16"
                  class="text-primary mr-1"
                />
                <span class="font-weight-bold text-primary">
                  {{ noticeObj.value || "Freeship Challan" }}
                </span>
              </b-badge>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-button
                class="mt-1 btn-icon"
                block
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-primary"
                @click="checkPrint('print')"
                :disabled="iPrint"
              >
                <b-spinner v-if="iPrint" small type="grow" />
                <feather-icon v-if="!iPrint" icon="PrinterIcon" class="mr-50" />
                <span v-if="!iPrint">{{ $t("Print") }}</span>
              </b-button>
            </b-col>
            <b-col md="4" class="pl-md-0">
              <b-button
                class="mt-1 btn-icon"
                block
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-primary"
                :disabled="iMsg"
                @click="checkPrint('whatsapp')"
              >
                <b-spinner v-if="iMsg" small type="grow" />
                <feather-icon v-if="!iMsg" icon="MailIcon" class="" />
              </b-button>
            </b-col>

            <!-- Notification Button -->
            <b-col md="4" class="pl-md-0">
              <b-button
                class="mt-1 btn-icon"
                block
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-primary"
                :disabled="iNotification"
                @click="checkPrint('notification')"
              >
                <b-spinner v-if="iNotification" small type="grow" />
                <feather-icon v-if="!iNotification" icon="BellIcon" class="" />
              </b-button>
            </b-col>
          </b-row>
          <br />
          <div style="background-color: none; padding: 15px 0px">
            <!-- label="Total dues" -->
            <b-form-group :invalid-feedback="$t('Total is required')">
              <div class="d-flex justify-content-between pb-50">
                <label class="bv-no-focus-ring col-form-label p-0">{{
                  $t("Total dues")
                }}</label>
              </div>
              <b-form-input
                disabled
                v-model="total"
                class="form-control"
                :placeholder="$t('Total dues')"
              />
            </b-form-group>

            <b-form-group
              v-if="false"
              label="Late fee"
              invalid-feedback="Late fee is required."
              ref="late"
            >
              <b-form-input
                disabled
                type="number"
                v-model="lateFee"
                placeholder="Enter late fee"
                no-wheel
              />
            </b-form-group>

            <b-form-group
              :label="$t('Receiving amount')"
              :invalid-feedback="$t('Invalid amount entered')"
            >
              <b-form-input
                ref="paid"
                type="number"
                v-model="paid"
                @input="getBalance()"
                class="form-control"
                :placeholder="$t('Receiving amount')"
                no-wheel
              />
            </b-form-group>
            <b-form-group
              :label="$t('Balance')"
              :invalid-feedback="$t('Balance is required')"
            >
              <b-form-input
                disabled
                v-model="balance"
                class="form-control"
                :placeholder="$t('Balance')"
                ref="fCode"
              />
            </b-form-group>

            <!-- label="After Timely Discount" -->
            <b-form-group
              v-if="
                (dueDateToShow && discountToShow > 0) ||
                (annualDueDate &&
                  (annualTimelyDiscount > 0 || annualAdvanceDiscount > 0))
              "
              :invalid-feedback="$t('timely discount is required')"
              ref="dis"
            >
              <div
                class="d-flex justify-content-between align-items-start pb-50"
              >
                <label class="bv-no-focus-ring col-form-label p-0"
                  >{{ $t("After Timely Dis") }} (Rs.{{ disAmount }})</label
                >
                <b-badge variant="primary" pill class="cursor-pointer">
                  {{
                    new Date(dueDateToShow).toLocaleDateString("en-UK", {
                      year: "numeric",
                      day: "numeric",
                      month: "short",
                    })
                  }}
                </b-badge>
              </div>
              <b-form-input
                disabled
                type="number"
                v-model="afterDis"
                :placeholder="$t('Enter timely discount')"
              />
            </b-form-group>

            <b-form-group
              :invalid-feedback="$t('Collection account is required')"
              ref="acc"
            >
              <div class="d-flex justify-content-between">
                <label class="bv-no-focus-ring col-form-label pt-0">{{
                  $t("Collection Account")
                }}</label>
                <feather-icon
                  v-if="rights.add"
                  class="cursor-pointer"
                  icon="BriefcaseIcon"
                  size="20"
                  v-b-tooltip.hover.top
                  :title="$t('Accounts')"
                  @click="openAccount()"
                />
              </div>
              <v-select
                v-model="accountType"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="accTypes"
                :reduce="(opt) => opt.id"
                label="account"
                :clearable="false"
                ref="acc"
                :placeholder="$t('Select account type')"
                @input="setAccount()"
                @search:blur="checkRecAccount()"
              />
            </b-form-group>
            <b-form-group
              :label="$t('Receiving Date')"
              :invalid-feedback="$t('receiving date is required')"
              ref="rcvDate"
            >
              <flat-pickr
                ref="rcvDate"
                :config="receiveConfig"
                v-model="receiveObj.rcvDate"
                class="form-control"
                :placeholder="$t('Select Date')"
                :disabled="
                  (!rights.add && !rights.edit) ||
                  rights.disableDate ||
                  (backDtObj && backDtObj.valueBool)
                "
                @on-change="checkDate()"
              />
            </b-form-group>

            <b-form-checkbox
              v-if="lateObj && lateObj.valueBool"
              v-model="withLate"
            >
              <span class="bv-no-focus-ring col-form-label p-0">
                {{ $t("Receive with Late Fee") }}
              </span>
            </b-form-checkbox>

            <template v-if="chDetails && chDetails.valueBool">
              <b-form-group :invalid-feedback="$t('Organization is required')">
                <div class="d-flex justify-content-between">
                  <label class="bv-no-focus-ring col-form-label pt-0">{{
                    $t("Organization")
                  }}</label>
                  <feather-icon
                    v-if="rights.add"
                    class="cursor-pointer"
                    icon="EditIcon"
                    size="20"
                    v-b-tooltip.hover.top
                    :title="$t('Organization')"
                    @click="openOrg()"
                  />
                </div>
                <v-select
                  v-model="otherObj.organization"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="[{ id: 0, title: 'None' }, ...orgList]"
                  :reduce="(opt) => opt.id"
                  label="title"
                  :clearable="false"
                  :placeholder="$t('Select organization')"
                />
              </b-form-group>
              <b-form-group
                :label="$t('Bank Name')"
                :invalid-feedback="$t('Bank Name is required')"
              >
                <b-form-input
                  v-model="otherObj.bank"
                  :placeholder="$t('Enter bank name')"
                />
              </b-form-group>
              <b-form-group
                :label="$t('Cheque No')"
                :invalid-feedback="$t('Cheque No is required')"
              >
                <b-form-input
                  v-model="otherObj.cheque"
                  :placeholder="$t('Enter cheque number')"
                />
              </b-form-group>
            </template>

            <b-form-group
              v-if="reportDomain === 'myskoolhpgs'"
              :label="$t('Receipt No')"
              :invalid-feedback="$t('Receipt No is required')"
              ref="rcptNo"
            >
              <b-form-input
                type="number"
                v-model="receiveObj.barcode"
                :placeholder="$t('Enter receipt number')"
                no-wheel
              />
            </b-form-group>

            <b-form-group
              :label="$t('Note')"
              :invalid-feedback="$t('Note is required')"
              ref="rec_note"
            >
              <b-form-textarea
                :placeholder="$t('Enter note')"
                rows="3"
                v-model.trim="receiveObj.receiveNote"
              />
            </b-form-group>

            <b-button
              class="mt-1"
              block
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              :disabled="
                receiving ||
                dataLoading ||
                gridLoading ||
                rights.disableReceiving ||
                (!rights.add && !rights.receiveFee) ||
                isLeftStd
              "
              @click="receiveFee('normal')"
            >
              <b-spinner v-if="receiving" small type="grow" />
              <span v-else class="align-middle">{{ $t("Receive") }}</span>
            </b-button>
          </div>
        </b-card>
      </b-col>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BCollapse,
  BCarouselSlide,
  BCarousel,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BLink,
  BBadge,
  BImg,
  VBTooltip,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormGroup,
  BForm,
  BContainer,
  BMediaAside,
  BSpinner,
  BSidebar,
  VBToggle,
  BInputGroupPrepend,
  BInputGroup,
  BFormTextarea,
  BAvatar,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import AccountBranch from "@/views/myskool/components/AccountBranch.vue";
import flatPickr from "vue-flatpickr-component";
import { TheMask } from "vue-the-mask";
import { mapActions, mapGetters } from "vuex";
import roleCoaAccessMixin from "@/mixins/roleCoaAccessMixin";
import { syncAccountCoaRestrictionsToStore } from "@/utils/roleCoaAccess";
import swiper from "swiper";
import readXlsxFile from "read-excel-file";
import * as XLSX from "xlsx";
import axios from "axios";

export default {
  mixins: [roleCoaAccessMixin],
  components: {
    BFormTextarea,
    Swiper,
    SwiperSlide,
    BCarouselSlide,
    BCarousel,
    BCollapse,
    TheMask,
    BInputGroup,
    BCard,
    BRow,
    BBadge,
    BTable,
    BCol,
    BAvatar,
    BFormInput,
    BButton,
    BSidebar,
    BFormGroup,
    BInputGroupPrepend,
    BSpinner,
    BFormCheckbox,
    BFormCheckboxGroup,
    BForm,
    BContainer,
    //BCardTitle,
    //BCardText,
    BMediaAside,
    BImg,
    BMedia,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    //BPagination,
    vSelect,
    flatPickr,
    AccountBranch,
  },
  directives: {
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
    Ripple,
  },
  mounted() {
    window.addEventListener("keydown", this.handleEvent);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleEvent);
  },
  async created() {
    syncAccountCoaRestrictionsToStore(
      this.$store,
      this.$store.state.loggedUser?.forms
    );
    const priorRights = { ...(this.$store.state.rights || {}) };
    let right = {};
    this.$store.state.menu.forEach((el) => {
      el.children.forEach((ch) => {
        right[ch.route] = {
          view: ch.view,
          add: ch.add,
          edit: ch.edit,
          delete: ch.delete,
          hideFee: ch.hideFee, // to hide fee history
          disableDate: ch.disableDate,
          receiveFee: ch.receiveFee,
          disableReceiving: ch.disableReceiving,
          editDate: ch.editDate, // to edit receiving date
          coaAccountIDs: ch.coaAccountIDs ||
            priorRights[ch.route]?.coaAccountIDs || [0],
        };
      });
    });
    // console.log(right);
    this.$store.commit("setRights", { ...priorRights, ...right });

    if (!this.$store.state.rights[this.$route.name]) {
      this.$router.replace({
        name: "misc-not-authorized",
      });
    } else {
      this.rights = this.$store.state.rights[this.$route.name];
      // if (
      //   !this.receiveObj.rcvDate ||
      //   this.role.toLowerCase() !== "administrator" ||
      //   this.dateFor.includes(this.$store.state.clientID)
      // ) {
      //   this.receiveObj.rcvDate = new Date().toJSON();
      //   // console.log(this.receiveObj.rcvDate);
      //   this.$store.commit("setDate", this.receiveObj.rcvDate);
      //   this.challanObj.rcvDate = this.receiveObj.rcvDate;
      // }

      this.fetchTime();

      this.LoadFeeType();
      if (this.reportDomain === "myskooliuss") this.LoadCollectionLinks();
      this.loadSubSetting();
      this.loadCOA();
      this.LoadSettingsAll();
      this.LoadUsers();
      await this.openSettings(false);
      this.LoadCampuses();

      this.applyRouteStudentSearch();

      this.showExDate = this.reportDomain === "myskoolhpgs";
    }
  },
  computed: {
    filters: function () {
      return this.items.filter((pro) => {
        return pro.name.toLowerCase().match(this.searchQuery.toLowerCase());
      });
    },
    searchData: function () {
      return this.studentData.filter((pro) => {
        return pro.name.toLowerCase().match(this.filterData.toLowerCase());
      });
    },
    computedFields() {
      if (this.lateFee > 0 && this.timelyDiscount > 0) return this.fieldsBoth;
      else if (this.lateFee > 0) return this.fieldsLate;
      else if (this.timelyDiscount > 0) return this.fieldsDiscount;
      else return this.fields;
    },
    disAmount() {
      let amount = 0;
      if (new Date(this.receiveObj.rcvDate) <= new Date(this.dueDateToShow)) {
        amount = this.discountToShow;
      } else amount = this.advanceToShow;

      if (new Date(this.receiveObj.rcvDate) <= new Date(this.annualDueDate)) {
        amount += this.annualTimelyDiscount;
      } else amount += this.annualAdvanceDiscount;

      return amount;
    },
    afterDis() {
      return this.total - this.disAmount;
      // if (new Date(this.receiveObj.rcvDate) <= new Date(this.dueDateToShow)) {
      //   return this.total - this.discountToShow;
      // } else return this.total - this.advanceToShow;
    },
    shouldHideSettings() {
      return this.hideSettings
        ? this.hideSettings.valueBool &&
            this.role.toLowerCase() != "administrator"
        : false;
    },
    /** Setting from getSettingsAll key `custom_fees_date` — show Apply custom fee dates */
    isCustomFeesDateEnabled() {
      const s = this.customFeesDateSetting;
      if (!s || s.key !== "custom_fees_date") return false;
      if (s.valueBool === true || s.valueBool === 1) return true;
      if (typeof s.valueBool === "string") {
        const t = s.valueBool.toLowerCase().trim();
        return t === "true" || t === "1";
      }
      return false;
    },
    studentGridRights() {
      return this.$store.state.rights["manage-studentgrid"] || {};
    },
    canOpenStudentProfile() {
      return !!(
        this.myObj?.id &&
        (this.studentGridRights.view || this.studentGridRights.edit)
      );
    },
    /** Selected fee rows → labels for custom-dates modal (fee type + month/year) */
    customFeesDateSelectedDescriptors() {
      const ids = this.receiveObj?.feesIDs || [];
      const out = [];
      if (!Array.isArray(ids) || !ids.length) return out;

      const findRow = (fid) =>
        (this.items &&
          this.items.find(
            (it) => it.fees && Number(it.fees.id) === Number(fid)
          )) ||
        (this.selectedRows &&
          this.selectedRows.find(
            (it) => it.fees && Number(it.fees.id) === Number(fid)
          ));

      ids.forEach((fid) => {
        const row = findRow(fid);
        if (!row) {
          out.push({
            feeName: this.$t("Fee"),
            period: `#${fid}`,
            fid,
            badgeLabel: `${this.$t("Fee")} #${fid}`,
          });
          return;
        }
        const feeName =
          row.feesType?.feeType ||
          row.fees?.feeTypeName ||
          row.fees?.feeType ||
          this.$t("Fee");
        const period = (row.fees?.monthYear || "").trim();
        const badgeLabel = period ? `${feeName} ${period}` : feeName;
        out.push({ feeName, period, fid, badgeLabel });
      });
      return out;
    },
    /** True when LoadData returned an existing saved custom-dates row */
    customFeesDateHasSavedRecord() {
      const r = this.customFeesDateLoadedRecord;
      return !!(r && r.id);
    },
    receiveConfig() {
      let obj = { ...this.config };
      if (this.shouldHideSettings) {
        obj.minDate = this.settings.issueDate || "today";
        // if receive date is before issue date, set issue date
        const issueDate = new Date(this.settings.issueDate);
        if (
          new Date(this.receiveObj.rcvDate) <= issueDate &&
          this.settings.issueDate
        ) {
          this.receiveObj.rcvDate = this.settings.issueDate;
          this.challanObj.rcvDate = this.receiveObj.rcvDate;
          this.$store.commit("setDate", this.receiveObj.rcvDate);
        }
        if (this.settings.expiryDate) {
          const expiryDate = new Date(this.settings.expiryDate);
          if (issueDate <= expiryDate) {
            obj.maxDate = this.settings.expiryDate;
          }
        }
      }
      return obj;
    },
    isLeftStd: function () {
      if (this.reportDomain == "myskoolalhameed") {
        return this.fromGr
          ? this.myObj?.status?.toLowerCase() == "left"
          : this.students.find((el) => el.status?.toLowerCase() == "left");
      } else false;
    },
  },
  data() {
    let yList = [];
    for (let i = 2015; i <= 2050; i++) {
      yList.push(i);
    }
    return {
      idVisible: [],
      searchType: "grNo",
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      studentConcessionCategory: "",
      concessionCategoryLoading: false,
      iFamily: false,
      iMsg: false,
      iNotification: false,
      iPrint: false,
      check: 1,
      fromShortcut: false,
      slipShortcut: false,
      swiperOptions: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      rights: {},
      showAll: false,
      role: this.$store.state.userData.roles,
      contacterror: false,
      mydocloading: false,
      docsloading: "Upload",
      students: [],
      request: false,
      showDiscount: false,
      disObj: {
        feesID: 0,
        discountAmount: null,
        userID: this.$store.state.userData.userID,
        timelyDiscount: 0,
      },
      currentBalance: 0,
      netBalance: 0,

      instObj: {
        feeID: 0,
        amount: null,
        campusID: this.$store.state.userData.cId,
      },
      instCurrent: 0,
      visibility2: false,

      auto: false,
      fromChallan: false,
      challanObj: {
        challanNo: 0,
        amount: 0,
        rcvDate: this.$store.state.date,
        userID: this.$store.state.userData.userID,
        campusID: this.$store.state.userData.cId,
        feesIDs: [],
        accountID: this.$store.state.accountType,
      },

      receiveObj: {
        grNo: "",
        familyCode: 0,
        amount: 0,
        rcvDate: this.$store.state.date,
        userID: this.$store.state.userData.userID,
        campusID: this.$store.state.userData.cId,
        feesIDs: [],
        accountID: this.$store.state.accountType,
        receiveNote: "",
        barcode: 0,
      },
      receiving: false,
      colorDep: [],
      visibility1: false,

      sidebarTitle: "Search",
      sidebarButton: "Save",
      visibility: false,
      dataLoading: false,
      gridLoading: false,
      studentLoading: false,
      saving: false,
      searchQuery: "",
      searchFather: "",
      searchStatus: "present",
      fSearch: this.$store.state.feeSearch,
      statusOptions: [
        { text: "All", value: "" },
        { text: "Present", value: "present" },
        { text: "Registered", value: "registered" },
        { text: "Left", value: "left" },
      ],
      currentPage: 1,
      totalRows: 0,
      filterData: "",
      studentData: [],
      date: {
        range: "",
      },
      index: null,
      cover: "",

      fields: [
        // '-',
        { label: "gr", key: "gr" },
        { label: "Name", key: "name" },
        { label: "class", key: "class" },
        { label: "fee type", key: "feeType" },
        { label: "details", key: "monthYear" },
        { label: "balance", key: "balance" },
        { label: "hold reason", key: "holdReason" },
        { key: "actions", label: "actions" },
      ],
      fieldsLate: [
        { label: "gr", key: "gr" },
        { label: "Name", key: "name" },
        { label: "class", key: "class" },
        { label: "fee type", key: "feeType" },
        { label: "details", key: "monthYear" },
        { label: "late fee", key: "lateFee" },
        { label: "balance", key: "balance" },
        { label: "hold reason", key: "holdReason" },
        { key: "actions", label: "actions" },
      ],
      fieldsDiscount: [
        { label: "gr", key: "gr" },
        { label: "Name", key: "name" },
        { label: "class", key: "class" },
        { label: "fee type", key: "feeType" },
        { label: "details", key: "monthYear" },
        { label: "timely discount", key: "timelyDiscount" },
        { label: "balance", key: "balance" },
        { label: "hold reason", key: "holdReason" },
        { key: "actions", label: "actions" },
      ],
      fieldsBoth: [
        { label: "gr", key: "gr" },
        { label: "Name", key: "name" },
        { label: "class", key: "class" },
        { label: "fee type", key: "feeType" },
        { label: "details", key: "monthYear" },
        { label: "late fee", key: "lateFee" },
        { label: "timely discount", key: "timelyDiscount" },
        { label: "balance", key: "balance" },
        { label: "hold reason", key: "holdReason" },
        { key: "actions", label: "actions" },
      ],
      historyLoading: false,
      hisFields: [
        { label: "Slip No#", key: "billID" },
        { label: "fee type", key: "feeType" },
        { label: "Class", key: "class" },
        { label: "details", key: "monthYear" },
        { label: "discount", key: "discount" },
        { label: "total", key: "rcvd" },
        { label: "receiving date", key: "rcvdDate" },
        { label: "received by", key: "rcvdBy" },
        { key: "actions", label: "actions" },
      ],

      fields2: ["student"], //{ label: "picture", key: "picture" },
      items: [],
      history: [],
      selected: null,
      allSelect: false,
      filterOptions: [
        { text: "Most sold product", value: "mostSold" },
        { text: "Least sold product", value: "leastSold" },
        { text: "Most popular product", value: "mostPopular" },
        { text: "Least popular product", value: "leastPopular" },
        { text: "Most profitable product", value: "mostProfitable" },
      ],
      attachList: [],
      loadSetting: false,
      showSettings: false,
      settingOptions: ["Yes", "No"],
      settings: {
        id: 0,
        campusID: this.$store.state.userData.cId,
        issueDate: null,
        dueDate: null,
        expiryDate: null,
        lateFee: 0,
        timelyDiscount: 0,
        printSlip: false,
        sendSMS: false,
        instructions: "",
        bankName: "",
        accountNumber: "",
        printBy: "",
        titleOfAccount: "",
      },
      printOptions: [
        {
          text: "Student",
          value: "student",
        },
        {
          text: "Family",
          value: "family",
        },
      ],
      lateFee: 0,
      timelyDiscount: 0,

      myObj: {
        grNo: null,
        familyCode: null,
        challanNo: null,
        id: 0,
      },
      detailObj: {},
      avatarURL:
        "https://raw.githubusercontent.com/Ashwinvalento/cartoon-avatar/master/lib/images/female/110.png",
      createForm: false,
      allfeeType: [],
      campusFeeType: [],
      linkedAccounts: [],
      linkObj: null,
      accTypes: [],
      accountType: null,
      collection: {
        sID: 0,
        year: 0,
        userID: this.$store.state.userData.userID,
        feesTypeIDs: [],
        months: [],
        onBehalf: 0,
      },
      months: [
        {
          id: 1,
          name: "Jan",
        },
        {
          id: 2,
          name: "Feb",
        },
        {
          id: 3,
          name: "Mar",
        },
        {
          id: 4,
          name: "Apr",
        },
        {
          id: 5,
          name: "May",
        },
        {
          id: 6,
          name: "Jun",
        },
        {
          id: 7,
          name: "Jul",
        },
        {
          id: 8,
          name: "Aug",
        },
        {
          id: 9,
          name: "Sep",
        },
        {
          id: 10,
          name: "Oct",
        },
        {
          id: 11,
          name: "Nov",
        },
        {
          id: 12,
          name: "Dec",
        },
      ],
      years: yList,
      sendChallan: false,
      total: null,
      balance: null,
      paid: null,
      discountToShow: 0,
      advanceToShow: 0,
      dueDateToShow: null,
      annualDueDate: null,
      annualAdvanceDiscount: 0,
      annualTimelyDiscount: 0,
      leftDues: 0,
      config: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      config2: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
        mode: "range",
      },
      fromGr: true,
      fromFamily: false,
      accountObj: {
        id: 0,
        campusID: this.$store.state.userData.cId,
        account: "",
        status: "active",
        accountID: 0,
      },
      accIcon: "",
      accountbar: false,
      addingAcc: false,
      savingacc: false,
      accFields: [
        { label: "Name", key: "account" },
        { key: "actions", label: "actions" },
      ],

      lastChanged: null,
      commitObj: {},
      visibility3: false,
      pSaving: false,
      unholding: false,
      historyObj: {
        dtFrom: null,
        dtTo: null,
      },
      hisOpen: false,
      hisPrinting: false,
      rangeDate: null,
      subObj: null,
      prevLedgObj: null,
      chDetails: null,
      schGr: null,
      showMother: null,
      showAllLate: false,
      showOnBehalf: false,
      toPrint: [],
      entryObj: null,
      coAccounts: [],
      dateFor: ["myskool_aims", "myskool_aims_c2"],
      noticeObj: null,
      cHeadObj: null,
      taxObj: null,
      hideSettings: null,
      customFeesDateSetting: null,
      customFeesDateForm: {
        issueDate: null,
        dueDate: null,
        expiryDate: null,
      },
      /** Row from GET CustomFeesDate/LoadData for current fee selection */
      customFeesDateLoadedRecord: null,
      loadingCustomFeesDateLoad: false,
      loadingCustomFeesDateModal: false,
      removingCustomFeesDate: false,
      savingCustomFeesDate: false,
      annualObj: null,
      lateObj: null,
      backDtObj: null,
      isHeadOffice: null,
      withLate: false,
      importing: false,
      uploadSettings: {
        dateColumn: "TRANS.DATE",
        amountColumn: "AMOUNT",
        challanColumn: "Challan/C-ID",
        barcodeColumn: "BR.CODE",
      },
      savingSettings: false,
      showUpload: false,
      uploadObj: {},
      uploadedData: [],
      savingUpload: false,
      errorData: [],
      recLoading: false,
      receiptFields: [
        { label: "gr", key: "gr" },
        { label: "Name", key: "name" },
        { label: "class", key: "class" },
        { label: "Feetype", key: "feeType" },
        { label: "details", key: "monthYear" },
        { label: "balance", key: "balance" },
        // { key: "actions", label: "actions" },
      ],
      receiptData: [],
      validating: false,
      validData: [],
      slipObj: {
        from: "",
        till: "",
      },
      printingSlip: false,
      slipNo: null,
      showLedg: false,
      orgList: [],
      visibility4: false,
      orgFields: [
        { label: "Name", key: "title" },
        { key: "actions", label: "actions" },
      ],
      otherObj: {
        organization: 0,
        bank: "",
        cheque: "",
      },
      orgObj: {},
      savingOrg: false,
      sending: false,
      allUsers: [],
      exempting: false,
      exObj: {},
      showExDate: false,
      campuses: [],
      modalTitle: "Account Branches",
      branchItems: [],
      branchFields: [
        { label: "name", key: "branch" },
        { label: "campuses", key: "campuses" },
        { label: "actions", key: "actions" },
      ],
      branchLoading: false,
      branchObj: {
        id: 0,
        accountID: 0,
        campusID: 0,
        branch: "",
        accountNumber: "",
        linkedCampuses: "",
      },
      selectedCamp: [],
      currentAccount: {},
      branchForm: false,
      savingBranch: false,
      currLedgObj: null,
      seqObj: null,
      ledgLoading: false,
      selectedRows: [], // Track row selection in order
      editRcvDate: null,
      isEditDateModalVisible: false,
      editFee: null,
      isUpdatingDate: false,
      holdReasonModalVisible: false,
      holdReasonModalText: "",
      holdReasonModalStudent: "",
      holdReasonModalClassSection: "",
      holdReasonModalHoldTill: null,
      partialObj: null,
      partialPerc: 100,
      partialrequest: false,
      secondDueDate: null,
      accObj: null,
      accIDs: [],
      approvalList: [],
      reqObj: {
        id: 0,
        sID: 0,
        request_date: null,
        reason: "",
        leaving_date: null,
        note: "",
        document: "",
        status: "pending",
        requested_by: 0,
        campusID: 0,
        type: "remove-fee",
        approved_by: 0,
        approved_document: "",
        entityID: 0,
        meta_data: "",
      },
      savingReq: false,
      pendingFeeRequest: [],
      resendObj: null,
    };
  },
  methods: {
    ...mapActions({
      get: "get",
      post: "post",
      postObj: "postObj",
      put: "put",
      delete: "delete",
    }),

    async loadLedger() {
      if (!this.myObj.id) {
        this.$bvToast.toast(this.$t("Please select a student first"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        this.ledgLoading = true;
        var status = await this.post({
          url:
            this.$store.state.domain +
            "studentLedger/syncLedger?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.myObj.campusID +
            "&sID=" +
            this.myObj.id,
          context: this,
          importing: true,
          token: this.$store.state.userData.token,
        });
        this.ledgLoading = false;

        if (status) {
          var url =
            `https://${this.reportDomain}.myskool.app/Account/StudentLedger?dbb=` +
            this.$store.state.userData.db +
            "&cID=" +
            this.myObj.campusID +
            "&sID=" +
            this.myObj.id;

          window.open(url, "_blank");
        }
      }
    },

    getCampus(id) {
      let obj = this.campuses.find((el) => el.id == id);
      return obj ? obj.branch : "";
    },
    async LoadCampuses() {
      var obj = {
        url:
          this.$store.state.domain +
          "campuses?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.campuses = await this.get(obj);
    },

    async fetchTime() {
      var obj = {
        url: this.$store.state.domain + "Fees/GetDate",
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj);

      // console.log(res);
      if (res && !Array.isArray(res)) {
        this.receiveObj.rcvDate = res;
        this.$store.commit("setDate", this.receiveObj.rcvDate);
        this.challanObj.rcvDate = this.receiveObj.rcvDate;
      } else {
        this.receiveObj.rcvDate = new Date().toJSON();
        this.$store.commit("setDate", this.receiveObj.rcvDate);
        this.challanObj.rcvDate = this.receiveObj.rcvDate;
      }

      // axios
      //   .get("https://worldtimeapi.org/api/timezone/Asia/Karachi")
      //   .then((response) => {
      //     // console.log(response.data);
      //     let date = response.data.datetime;
      //     this.receiveObj.rcvDate = date;
      //     this.$store.commit("setDate", this.receiveObj.rcvDate);
      //     this.challanObj.rcvDate = this.receiveObj.rcvDate;
      //     // console.log(this.receiveObj.rcvDate);
      //   })
      //   .catch((error) => {
      //     console.log("Error fetching time:", error);
      //     this.receiveObj.rcvDate = new Date().toJSON();
      //     this.$store.commit("setDate", this.receiveObj.rcvDate);
      //     this.challanObj.rcvDate = this.receiveObj.rcvDate;
      //     // console.log(this.receiveObj.rcvDate);
      //   });
    },
    checkLedger() {
      if (this.myObj.gr != null && this.myObj.gr != "" && this.myObj.doc) {
        let att = this.myObj.doc.split(",");
        let dd = att.find((el) =>
          el.toLowerCase().includes(`ledger_${this.myObj.gr}`)
        );
        // console.log(dd);
        this.showLedg = dd ? true : false;
      } else {
        // console.log("not");
        this.showLedg = false;
      }
    },
    openLedger() {
      let url = `https://cdn.cloudious.net/${this.prevLedgObj.value}/ledger_${this.myObj.gr}.pdf`;
      // Create a full-page iframe
      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.top = "0";
      iframe.style.left = "0";
      iframe.style.width = "100%";
      iframe.style.height = "100%";
      iframe.style.border = "none";
      iframe.style.zIndex = "1000000"; // Increased z-index
      iframe.src = url + "#toolbar=1&navpanes=1"; // Enable PDF toolbar and sidebar
      // Create a close button
      const closeButton = document.createElement("button");
      closeButton.innerHTML = "&times;";
      closeButton.style.position = "fixed";
      closeButton.style.top = "10px";
      closeButton.style.right = "10px";
      closeButton.style.fontSize = "24px";
      closeButton.style.background = "white";
      closeButton.style.border = "none";
      closeButton.style.borderRadius = "50%";
      closeButton.style.width = "30px";
      closeButton.style.height = "30px";
      closeButton.style.cursor = "pointer";
      closeButton.style.zIndex = "1000001"; // Ensure close button is above iframe
      // Add click event to close button
      closeButton.onclick = () => {
        document.body.removeChild(iframe);
        document.body.removeChild(closeButton);
      };
      // Add iframe and close button to the body
      document.body.appendChild(iframe);
      document.body.appendChild(closeButton);
    },

    async upload() {
      this.importing = true;
      const input = this.$refs.fileProfile.files[0];
      await readXlsxFile(input)
        .then((rows) => {
          // console.log(rows);
          const ind1 = rows.findIndex(
            (el) => el[0] == "TUITION" || el[0] == "tuition"
          );
          // console.log(ind1);
          const ind2 = rows.findIndex(
            (el) => el[0] == "TRANSPORT" || el[0] == "transport"
          );
          // console.log(ind2);
          let dataset1 = rows.slice(ind1, ind2);
          let dataset2 = rows.slice(ind2);
          // console.log(dataset1, dataset2);
          const data1 = dataset1.slice(2).reduce((result, el) => {
            if (el[1] && el[2] && el[3] && el[4]) {
              result.push({
                date: el[1],
                amount: el[2],
                challan: el[3],
                barcode: el[4],
              });
            }
            return result;
          }, []);
          console.log(data1);
          const data2 = dataset2.slice(2).reduce((result, el) => {
            if (el[1] && el[2] && el[3] && el[4]) {
              result.push({
                date: el[1],
                amount: el[2],
                challan: el[3],
                barcode: el[4],
              });
            }
            return result;
          }, []);
          console.log(data2);
          this.importing = false;
          if (data1.length == 0 && data2.length == 0) {
            this.$bvToast.toast(this.$t("No record found!"), {
              title: this.$t("Error!"),
              variant: "danger",
              toaster: "b-toaster-top-center",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.importing = false;
        });

      // const schema = {
      //   [this.uploadSettings.dateColumn]: {
      //     prop: "date",
      //     type: String,
      //   },
      //   [this.uploadSettings.amountColumn]: {
      //     prop: "amount",
      //     type: Number,
      //   },
      //   [this.uploadSettings.challanColumn]: {
      //     prop: "challan",
      //     type: Number,
      //   },
      //   [this.uploadSettings.barcodeColumn]: {
      //     prop: "barcode",
      //     type: Number,
      //   },
      // };

      // const input = this.$refs.fileProfile.files[0];
      // await readXlsxFile(input, { schema })
      //   .then((rows) => {
      //     // console.log(rows);
      //     let res = rows.rows;
      //     let formatted = res.filter((el) => el.challan || el.barcode);
      //     console.log(formatted);
      //     this.importing = false;
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //     this.importing = false;
      //   });
    },

    async uploadOther() {
      this.importing = true;
      const input = this.$refs.fileProfile.files[0];
      const schema = {
        "Payment Date": {
          prop: "date",
          // type: (value) => {
          //   return new Date(value).toJSON();
          // },
          type: (value) => {
            console.log(value);
            const parts = value.split("/");
            const day = parts[0];
            const month = parts[1];
            const year = parts[2];

            const formattedDate = `${year}-${month.padStart(
              2,
              "0"
            )}-${day.padStart(2, "0")}`;

            return formattedDate;
          },
        },
        "Total Fee Paid": {
          prop: "amount",
          // type: Number,
          type: (value) => {
            let res = value
              .toString()
              .toLowerCase()
              .replace(/\b(rs|pkr|rs.)\b/g, "")
              .trim();
            return parseInt(res);
          },
        },
        "C-ID": {
          prop: "sID",
          type: Number,
        },
      };

      await readXlsxFile(input, { schema })
        .then((rows) => {
          // console.log(rows);
          this.uploadedData = rows.rows.filter(
            (el) => el.date && el.amount >= 0 && el.sID
          );
          console.log(this.uploadedData);
          this.importing = false;
          if (this.uploadedData.length == 0) {
            this.$bvToast.toast(this.$t("No record found!"), {
              title: this.$t("Error!"),
              variant: "danger",
              toaster: "b-toaster-top-center",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.importing = false;
        });
    },

    async uploadNew() {
      this.importing = true;
      const input = this.$refs.fileProfile.files[0];
      const schema = {
        Date: {
          prop: "date",
          type: Date,
        },
        Amount: {
          prop: "amount",
          type: Number,
          // type: (value) => {
          //   let res = value
          //     .toString()
          //     .toLowerCase()
          //     .replace(/\b(rs|pkr|rs.)\b/g, "")
          //     .trim();
          //   return parseInt(res);
          // },
        },
        "C-ID": {
          prop: "sID",
          type: String,
        },
      };

      await readXlsxFile(input, { schema })
        .then((rows) => {
          // console.log(rows);
          this.uploadedData = rows.rows.filter(
            (el) => el.date && el.amount > 0 && el.sID
          );
          console.log(this.uploadedData);

          if (this.uploadedData.length == 0) {
            this.$bvToast.toast(this.$t("No record found!"), {
              title: this.$t("Error!"),
              variant: "danger",
              toaster: "b-toaster-top-center",
            });
            this.importing = false;
            this.errorData = [];
          } else this.verifyData();
        })
        .catch((err) => {
          console.log(err);
          this.importing = false;
        });
    },

    async verifyData() {
      if (this.uploadObj.accountID == 0) {
        this.$bvToast.toast(this.$t("Please select collection account."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        this.importing = false;
      } else {
        var status = await this.post({
          url:
            this.$store.state.domain +
            "Fees/PostBankFeeVerify?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&accID=" +
            this.uploadObj.accountID +
            "&isTransport=" +
            this.uploadObj.isTransport +
            "&userID=" +
            this.$store.state.userData.userID,
          body: this.uploadedData,
          context: this,
          token: this.$store.state.userData.token,
          upload: true,
        });
        if (status == true) {
          this.errorData = [];
          this.saveUpload();
        } else if (Array.isArray(status)) {
          this.errorData = status;
          const expData = this.errorData.map((item) => ({
            Date: item.date,
            Amount: item.amount,
            "C-ID": item.sID,
            Note: item.note,
          }));
          const worksheet = XLSX.utils.json_to_sheet(expData);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
          XLSX.writeFile(workbook, "Errors.xlsx");
          this.importing = false;
        }
      }
    },
    async saveUpload() {
      // console.log(this.uploadedData);
      // this.savingUpload = true;
      var status = await this.post({
        url:
          this.$store.state.domain +
          "Fees/PostBankFee?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&accID=" +
          this.uploadObj.accountID +
          "&isTransport=" +
          this.uploadObj.isTransport +
          "&userID=" +
          this.$store.state.userData.userID,
        body: this.uploadedData,
        message: "Data saved successfully",
        context: this,
        token: this.$store.state.userData.token,
      });
      // this.savingUpload = false;
      this.importing = false;
      if (status) {
        this.showUpload = false;
        this.uploadedData = [];
      }
    },

    async uploadValidate() {
      this.validating = true;
      const input = this.$refs.validProfile.files[0];
      const schema = {
        Date: {
          prop: "date",
          type: Date,
        },
        Amount: {
          prop: "amount",
          type: Number,
        },
        "C-ID": {
          prop: "sID",
          type: String,
        },
      };

      await readXlsxFile(input, { schema })
        .then((rows) => {
          // console.log(rows);
          this.validData = rows.rows.filter(
            (el) => el.date && el.amount > 0 && el.sID
          );
          console.log(this.validData);

          if (this.validData.length == 0) {
            this.$bvToast.toast(this.$t("No record found!"), {
              title: this.$t("Error!"),
              variant: "danger",
              toaster: "b-toaster-top-center",
            });
            this.validating = false;
          } else this.checkFile();
        })
        .catch((err) => {
          console.log(err);
          this.validating = false;
        });
    },

    async checkFile() {
      if (this.uploadObj.accountID == 0) {
        this.$bvToast.toast("Please select collection account.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        this.validating = false;
      } else {
        var status = await this.post({
          url:
            this.$store.state.domain +
            "Fees/ValidateFile?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&accID=" +
            this.uploadObj.accountID +
            "&isTransport=" +
            this.uploadObj.isTransport +
            "&userID=" +
            this.$store.state.userData.userID,
          body: this.validData,
          context: this,
          token: this.$store.state.userData.token,
          validation: true,
        });
        if (Array.isArray(status)) {
          const expData = status.map((item) => ({
            Date: item.date,
            Amount: item.amount,
            "C-ID": item.sID,
            Note: item.note,
          }));
          const worksheet = XLSX.utils.json_to_sheet(expData);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
          XLSX.writeFile(workbook, "Validate.xlsx");
          this.validating = false;
        }
        this.validating = false;
      }
    },

    async LoadOrg() {
      var obj = {
        url:
          this.$store.state.domain +
          "DropDownList/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&category=org",
        token: this.$store.state.userData.token,
      };
      this.orgList = await this.get(obj);
      // console.log(this.orgList);
    },
    openOrg() {
      this.orgObj = {
        id: 0,
        title: "",
        typee: "org",
        campusID: this.$store.state.userData.cId,
      };
      this.visibility4 = true;
      var elem = this.$refs["org_name"];
      elem.state = undefined;
    },
    checkOrg() {
      var elem = this.$refs["org_name"];
      if (this.orgObj.title == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async saveOrg() {
      if (this.checkOrg() == true) {
        this.savingOrg = true;
        if (this.orgObj.id == 0) {
          var status = await this.post({
            url:
              this.$store.state.domain +
              "DropDownList?db=" +
              this.$store.state.userData.db,
            body: this.orgObj,
            message: "Organization added successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
        } else {
          var status = await this.put({
            url:
              this.$store.state.domain +
              "DropDownList/" +
              this.orgObj.id +
              "?db=" +
              this.$store.state.userData.db,
            message: "Organization updated successfully.",
            context: this,
            body: this.orgObj,
            token: this.$store.state.userData.token,
          });
        }
        if (status) {
          this.LoadOrg();
          this.orgObj = {
            id: 0,
            title: "",
            typee: "org",
            campusID: this.$store.state.userData.cId,
          };
          var elem = this.$refs["org_name"];
          elem.state = undefined;
        }
        this.savingOrg = false;
      }
    },
    async editOrg(acc) {
      this.orgObj = { ...acc };
      var elem = this.$refs["org_name"];
      elem.state = undefined;
    },
    async deleteOrg(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "DropDownList/" +
            id +
            "?db=" +
            this.$store.state.userData.db,
          message: "Organization deleted successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.LoadOrg();
      }
    },

    async loadCOA() {
      var obj = {
        url:
          this.$store.state.domain +
          "Accounts/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      const raw = await this.get(obj);
      const list = this.normalizeAccountsResponse(raw);
      this.coAccounts = this.filterAccountsByRole(list);
      // console.log(this.coAccounts);
    },
    setCOA(el) {
      if (el == null || el == "") this.accountObj.accountID = 0;
    },

    async loadSubSetting() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettings?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: [
          "fee_sub_categories",
          "fee_notice",
          "double_entry",
          "receive_late",
          "prevent_back_date",
          "challan_with_header",
          "head_office",
          "partial-fee",
          "second_due_date",
          "annualFeeDiscount",
          "show_collection_accounts",
          "resend_slip",
        ],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });

      this.subObj = res.find((el) => el.key == "fee_sub_categories");
      this.entryObj = res.find(
        (el) => el.key.replace(/\r\n/g, "") == "double_entry"
      );
      this.noticeObj = res.find((el) => el.key == "fee_notice");
      this.cHeadObj = res.find((el) => el.key == "challan_with_header");
      this.lateObj = res.find((el) => el.key == "receive_late");
      this.backDtObj = res.find((el) => el.key == "prevent_back_date");
      this.isHeadOffice = res.find((el) => el.key == "head_office");
      this.partialObj = res.find((el) => el.key == "partial-fee");
      this.secondDueDate = res.find((el) => el.key == "second_due_date"); // 2nd due date to show in challan
      this.annualObj = res.find((el) => el.key == "annualFeeDiscount"); // discount date for annual fee
      this.resendObj = res.find((el) => el.key == "resend_slip");

      // only show these collection accounts
      this.accObj = res.find((el) => el.key == "show_collection_accounts");
      if (this.accObj?.value) {
        this.accIDs = this.accObj.value
          .split(",")
          .filter((el) => el)
          .map(Number);
      } else this.accIDs = [];
      // console.log(this.accIDs);
      this.loadAccounts();

      if (this.backDtObj && this.backDtObj.valueBool) {
        this.fetchTime();
        // this.receiveObj.rcvDate = new Date().toJSON();
        // this.$store.commit("setDate", this.receiveObj.rcvDate);
        // this.challanObj.rcvDate = this.receiveObj.rcvDate;
      }
    },
    async LoadSettingsAll() {
      let raw = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettingsAll?db=" +
          this.$store.state.userData.db,
        body: [
          "std_ledger",
          "cheque_details",
          "local_gr",
          "show_mother_name",
          "show_student_ledger",
          "family_sequence",
          "edit_rcv_date",
          "tax-fee",
          "hide_fee_settings",
          "custom_fees_date",
          "admin-approval",
        ],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });

      let res = [];
      if (Array.isArray(raw)) res = raw;
      else if (raw && typeof raw === "object" && Array.isArray(raw.data))
        res = raw.data;

      if (!Array.isArray(res)) res = [];

      this.prevLedgObj = res.find((el) => el.key == "std_ledger"); // for previous ledger
      this.chDetails = res.find((el) => el.key == "cheque_details");
      this.showMother = res.find((el) => el.key == "show_mother_name");
      this.currLedgObj = res.find((el) => el.key == "show_student_ledger");
      this.seqObj = res.find((el) => el.key == "family_sequence"); // for std f.code = id
      this.editRcvDate = res.find((el) => el.key == "edit_rcv_date");
      this.taxObj = res.find((el) => el.key == "tax-fee");
      this.hideSettings = res.find((el) => el.key == "hide_fee_settings"); // hide fee settings and should not receive fee before issue date
      this.customFeesDateSetting = res.find(
        (el) =>
          el &&
          String(el.key || "")
            .trim()
            .toLowerCase() === "custom_fees_date"
      );
      // console.log("after", this.receiveConfig); // according to hide settings

      // this.schGr = res.find((el) => el.key == "local_gr");
      // console.log(this.schGr);
      if (this.chDetails && this.chDetails.valueBool) this.LoadOrg();

      const obj = res.find((el) => el.key == "admin-approval");
      if (obj && obj.valueBool && obj.value) {
        this.approvalList = obj.value
          .split(",")
          .map((v) => v.trim())
          .filter((v) => v);
      }
      if (this.approvalList.includes("remove-fee")) {
        this.LoadFeeRequests();
      }
    },
    async LoadFeeRequests() {
      let url =
        this.$store.state.domain +
        "studentLeftRequest/LoadData?db=" +
        this.$store.state.userData.db +
        "&cID=0&status=pending&type=remove-fee&page=1&pageSize=1000";

      const res = await this.get({
        url,
        token: this.$store.state.userData.token,
        dashboard: true,
      });

      let items = [];
      if (res && res.data && res.data.data) {
        items = Array.isArray(res.data.data) ? res.data.data : [];
      } else if (res && res.data && Array.isArray(res.data)) {
        items = res.data;
      } else if (res && Array.isArray(res)) {
        items = res;
      }
      this.pendingFeeRequest = items
        .filter((req) => req.us)
        .map((el) => el.us.entityID);
      // console.log(this.pendingFeeRequest);
    },
    async LoadUsers() {
      this.allUsers = await this.get({
        url:
          this.$store.state.domain +
          "Users/LoadUsersBasic?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      });
    },
    getUser(id) {
      let obj = this.allUsers.find((el) => el.id == id);
      return obj ? obj.username : "-";
    },
    getAcc(id) {
      let obj = this.accTypes.find((el) => el.id == id);
      return obj ? obj.account : "-";
    },
    setAll() {
      if (this.toPrint.includes(0)) {
        this.toPrint = this.allfeeType.reduce((acc, c) => {
          acc.push(c.id);
          return acc;
        }, []);
      }
    },

    openPrint() {
      this.hisOpen = true;
    },
    setHisDate() {
      if (this.rangeDate) {
        let d = this.rangeDate.split(" to ");
        this.historyObj.dtFrom = d[0];
        this.historyObj.dtTo = d[1];
      } else {
        this.historyObj.dtFrom = null;
        this.historyObj.dtTo = null;
      }
    },
    printHistory() {
      if (!this.myObj.id) {
        this.$bvToast.toast(this.$t("Please select the student first"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else if (!this.historyObj.dtFrom || !this.historyObj.dtTo) {
        this.$bvToast.toast("Please select valid date", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        this.hisPrinting = true;

        let fcode = 0;
        let sID = 0;
        if (this.iFamily) fcode = this.myObj.familyCode;
        else sID = this.myObj.id;

        var url =
          `https://${this.reportDomain}.myskool.app/Fee/ShowHistory` +
          "?dtFrom=" +
          this.historyObj.dtFrom +
          "&dtTo=" +
          this.historyObj.dtTo +
          "&dbb=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&sID=" +
          sID +
          "&family=" +
          fcode;

        window.open(url, "_blank");
        this.hisPrinting = false;
      }
    },
    openCom() {
      this.commitObj = {
        date: null,
        reason: "",
        feeIDs: this.receiveObj.feesIDs,
        userID: this.$store.state.userData.userID,
      };
      this.visibility3 = true;
    },
    CheckComDate() {
      var elem = this.$refs["commit_date"];
      if (this.commitObj.date == "" || this.commitObj.date == null) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async saveCommitment() {
      if (this.CheckComDate() == true) {
        this.pSaving = true;
        // console.log(this.commitObj);
        var status = await this.post({
          url:
            this.$store.state.domain +
            "Fees/HoldFeeSelected?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: this.commitObj,
          message: "Fees holded successfully",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) {
          this.visibility3 = false;
          this.loadGrid();
        }
        this.pSaving = false;
      }
    },
    async unHoldFee() {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("Do you want to unhold the selected fee?"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("Yes, Unhold it!"),
      });

      if (result.isConfirmed) {
        this.unholding = true;
        let obj = {
          feeIDs: this.receiveObj.feesIDs,
          campusID: this.$store.state.userData.cId,
          userID: this.$store.state.userData.userID,
        };
        // console.log(obj);
        var status = await this.post({
          url:
            this.$store.state.domain +
            "Fees/UnholdFeeSelected?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: obj,
          message: "Fees unholded successfully",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.unholding = false;
        if (status) {
          this.loadGrid();
        }
      }
    },

    handleEvent(event) {
      if (
        (this.rights.add || this.rights.receiveFee) &&
        !this.rights.disableReceiving
      ) {
        if (event.key == "Escape") {
          this.closeForm();
        } else if (event.ctrlKey && event.shiftKey && event.keyCode === 83) {
          if (this.check == 1) {
            this.check = 0;
            this.fromShortcut = true;
            this.slipShortcut = true;
            // console.log(this.check, this.fromShortcut, this.slipShortcut);
            this.receiveFee("normal");
          }
        } else if (event.ctrlKey && event.keyCode === 83) {
          event.preventDefault();
          if (this.check == 1) {
            this.check = 0;
            // console.log(this.check);
            this.fromShortcut = true;
            this.slipShortcut = false;
            this.receiveFee("normal");
          }
        }
      }
    },
    showFreeshipAlert() {
      Swal.fire({
        title: this.noticeObj.value || "Freeship Challan",
        html: `<div class='text-center'>
          <p class='mb-0'>You have set the <strong>${
            this.noticeObj.value || "Freeship Challan"
          }</strong> setting saved in your settings.</p>
        </div>`,
        icon: "info",
        showCloseButton: true,
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        confirmButtonText: this.$t("Ok"),
      });
    },
    async PrintChallan() {
      // For myskooliuss, show Freeship Challan message if setting is enabled
      if (
        this.reportDomain === "myskooliuss" &&
        this.noticeObj &&
        this.noticeObj.valueBool
      ) {
        await Swal.fire({
          title: this.noticeObj.value || "Freeship Challan",
          html: `<div class='text-left'>
            <p class='mb-50'>You are creating a ${
              this.noticeObj.value || "Freeship Challan"
            }.</p>
          </div>`,
          icon: "info",
          showCloseButton: false,
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: this.$t("Ok"),
        });
      }

      var contr = "Challan";
      if (this.myObj.status.toLowerCase() == "present") {
        contr = "Challan";
      } else {
        contr = "ChallanLeft";
      }

      let header = this.cHeadObj ? this.cHeadObj.valueBool : false;

      // For myskooliuss, if student status is "registered", set header=true
      if (
        this.reportDomain === "myskooliuss" &&
        this.myObj.status &&
        this.myObj.status.toLowerCase() === "registered"
      ) {
        header = true;
      }

      let url =
        `https://${this.reportDomain}.myskool.app/Fee/` +
        contr +
        "?dbb=" +
        this.$store.state.userData.db +
        "&sID=" +
        this.myObj.id +
        "&cID=" +
        this.$store.state.userData.cId +
        "&fID=" +
        this.receiveObj.feesIDs +
        "&header=" +
        header;
      window.open(url, "_blank");
    },
    async checkPrint(text) {
      if (this.myObj.id == 0) {
        this.$bvToast.toast(this.$t("Please select the student first"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        await this.openSettings();

        if (
          this.settings.printBy != null &&
          this.settings.printBy.toLowerCase() == "student" &&
          this.iFamily &&
          (!this.seqObj || !this.seqObj.valueBool) // not include settings
        ) {
          Swal.fire({
            // title: "",
            html: `<div class='text-left'>
              <p class='mb-50'>You have Student wise print option enabled.</p>
              <p class='mb-50'>Please enter by Gr# to proceed.</p>
            </div>`,
            icon: "warning",
            showCloseButton: false,
            showCancelButton: false,
            confirmButtonColor: "#d33",
            confirmButtonText: this.$t("Ok"),
          });
        } else if (
          this.settings.printBy != null &&
          this.settings.printBy.toLowerCase() == "family" &&
          !this.iFamily &&
          (!this.seqObj || !this.seqObj.valueBool) // not include settings
        ) {
          Swal.fire({
            // title: "",
            html: `<div class='text-left'>
              <p class='mb-50'>You have Family wise print option enabled.</p>
              <p class='mb-50'>Please enter by Family code to proceed.</p>
            </div>`,
            icon: "warning",
            showCloseButton: false,
            showCancelButton: false,
            confirmButtonColor: "#d33",
            confirmButtonText: this.$t("Ok"),
          });
        } else {
          let result = await Swal.fire({
            // title: "",
            html: `<div class='text-left'><p class='mb-50'>Your fee details are:</p>
             <b>Issue Date: </b>  ${new Date(
               this.settings.issueDate
             ).toLocaleDateString("en-UK", {
               year: "numeric",
               day: "numeric",
               month: "short",
             })}<br/>
            <b>Due Date: </b> ${new Date(
              this.settings.dueDate
            ).toLocaleDateString("en-UK", {
              year: "numeric",
              day: "numeric",
              month: "short",
            })}<br/>
            <b>Expiry Date: </b> ${new Date(
              this.settings.expiryDate
            ).toLocaleDateString("en-UK", {
              year: "numeric",
              day: "numeric",
              month: "short",
            })}<br/>
            <p class='mt-1'>Are you sure you want to proceed?</p>
            </div>`,
            icon: "warning",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: this.$t("Yes"),
            cancelButtonText: "Edit Settings",
          });

          // console.log(result);
          if (result.isConfirmed) {
            if (text == "print") this.print();
            else if (text == "whatsapp") this.SendChallan();
            else if (text == "notification") this.sendNotification();
          } else if (result.dismiss == "cancel") {
            this.openSettings(true);
          }
        }
      }
    },
    async print() {
      // await this.openSettings();
      var ffc = this.myObj.familyCode;
      var controller = "GenerateChallan";

      var contr = "Challan";
      // console.log(this.myObj.status.toLowerCase());
      if (this.myObj.status.toLowerCase() == "present") {
        contr = "Challan";
      } else {
        contr = "ChallanLeft";
      }

      if (
        this.settings.printBy != null &&
        this.settings.printBy.toLowerCase() == "student"
      ) {
        if (this.myObj.status.toLowerCase() == "present") {
          controller = "GenerateChallanStudent";
        } else {
          controller = "GenerateChallanStudentLeft";
        }

        ffc = -1;
      }

      this.iPrint = true;
      try {
        var pObj = {
          fCode: this.myObj.familyCode,
          sID: this.myObj.id,
          cID: [],
          secID: [],
          feeTypeID: [],
          months: [],
          year: 0,
          familyWise: true,
          userID: this.$store.state.userData.userID,
          feeIDs: this.receiveObj.feesIDs,
        };

        if (pObj.familyCode == null) pObj.familyCode = 0;
        if (pObj.sID == null) pObj.sID = 0;

        if (this.iFamily && (!this.seqObj || !this.seqObj.valueBool))
          pObj.sID = 0;

        let campID = this.myObj.campusID || this.$store.state.userData.cId;

        var objData = await this.postObj({
          url:
            this.$store.state.domain +
            "feesChallan/" +
            controller +
            "?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            campID +
            "&exp=false",
          body: pObj,
          message: null,
          context: this,
          token: this.$store.state.userData.token,
        });
        console.log(objData);

        let header = this.cHeadObj ? this.cHeadObj.valueBool : false;

        // For myskooliuss, if student status is "registered", set header=true
        if (
          this.reportDomain === "myskooliuss" &&
          this.myObj.status &&
          this.myObj.status.toLowerCase() === "registered"
        ) {
          header = true;
        }

        if (objData.length > 0) {
          let url =
            `https://${this.reportDomain}.myskool.app/Fee/` +
            contr +
            "?dbb=" +
            this.$store.state.userData.db +
            "&sID=" +
            this.myObj.id +
            "&cID=" +
            campID +
            "&cls=" +
            "" +
            "&sec=" +
            "" +
            "&feeType=" +
            "" +
            "&fCode=" +
            ffc +
            "&fcID=" +
            objData +
            "&duedate=" +
            this.settings.dueDate +
            "&header=" +
            header;

          if (!this.iFamily) {
            url =
              `https://${this.reportDomain}.myskool.app/Fee/` +
              contr +
              "?dbb=" +
              this.$store.state.userData.db +
              "&sID=" +
              this.myObj.id +
              "&cID=" +
              campID +
              "&cls=" +
              "" +
              "&sec=" +
              "" +
              "&feeType=" +
              "" +
              "&fCode=" +
              ffc +
              "&fcID=" +
              objData +
              "&duedate=" +
              this.settings.dueDate +
              "&header=" +
              header;
          }

          let urlSelectedMonth = url + "&month=" + this.selectedMonths;

          // For myskooliuss, show Freeship Challan message if setting is enabled
          if (
            this.reportDomain === "myskooliuss" &&
            this.noticeObj &&
            this.noticeObj.valueBool
          ) {
            await Swal.fire({
              title: this.noticeObj.value || "Freeship Challan",
              html: `<div class='text-left'>
                <p class='mb-50'>You are creating a ${
                  this.noticeObj.value || "Freeship Challan"
                }.</p>
              </div>`,
              icon: "info",
              showCloseButton: false,
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              confirmButtonText: this.$t("Ok"),
            });
          }

          // console.log(url);
          window.open(url, "_blank");
        } else {
          alert("Nothing to print.");
        }
      } catch (error) {
      } finally {
        this.iPrint = false;
      }
    },
    async SendChallan() {
      // await this.openSettings();
      var ffc = this.myObj.familyCode;
      var controller = "GenerateChallan";
      if (
        this.settings.printBy != null &&
        this.settings.printBy.toLowerCase() == "student"
      ) {
        if (this.myObj.status.toLowerCase() == "present") {
          controller = "GenerateChallanStudent";
        } else {
          controller = "GenerateChallanStudentLeft";
        }
        ffc = -1;
      }

      this.iMsg = true;
      try {
        var pObj = {
          fCode: this.myObj.familyCode,
          sID: this.myObj.id,
          cID: [],
          secID: [],
          feeTypeID: [],
          months: [],
          year: 0,
          familyWise: true,
          userID: this.$store.state.userData.userID,
          feeIDs: this.receiveObj.feesIDs,
        };

        if (pObj.familyCode == null) pObj.familyCode = 0;
        if (pObj.sID == null) pObj.sID = 0;

        if (this.iFamily) pObj.sID = 0;

        let campID = this.myObj.campusID || this.$store.state.userData.cId;

        var objData = await this.postObj({
          url:
            this.$store.state.domain +
            "feesChallan/" +
            controller +
            "?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            campID +
            "&exp=true",
          body: pObj,
          message: "Sent on WhatsApp",
          context: this,
          ignoreTimeout: true,
          token: this.$store.state.userData.token,
        });
      } catch (error) {
      } finally {
        this.iMsg = false;
      }
    },

    async sendNotification() {
      // await this.openSettings();
      var ffc = this.myObj.familyCode;
      var controller = "GenerateChallanStudent";

      this.iNotification = true;
      try {
        var pObj = {
          fCode: this.myObj.familyCode,
          sID: this.myObj.id,
          cID: [],
          secID: [],
          feeTypeID: [],
          months: [],
          year: 0,
          familyWise: true,
          userID: this.$store.state.userData.userID,
          feeIDs: this.receiveObj.feesIDs,
        };

        if (pObj.familyCode == null) pObj.familyCode = 0;
        if (pObj.sID == null) pObj.sID = 0;

        if (this.iFamily) pObj.sID = 0;

        let campID = this.myObj.campusID || this.$store.state.userData.cId;

        var objData = await this.postObj({
          url:
            this.$store.state.domain +
            "feesChallan/" +
            controller +
            "?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            campID +
            "&exp=true&notification=true",
          body: pObj,
          message: "Notification sent successfully",
          context: this,
          ignoreTimeout: true,
          token: this.$store.state.userData.token,
        });
      } catch (error) {
      } finally {
        this.iNotification = false;
      }
    },
    async sendSlip(id, cID) {
      let result = await Swal.fire({
        title: "Are you sure?",
        text: "Do you want to send Slip No# " + id + " to WhatsApp?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes!"),
      });
      if (result.isConfirmed) {
        this.sending = true;
        let res = await this.post({
          url:
            this.$store.state.domain +
            "Fees/SendSlip?db=" +
            this.$store.state.userData.db +
            "&campusID=" +
            cID +
            "&billID=" +
            id +
            "&userID=" +
            this.$store.state.userData.userID,
          message: "Slip is being processed.",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.sending = false;
      }
    },
    printSlip(id, rem, cID) {
      // console.log(this.leftDues);
      // console.log(id, rem);
      let campID = cID || this.myObj.campusID || this.$store.state.userData.cId;
      const remTotal =
        this.reportDomain == "myskoolstjacob" ? rem + this.leftDues : rem;

      const fcode = this.myObj.familyCode;

      let url =
        `https://${this.reportDomain}.myskool.app/Fee/Slip?dbb=` +
        this.$store.state.userData.db +
        "&bID=" +
        id +
        "&cID=" +
        campID +
        "&rem=" +
        remTotal +
        "&fcode=" +
        fcode;
      window.open(url, "_blank");
    },
    slidechange() {
      // console.log(this.$refs.myswiper.$swiper.activeIndex);
      this.myObj = this.students[this.$refs.myswiper.$swiper.activeIndex];

      this.collection.sID = this.myObj.id;
      // console.log(this.myObj, this.collection);
      this.loadStudentConcessionCategory(this.myObj);
      this.checkLedger();
    },
    setLastChanged(name) {
      this.lastChanged = name;
    },
    printLedger() {
      if (!this.myObj.id) {
        this.$bvToast.toast("Please select the student first", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return;
      }

      const routeData = this.$router.resolve({
        name: "student-ledger-print",
        query: {
          db: this.$store.state.userData.db,
          sID: this.myObj.id,
          studentName: this.myObj.name,
          id: this.myObj.id,
          cID: this.$store.state.userData.cId,
        },
      });
      window.open(routeData.href, "_blank");
    },
    printFeeReminderTop() {
      if (!this.myObj.id) {
        this.$bvToast.toast(this.$t("Please select the student first"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return;
      }

      const routeData = this.$router.resolve({
        name: "fee-reminder-print",
        query: {
          db: this.$store.state.userData.db,
          cID: this.myObj.campusID || this.$store.state.userData.cId,
          search: this.myObj.gr,
        },
      });
      window.open(routeData.href, "_blank");
    },
    async getReport() {
      if (!this.myObj.id) {
        this.$bvToast.toast("Please select the student first", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        let x = parseInt(this.myObj.familyCode);

        if (!this.fromGr && !x) {
          this.$bvToast.toast("Please select the student first", {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
        } else {
          // For myskooliuss, show Freeship Challan message if setting is enabled
          if (
            this.reportDomain === "myskooliuss" &&
            this.noticeObj &&
            this.noticeObj.valueBool
          ) {
            await Swal.fire({
              title: this.noticeObj.value || "Freeship Challan",
              html: `<div class='text-left'>
                <p class='mb-50'>You are creating a ${
                  this.noticeObj.value || "Freeship Challan"
                }.</p>
              </div>`,
              icon: "info",
              showCloseButton: false,
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              confirmButtonText: this.$t("Ok"),
            });
          }

          let fcode = 0;
          let id = 0;
          if (!this.fromGr) {
            fcode = this.myObj.familyCode;
          } else {
            id = this.myObj.id;
          }
          var url =
            `https://${this.reportDomain}.myskool.app/Fee/PrintOutstanding?dbb=` +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&sID=" +
            id +
            "&family=" +
            fcode;

          window.open(url, "_blank");
        }
      }
    },
    show() {
      // console.log(this.lastChanged);
      if (this.lastChanged === "gr") {
        this.byGR();
      } else if (this.lastChanged === "family") {
        this.byFamily();
      } else if (this.lastChanged === "challan") {
        this.byChallan();
      } else {
        this.$bvToast.toast(this.$t("Please select the student first"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
    },

    byGR() {
      this.iFamily = false;
      if (this.myObj.gr == null || this.myObj.gr == "") {
        this.$bvToast.toast(this.$t("Please select the student first"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        this.loadGrid(this.myObj.gr);
      }
    },
    applyRouteStudentSearch() {
      const q = this.$route && this.$route.query ? this.$route.query : {};
      const grRaw = q.grNo != null ? String(q.grNo).trim() : "";
      const sid = q.sID != null ? parseInt(String(q.sID), 10) : 0;
      if (!grRaw && !(sid > 0)) return;

      if (grRaw) {
        this.myObj.gr = grRaw;
        this.lastChanged = "gr";
      }
      if (sid > 0) {
        this.myObj.id = sid;
      }

      this.$nextTick(() => {
        if (grRaw) {
          this.byGR();
        } else if (sid > 0) {
          this.loadGrid(sid);
        }
      });
    },
    byFamily() {
      if (this.myObj.familyCode == null || this.myObj.familyCode == "") {
        this.$bvToast.toast(this.$t("Please select the student first"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        this.loadByFamily();
      }
    },
    async showSidebar() {
      this.visibility = true;
    },
    hideSideBar() {
      this.visibility = false;
    },
    openInst(item) {
      // console.log(item);
      this.instObj = {
        feeID: item.fees.id,
        amount: null,
        campusID: this.$store.state.userData.cId,
      };
      this.instCurrent = item.fees.balance;
      this.$refs["instAmount"].state = undefined;
      this.visibility2 = true;
    },
    checkInstallment() {
      var elem = this.$refs["instAmount"];
      let x = parseInt(this.instObj.amount);
      if (isNaN(x) || x <= 0 || x >= this.instCurrent) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async saveInstallment() {
      if (this.checkInstallment() == true) {
        this.instObj.amount = parseInt(this.instObj.amount);
        // console.log(this.instObj);
        this.request = true;
        var status = await this.post({
          url:
            this.$store.state.domain +
            "Fees/BreakFee?db=" +
            this.$store.state.userData.db,
          body: this.instObj,
          message: "Installment added successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.request = false;
        if (status) {
          this.visibility2 = false;
          this.loadGrid();
        }
      }
    },
    openDiscount(item) {
      // console.log(item);
      this.disObj = {
        feesID: item.fees.id,
        discountAmount: item.fees.discount,
        userID: this.$store.state.userData.userID,
        timelyDiscount:
          this.settings.timelyDiscount > 0 ? item.fees.timelyDiscount : 0,
        discountNote: item.fees.discountNote,
      };
      this.currentBalance = item.fees.actualFee;
      this.netBalance =
        item.fees.actualFee - item.fees.discount - this.disObj.timelyDiscount;
      this.$refs["discount"].state = undefined;
      this.showDiscount = true;
    },
    hideDiscount() {
      this.showDiscount = false;
    },
    validateDiscount() {
      var elem = this.$refs["discount"];
      if (this.checkDiscount() == true) {
        this.netBalance =
          this.currentBalance -
          this.disObj.discountAmount -
          this.disObj.timelyDiscount;
        elem.state = undefined;
      } else {
        this.netBalance = this.currentBalance;
      }
    },
    validateTimely() {
      var elem = this.$refs["timely"];
      if (
        this.disObj.timelyDiscount < 0 ||
        this.disObj.timelyDiscount == null ||
        this.disObj.timelyDiscount == "" ||
        parseInt(this.disObj.timelyDiscount) +
          parseInt(this.disObj.discountAmount) >=
          this.currentBalance
      ) {
        elem.state = false;
        this.netBalance = this.currentBalance;
      } else {
        this.netBalance =
          this.currentBalance -
          this.disObj.discountAmount -
          this.disObj.timelyDiscount;
        elem.state = true;
      }
    },
    async AddDiscount() {
      if (this.checkDiscount() == false) {
        return this.$bvToast.toast("Please enter the discount amount.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-right",
        });
      } else {
        this.disObj.discountAmount = parseInt(this.disObj.discountAmount);
        this.disObj.timelyDiscount = parseInt(this.disObj.timelyDiscount);
        // console.log(this.disObj);
        this.request = true;
        var status = await this.post({
          url:
            this.$store.state.domain +
            "Fees/AddDiscount?db=" +
            this.$store.state.userData.db,
          body: this.disObj,
          message: "Discount added successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) {
          this.showDiscount = false;
          this.loadGrid();
        }
        this.request = false;
      }
    },
    checkDiscount() {
      // var reg = /^\d+$/;
      // console.log(reg.test(this.disObj.discountAmount));
      var elem = this.$refs["discount"];
      if (
        // this.disObj.discountAmount <= 0 ||
        this.disObj.discountAmount == null ||
        this.disObj.discountAmount == "" ||
        parseInt(this.disObj.discountAmount) +
          parseInt(this.disObj.timelyDiscount) >=
          this.currentBalance
      ) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async fetchDate() {
      var obj = {
        url: this.$store.state.domain + "Fees/GetDate",
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj);

      // console.log(res);
      if (res && !Array.isArray(res)) {
        return res;
      } else {
        return new Date().toJSON();
      }
    },
    async openExempt(id) {
      this.exObj = {
        feeID: id,
        reason: "",
        date: null,
      };
      this.$bvModal.show("modal-exempt");
      if (this.showExDate) {
        this.exObj.date = await this.fetchDate();
        // console.log(this.exObj.date);
      }
    },
    checkExReason() {
      var elem = this.$refs["ex_reason"];
      if (this.exObj.reason == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkExDate() {
      if (this.showExDate) {
        var elem = this.$refs["ex_date"];
        if (!this.exObj.date) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },
    async ExemptWithNote() {
      if (this.checkExReason() == true && this.checkExDate() == true) {
        let result = await Swal.fire({
          title: this.$t("Are you sure?"),
          text: this.$t("Do you want to exempt this fee?"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: this.$t("Yes!"),
        });

        if (result.isConfirmed) {
          // console.log(this.exObj);
          this.exempting = true;
          let dtParam = this.showExDate ? "&date=" + this.exObj.date : "";

          var status = await this.post({
            url:
              this.$store.state.domain +
              "Fees/ExemptFee?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.$store.state.userData.cId +
              "&feeID=" +
              this.exObj.feeID +
              "&reason=" +
              this.exObj.reason +
              "&userID=" +
              this.$store.state.userData.userID +
              dtParam,
            message: "Fee exempt successfully.",
            context: this,
            body: null,
            token: this.$store.state.userData.token,
          });
          this.exempting = false;
          if (status) {
            this.$bvModal.hide("modal-exempt");
            this.loadGrid();
          }
        }
      }
    },
    async Exempt(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("Do you want to exempt this fee?"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes!"),
      });

      if (result.isConfirmed) {
        var status = await this.post({
          url:
            this.$store.state.domain +
            "Fees/ExemptFee?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&feeID=" +
            id,
          message: "Fee exempt successfully.",
          context: this,
          body: null,
          token: this.$store.state.userData.token,
        });
        if (status) this.loadGrid();
      }
    },
    async UnExempt(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("Do you want to exempt this fee?"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes!"),
      });

      if (result.isConfirmed) {
        var status = await this.post({
          url:
            this.$store.state.domain +
            "Fees/UnExemptFee?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&feeID=" +
            id,
          message: "Fee unexempt successfully.",
          context: this,
          body: null,
          token: this.$store.state.userData.token,
        });
        if (status) this.loadGrid();
      }
    },
    async deleteFee(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.put({
          url:
            this.$store.state.domain +
            "Fees/DeleteFee?" +
            "db=" +
            this.$store.state.userData.db +
            "&id=" +
            id +
            "&userID=" +
            this.$store.state.userData.userID,
          message: "Fee deleted successfully.",
          context: this,
          body: null,
          token: this.$store.state.userData.token,
        });
        if (status) this.loadGrid();
      }
    },
    async CancelFee(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Cancel it!"),
      });

      if (result.isConfirmed) {
        var status = await this.put({
          url:
            this.$store.state.domain +
            "Fees/CancelSlip?" +
            "db=" +
            this.$store.state.userData.db +
            "&campusID=" +
            this.$store.state.userData.cId +
            "&billID=" +
            id +
            "&userID=" +
            this.$store.state.userData.userID,
          message: "Fee cancelled successfully.",
          context: this,
          body: null,
          token: this.$store.state.userData.token,
        });
        if (status) this.loadHistoryGrid();
      }
    },
    openRequest(item) {
      const fees = item.fees;
      if (this.pendingFeeRequest.includes(fees.id)) {
        this.$bvToast.toast(
          `A delete request for this fee is already in pending.`,
          {
            title: "Warning!",
            variant: "warning",
            solid: true,
          }
        );
        return;
      }
      const feeType = item.feesType.feeType;
      const monthYear = fees.monthYear;
      const amount = fees.balance;

      this.reqObj = {
        id: 0,
        sID: fees.sID,
        request_date: new Date().toJSON(),
        reason: "",
        leaving_date: null,
        note: "",
        document: "",
        status: "pending",
        requested_by: this.$store.state.userData.userID,
        campusID: fees.campusID,
        type: "remove-fee",
        approved_by: 0,
        approved_document: "",
        entityID: fees.id,
        meta_data: JSON.stringify({
          feeType,
          monthYear,
          amount,
        }),
      };
      this.$bvModal.show("modal-request");
    },
    CheckReqReason() {
      var elem = this.$refs["req_reason"];
      if (!this.reqObj.reason || this.reqObj.reason.trim() == "") {
        if (elem) elem.state = false;
        return false;
      } else {
        if (elem) elem.state = true;
        return true;
      }
    },
    async saveLeaveReq() {
      if (this.CheckReqReason() == true) {
        let curDate = new Date().toJSON();
        this.reqObj.request_date = curDate;
        this.reqObj.leaving_date = curDate;
        let payload = { ...this.reqObj };
        this.savingReq = true;
        var status = await this.post({
          url:
            this.$store.state.domain +
            "studentLeftRequest?db=" +
            this.$store.state.userData.db,
          body: payload,
          message: "Request saved successfully!",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.savingReq = false;
        if (status) {
          this.$bvModal.hide("modal-request");
          if (this.approvalList.includes("remove-fee")) {
            this.LoadFeeRequests();
          }
        }
      }
    },
    resetLeaveReq() {
      this.reqObj = {
        id: 0,
        sID: 0,
        request_date: null,
        reason: "",
        leaving_date: null,
        note: "",
        document: "",
        status: "pending",
        requested_by: 0,
        campusID: 0,
        type: "remove-fee",
        approved_by: 0,
        approved_document: "",
        entityID: 0,
        meta_data: "",
      };
      if (this.$refs["req_reason"]) this.$refs["req_reason"].state = undefined;
    },
    async loadSearch() {
      //  this.items =[];
      if (this.searchQuery.trim() !== "") {
        this.studentLoading = true;
        let myitem = await this.get({
          url:
            this.$store.state.domain +
            "Students/FeeSearch?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&name=" +
            this.searchQuery +
            "&fatherName=" +
            // this.searchFather +
            "&status=" +
            this.searchStatus,
          token: this.$store.state.userData.token,
        });

        // console.log(myitem)
        if (Array.isArray(myitem)) {
          this.studentData = myitem;
        } else this.studentData = [];
        // console.log("stud", this.studentData);
        this.studentLoading = false;
      }
    },
    selectSearch(item) {
      this.fSearch = item;
      this.$store.commit("setFeeSearch", item);
    },
    async loadbyFather() {
      //  this.items =[];
      if (this.searchFather.trim() !== "") {
        // console.log(this.searchFather);
        this.studentLoading = true;
        let params =
          this.fSearch == "mother"
            ? `&fatherName=&mother=${this.searchFather}`
            : `&fatherName=${this.searchFather}&mother=`;
        let myitem = await this.get({
          url:
            this.$store.state.domain +
            "Students/FeeSearch?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&name=" +
            this.searchQuery +
            params +
            "&status=" +
            this.searchStatus,
          token: this.$store.state.userData.token,
        });
        this.studentData = myitem;
        // console.log("stud", this.studentData);
        this.studentLoading = false;
      }
    },
    async byChallan() {
      if (this.myObj.challanNo == null || this.myObj.challanNo == "") {
        this.$bvToast.toast("Please enter the Challan No. first.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        this.gridLoading = true;
        this.historyLoading = true;
        this.fromGr = true;
        this.fromChallan = true;
        this.iFamily = false;
        this.history = [];
        this.students = [];
        this.challanObj.feesIDs = [];
        this.receiveObj.feesIDs = [];

        if (this.$refs.selectableTable) {
          this.$refs.selectableTable.clearSelected();
        }

        let res = await this.get({
          url:
            this.$store.state.domain +
            "Fees/GetByChallan?db=" +
            this.$store.state.userData.db +
            "&campusID=" +
            this.$store.state.userData.cId +
            "&challanNo=" +
            this.myObj.challanNo,
          token: this.$store.state.userData.token,
        });
        // console.log("res", res);

        if (res === "No record found") {
          this.gridLoading = false;
          this.historyLoading = false;
          this.items = [];
          this.history = [];
          this.fromChallan = false;

          this.myObj = {
            gr: null,
            familyCode: null,
            challanNo: this.myObj.challanNo,
            id: 0,
          };

          this.total = null;
          this.balance = null;
          this.paid = null;

          this.challanObj.feesIDs = [];
        } else {
          this.items = res.dues;
          this.history = res.history;
          this.total = res.duesTotal;
          this.paid = res.duesTotal;
          var elem = this.$refs["paid"];
          elem.state = undefined;
          this.balance = 0;

          this.myObj = {
            gr: null,
            familyCode: null,
            challanNo: this.myObj.challanNo,
            id: 0,
          };

          this.historyLoading = false;
          this.gridLoading = false;
        }
      }
    },

    async loadGrid(id) {
      this.fromChallan = false;
      this.iFamily = false;
      this.challanObj.feesIDs = [];
      this.receiveObj.feesIDs = [];

      if (this.$refs.selectableTable) {
        this.$refs.selectableTable.clearSelected();
      }

      this.visibility = false;
      this.allSelect = false;
      this.gridLoading = true;
      this.historyLoading = true;

      let x = parseInt(id);
      var obj = {
        url:
          this.$store.state.domain +
          "Fees/GetStudentFeesDataExemption?db=" +
          this.$store.state.userData.db +
          "&campusID=" +
          this.$store.state.userData.cId +
          "&grNo=" +
          this.myObj.gr +
          "&familyCode=0&sID=" +
          `${x ? x : this.myObj.id}`,
        token: this.$store.state.userData.token,
        // +
        // this.myObj.familyCode
      };
      let res = await this.get(obj);
      if (this.receiving) {
        this.receiving = false;
        if (this.fromShortcut && this.slipShortcut) {
          this.printSlip(this.slipNo, res[0].duesTotal, this.myObj.campusID);
        } else if (this.settings.printSlip) {
          //Print Slip
          this.printSlip(this.slipNo, res[0].duesTotal, this.myObj.campusID);
        }
        this.fromShortcut = false;
        this.slipShortcut = false;
        this.check = 1;
      }
      // console.log("res", res);
      if (res === "No record found") {
        this.gridLoading = false;
        this.historyLoading = false;
        this.items = [];
        this.history = [];
        this.students = [];
        this.fromGr = true;

        this.myObj = {
          gr: this.myObj.gr,
          familyCode: null,
          challanNo: null,
          id: 0,
        };
        this.total = null;
        this.balance = null;
        this.paid = null;

        this.discountToShow = 0;
        this.advanceToShow = 0;
        this.dueDateToShow = null;
        this.annualDueDate = null;
        this.annualTimelyDiscount = 0;
        this.annualAdvanceDiscount = 0;
        this.leftDues = 0;

        this.receiveObj.feesIDs = [];
        this.studentConcessionCategory = "";
      } else {
        this.fromGr = true;
        this.items = res[0].dues;
        this.history = res[0].history;
        this.myObj = res[0].std[0];
        // this.students = res[0].std;

        this.collection = {
          sID: this.myObj.id,
          year: new Date().getFullYear(),
          userID: this.$store.state.userData.userID,
          feesTypeIDs: [],
          months: [],
          onBehalf: 0,
        };
        this.receiveObj.feesIDs = [];
        this.receiveObj.familyCode = 0;
        this.receiveObj.grNo = this.myObj.gr;

        this.discountToShow = res[0].timelyDiscountToShow;
        this.advanceToShow = res[0].advanceTimelyDiscount;
        this.dueDateToShow = res[0].dueDate;
        this.annualDueDate = res[0].annualDueDate;
        this.annualTimelyDiscount = res[0].timelyDiscountAnnualToShow;
        this.annualAdvanceDiscount = res[0].advanceTimelyDiscountAnnual;
        this.leftDues = res[0].leftDues || 0;

        this.total = res[0].duesTotal;
        if (this.auto) {
          this.paid = res[0].duesTotal;
          this.balance = 0;
        } else {
          this.paid = null;
          this.balance = res[0].duesTotal;
        }
        var elem = this.$refs["paid"];
        elem.state = undefined;

        this.gridLoading = false;
        this.historyLoading = false;
      }
      // console.log("res", this.myObj);
      this.loadStudentConcessionCategory(this.myObj);
      this.checkLedger();
    },
    resolveStudentConcessionFilters(student) {
      return {
        cID: Number(student?.campusID || this.$store.state.userData.cId || 0),
        classID: Number(
          student?.cls?.id || student?.classID || student?.clsID || 0
        ),
        sectionID: Number(
          student?.sectionID || student?.secID || student?.section?.id || 0
        ),
      };
    },
    findConcessionRecord(items, student) {
      if (!Array.isArray(items) || !student?.id) return null;

      const studentId = Number(student.id);
      const studentRoll = String(
        student.gr || student.grNo || student.roll || ""
      ).trim();
      const studentName = String(student.name || "")
        .trim()
        .toLowerCase();

      return (
        items.find((item) => {
          const itemStudentId = Number(
            item.sID || item.studentID || item.sId || item.id || 0
          );
          return itemStudentId > 0 && itemStudentId === studentId;
        }) ||
        (studentRoll
          ? items.find((item) => String(item.roll || "").trim() === studentRoll)
          : null) ||
        (studentName
          ? items.find(
              (item) =>
                String(item.name || "")
                  .trim()
                  .toLowerCase() === studentName
            )
          : null)
      );
    },
    async loadStudentConcessionCategory(student) {
      if (this.reportDomain !== "myskoolaba") {
        this.studentConcessionCategory = "";
        this.concessionCategoryLoading = false;
        return;
      }

      if (!student?.id) {
        this.studentConcessionCategory = "";
        this.concessionCategoryLoading = false;
        return;
      }

      const filters = this.resolveStudentConcessionFilters(student);
      this.concessionCategoryLoading = true;

      try {
        const response = await axios.get(
          `${this.$store.state.domain}Fees/FeeConcessionReport`,
          {
            params: {
              db: this.$store.state.userData.db,
              cID: filters.cID,
              classID: filters.classID,
              sectionID: filters.sectionID,
              discountReferenceID: 0,
            },
            headers: {
              Authorization: `Bearer ${this.$store.state.userData.token}`,
              accept: "application/json",
            },
          }
        );

        const items =
          response.data?.status === "success" &&
          Array.isArray(response.data.data)
            ? response.data.data
            : [];
        const match = this.findConcessionRecord(items, student);
        const category = String(match?.category || "").trim();
        this.studentConcessionCategory =
          category && category !== "-" ? category : "";
      } catch (error) {
        console.warn("Failed to load student concession category:", error);
        this.studentConcessionCategory = "";
      } finally {
        this.concessionCategoryLoading = false;
      }
    },
    async loadByFamily() {
      this.fromChallan = false;
      this.challanObj.feesIDs = [];
      this.receiveObj.feesIDs = [];

      if (this.$refs.selectableTable) {
        this.$refs.selectableTable.clearSelected();
      }

      this.iFamily = true;
      this.allSelect = false;
      this.gridLoading = true;
      this.historyLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "Fees/GetStudentFeesDataExemption?db=" +
          this.$store.state.userData.db +
          "&campusID=" +
          this.$store.state.userData.cId +
          "&grNo=&familyCode=" +
          this.myObj.familyCode,
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj);
      if (this.receiving) {
        this.receiving = false;
        if (this.fromShortcut && this.slipShortcut) {
          this.printSlip(this.slipNo, res[0].duesTotal, this.myObj.campusID);
        } else if (this.settings.printSlip) {
          //Print Slip
          this.printSlip(this.slipNo, res[0].duesTotal, this.myObj.campusID);
        }
        this.fromShortcut = false;
        this.slipShortcut = false;
        this.check = 1;
      }
      // console.log("res", res);
      if (res === "No record found") {
        this.gridLoading = false;
        this.historyLoading = false;
        this.items = [];
        this.history = [];
        this.students = [];
        this.fromGr = true;

        this.myObj = {
          gr: null,
          familyCode: this.myObj.familyCode,
          challanNo: null,
          id: 0,
        };
        this.total = null;
        this.balance = null;
        this.paid = null;

        this.discountToShow = 0;
        this.advanceToShow = 0;
        this.dueDateToShow = null;
        this.annualDueDate = null;
        this.annualTimelyDiscount = 0;
        this.annualAdvanceDiscount = 0;
        this.leftDues = 0;
        this.receiveObj.feesIDs = [];
        this.studentConcessionCategory = "";
      } else {
        this.items = res[0].dues;
        this.history = res[0].history;

        this.students = res[0].std;
        this.myObj = this.students[0];
        // console.log(this.myObj);
        if (this.students.length > 1) this.fromGr = false;
        else this.fromGr = true;

        this.collection = {
          sID: this.myObj.id,
          year: new Date().getFullYear(),
          userID: this.$store.state.userData.userID,
          feesTypeIDs: [],
          months: [],
          onBehalf: 0,
        };
        this.receiveObj.feesIDs = [];
        this.receiveObj.grNo = "";
        this.receiveObj.familyCode = this.myObj.familyCode;

        this.discountToShow = res[0].timelyDiscountToShow;
        this.advanceToShow = res[0].advanceTimelyDiscount;
        this.dueDateToShow = res[0].dueDate;
        this.annualDueDate = res[0].annualDueDate;
        this.annualTimelyDiscount = res[0].timelyDiscountAnnualToShow;
        this.annualAdvanceDiscount = res[0].advanceTimelyDiscountAnnual;
        this.leftDues = res[0].leftDues || 0;

        this.total = res[0].duesTotal;
        if (this.auto) {
          this.paid = res[0].duesTotal;
          this.balance = 0;
        } else {
          this.paid = null;
          this.balance = res[0].duesTotal;
        }
        var elem = this.$refs["paid"];
        elem.state = undefined;

        this.gridLoading = false;
        this.historyLoading = false;
      }
      // console.log("res", this.myObj);
      this.loadStudentConcessionCategory(this.myObj);
      this.checkLedger();
    },
    async loadHistoryGrid() {
      this.historyLoading = true;
      if (this.fromGr) {
        var obj = {
          url:
            this.$store.state.domain +
            "Fees/GetStudentFeesDataExemption?db=" +
            this.$store.state.userData.db +
            "&campusID=" +
            this.$store.state.userData.cId +
            "&grNo=" +
            this.myObj.gr +
            "&familyCode=0&sID=" +
            this.myObj.id,
          token: this.$store.state.userData.token,
        };
      } else {
        var obj = {
          url:
            this.$store.state.domain +
            "Fees/GetStudentFeesDataExemption?db=" +
            this.$store.state.userData.db +
            "&campusID=" +
            this.$store.state.userData.cId +
            "&grNo=&familyCode=" +
            this.myObj.familyCode,
          token: this.$store.state.userData.token,
        };
      }
      let res = await this.get(obj);
      // console.log("History -----------", res);
      if (res === "No record found") {
        this.historyLoading = false;
        this.items = [];
        this.history = [];
        this.students = [];
        this.myObj = {
          gr: this.myObj.gr,
          id: 0,
        };
        this.total = null;
        this.balance = null;
        this.paid = null;

        this.discountToShow = 0;
        this.advanceToShow = 0;
        this.dueDateToShow = null;
        this.annualDueDate = null;
        this.annualTimelyDiscount = 0;
        this.annualAdvanceDiscount = 0;
        this.leftDues = 0;
        this.receiveObj.feesIDs = [];
      } else {
        this.items = res[0].dues;
        this.history = res[0].history;
        // this.myObj = res[0].std[0];

        this.students = res[0].std;
        this.myObj = this.students[0];
        // console.log(this.myObj);
        if (this.students.length > 1) this.fromGr = false;
        else this.fromGr = true;

        this.collection = {
          sID: this.myObj.id,
          year: new Date().getFullYear(),
          userID: this.$store.state.userData.userID,
          feesTypeIDs: [],
          months: [],
          onBehalf: 0,
        };

        this.discountToShow = res[0].timelyDiscountToShow;
        this.advanceToShow = res[0].advanceTimelyDiscount;
        this.dueDateToShow = res[0].dueDate;
        this.annualDueDate = res[0].annualDueDate;
        this.annualTimelyDiscount = res[0].timelyDiscountAnnualToShow;
        this.annualAdvanceDiscount = res[0].advanceTimelyDiscountAnnual;
        this.leftDues = res[0].leftDues || 0;

        this.total = res[0].duesTotal;
        this.paid = null;
        this.balance = res[0].duesTotal;
        this.historyLoading = false;
      }
    },
    normalizeFeeIdsList(val) {
      if (val == null || val === "") return [];
      if (Array.isArray(val)) {
        return val.map((id) => Number(id)).filter((n) => !Number.isNaN(n));
      }
      return String(val)
        .split(",")
        .map((s) => Number(String(s).trim()))
        .filter((n) => !Number.isNaN(n));
    },

    /** True when custom_fees_date is on and current selection has a saved CustomFeesDate row */
    shouldPassCustomFeesParamsToFeeSettingsLoad() {
      if (!this.isCustomFeesDateEnabled) return false;
      if (this.fromChallan) return false;
      if (!this.myObj?.id) return false;

      const rec = this.customFeesDateLoadedRecord;
      const recId = rec != null ? Number(rec.id) : NaN;
      if (!rec || Number.isNaN(recId) || recId <= 0) return false;

      const selected = this.normalizeFeeIdsList(this.receiveObj?.feesIDs);
      if (!selected.length) return false;

      const saved = this.normalizeFeeIdsList(
        rec.feeIDs ?? rec.feesIDs ?? rec.feeIDsStr
      );
      if (saved.length) {
        const a = [...selected].sort((x, y) => x - y).join(",");
        const b = [...saved].sort((x, y) => x - y).join(",");
        if (a !== b) return false;
      }

      return true;
    },

    buildFeeSettingsLoadDataUrl(includeCustomFeesContext = true) {
      const params = new URLSearchParams({
        campusID: String(this.$store.state.userData.cId),
        db: this.$store.state.userData.db,
      });

      if (
        includeCustomFeesContext &&
        this.shouldPassCustomFeesParamsToFeeSettingsLoad()
      ) {
        const ids = this.normalizeFeeIdsList(this.receiveObj.feesIDs);
        const fc = Number(this.myObj.familyCode);
        params.set("feeIDs", ids.join(","));
        params.set("sID", String(this.myObj.id));
        params.set("familyCode", String(Number.isFinite(fc) ? fc : 0));
        params.set("fcID", String(this.customFeesDateLoadedRecord.id));
      }

      return (
        this.$store.state.domain + "FeeSettings/LoadData?" + params.toString()
      );
    },

    async openSettings(open) {
      if (open) this.loadSetting = true;
      // Settings panel / explicit open: campus defaults only (no feeIDs, sID, fcID)
      const includeCustomFeesContext = open !== true;

      let myitem = await this.get({
        url: this.buildFeeSettingsLoadDataUrl(includeCustomFeesContext),
        token: this.$store.state.userData.token,
      });
      if (myitem == null || myitem == "") {
        this.settings = {
          id: 0,
          campusID: this.$store.state.userData.cId,
          issueDate: null,
          dueDate: null,
          expiryDate: null,
          lateFee: 0,
          timelyDiscount: 0,
          printSlip: false,
          sendSMS: false,
          instructions: "",
          bankName: "",
          accountNumber: "",
          printBy: "student",
          titleOfAccount: "",
        };
      } else {
        this.settings = myitem;
        this.lateFee = this.settings.lateFee;
        this.timelyDiscount = this.settings.timelyDiscount;
      }
      if (open) {
        this.showSettings = true;
        this.loadSetting = false;
      }
    },

    normalizeChallanDateForApi(val) {
      if (val == null || val === "") return null;
      const s = String(val);
      if (s.includes("T")) return s.slice(0, 10);
      return s.length >= 10 ? s.slice(0, 10) : s;
    },

    resetCustomFeesDateForm() {
      this.customFeesDateForm = {
        issueDate: null,
        dueDate: null,
        expiryDate: null,
      };
    },

    /** Pick usable row from LoadData response */
    pickCustomFeesDateRow(list) {
      if (!Array.isArray(list) || !list.length) return null;
      const usable = list.find((r) => {
        const st = String(r.status || "active")
          .toLowerCase()
          .trim();
        return st !== "delete" && st !== "deleted";
      });
      return usable || list[0] || null;
    },

    /**
     * GET CustomFeesDate/LoadData — only when campus setting custom_fees_date is enabled.
     * Pass { silent: true } from modal open (uses loadingCustomFeesDateModal instead).
     */
    async fetchCustomFeesDateLoadData(options = {}) {
      const silent = !!options.silent;
      this.customFeesDateLoadedRecord = null;

      if (!this.isCustomFeesDateEnabled) return;
      if (!this.myObj || !this.myObj.id) return;
      if (this.fromChallan) return;
      const ids = this.receiveObj?.feesIDs || [];
      if (!ids.length) return;

      const feeIDsStr = [...ids]
        .map((id) => Number(id))
        .filter((n) => !Number.isNaN(n))
        .join(",");
      if (!feeIDsStr) return;

      if (!silent) this.loadingCustomFeesDateLoad = true;
      try {
        const campusID =
          this.myObj.campusID || this.$store.state.userData.cId || 0;
        const params = new URLSearchParams({
          db: this.$store.state.userData.db,
          campusID: String(campusID),
          feeIDs: feeIDsStr,
          sID: String(this.myObj.id),
        });
        const url =
          this.$store.state.domain +
          "CustomFeesDate/LoadData?" +
          params.toString();
        const res = await this.get({
          url,
          token: this.$store.state.userData.token,
          returnData: true,
        });
        if (!res || res === false) return;
        const list = Array.isArray(res.data) ? res.data : [];
        const rec = this.pickCustomFeesDateRow(list);
        const recId = rec != null ? Number(rec.id) : NaN;
        this.customFeesDateLoadedRecord =
          rec != null && !Number.isNaN(recId) && recId > 0 ? rec : null;
      } catch (e) {
        console.warn("CustomFeesDate/LoadData", e);
        this.customFeesDateLoadedRecord = null;
      } finally {
        if (!silent) this.loadingCustomFeesDateLoad = false;
      }
    },

    fillCustomFeesDateFormFromCampusDefaults() {
      this.customFeesDateForm.issueDate = this.normalizeChallanDateForApi(
        this.settings.issueDate
      );
      this.customFeesDateForm.dueDate = this.normalizeChallanDateForApi(
        this.settings.dueDate
      );
      this.customFeesDateForm.expiryDate = this.normalizeChallanDateForApi(
        this.settings.expiryDate
      );
    },

    fillCustomFeesDateFormFromLoadedRecord(rec) {
      const r = rec || this.customFeesDateLoadedRecord;
      if (!r) return false;
      const issueDate = this.normalizeChallanDateForApi(r.issueDate);
      const dueDate = this.normalizeChallanDateForApi(r.dueDate);
      const expiryDate = this.normalizeChallanDateForApi(r.expiryDate);
      if (!issueDate || !dueDate || !expiryDate) return false;
      this.customFeesDateForm.issueDate = issueDate;
      this.customFeesDateForm.dueDate = dueDate;
      this.customFeesDateForm.expiryDate = expiryDate;
      return true;
    },

    async openCustomFeesDateModal() {
      if (!this.isCustomFeesDateEnabled) return;
      if (!this.myObj || !this.myObj.id) {
        this.$bvToast.toast(this.$t("Please select the student first"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return;
      }
      if (!this.receiveObj.feesIDs || this.receiveObj.feesIDs.length === 0) {
        this.$bvToast.toast(
          this.$t("Please select one or more fee rows first."),
          {
            title: this.$t("Error!"),
            variant: "warning",
            toaster: "b-toaster-top-center",
          }
        );
        return;
      }
      this.loadingCustomFeesDateModal = true;
      try {
        await this.fetchCustomFeesDateLoadData({ silent: true });
        await this.openSettings(false);
        if (!this.fillCustomFeesDateFormFromLoadedRecord()) {
          this.fillCustomFeesDateFormFromCampusDefaults();
        }
      } finally {
        this.loadingCustomFeesDateModal = false;
      }
      this.$bvModal.show("modal-custom-fees-date");
    },

    async removeCustomFeesDate() {
      if (!this.isCustomFeesDateEnabled) return;
      const id = this.customFeesDateLoadedRecord?.id;
      if (id == null || id === "") return;
      const result = await Swal.fire({
        title: this.$t("Remove custom fee dates?"),
        text: this.$t("This will clear saved dates for this fee selection."),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#6c757d",
        confirmButtonText: this.$t("Yes, remove"),
        cancelButtonText: this.$t("Cancel"),
      });
      if (!result.isConfirmed) return;

      const campusID =
        this.myObj.campusID || this.$store.state.userData.cId || 0;
      const params = new URLSearchParams({
        db: this.$store.state.userData.db,
        id: String(id),
        campusID: String(campusID),
        userID: String(this.$store.state.userData.userID),
      });
      this.removingCustomFeesDate = true;
      try {
        const ok = await this.put({
          url:
            this.$store.state.domain +
            "CustomFeesDate/RemoveDate?" +
            params.toString(),
          body: {},
          message: this.$t("Custom fee dates removed."),
          context: this,
          token: this.$store.state.userData.token,
        });
        if (ok) {
          this.customFeesDateLoadedRecord = null;
          await this.openSettings(false);
          this.fillCustomFeesDateFormFromCampusDefaults();
          this.$bvModal.hide("modal-custom-fees-date");
        }
      } finally {
        this.removingCustomFeesDate = false;
      }
    },
    async saveCustomFeesDate() {
      if (!this.isCustomFeesDateEnabled) return;
      const issueDate = this.normalizeChallanDateForApi(
        this.customFeesDateForm.issueDate
      );
      const dueDate = this.normalizeChallanDateForApi(
        this.customFeesDateForm.dueDate
      );
      const expiryDate = this.normalizeChallanDateForApi(
        this.customFeesDateForm.expiryDate
      );
      if (!issueDate || !dueDate || !expiryDate) {
        this.$bvToast.toast(
          this.$t("Please select issue, due and expiry dates."),
          {
            title: this.$t("Validation"),
            variant: "warning",
            toaster: "b-toaster-top-center",
          }
        );
        return;
      }
      const feeIDs = (this.receiveObj.feesIDs || []).map((id) => Number(id));
      if (!feeIDs.length || feeIDs.some((n) => Number.isNaN(n))) {
        this.$bvToast.toast(this.$t("Invalid fee selection."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return;
      }
      const campusID =
        this.myObj.campusID || this.$store.state.userData.cId || 0;
      const fc = Number(this.myObj.familyCode);
      const recordId = Number(this.customFeesDateLoadedRecord?.id);
      const payload = {
        id: Number.isFinite(recordId) && recordId > 0 ? recordId : 0,
        feeIDs,
        campusID,
        issueDate,
        expiryDate,
        dueDate,
        sID: this.myObj.id || 0,
        familyCode: Number.isFinite(fc) ? fc : 0,
      };
      this.savingCustomFeesDate = true;
      try {
        const status = await this.post({
          url:
            this.$store.state.domain +
            "CustomFeesDate/Save?db=" +
            this.$store.state.userData.db +
            "&userID=" +
            this.$store.state.userData.userID,
          body: payload,
          message: this.$t("Custom fee dates saved successfully."),
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) {
          await this.fetchCustomFeesDateLoadData({ silent: true });
          await this.openSettings(false);
          this.$bvModal.hide("modal-custom-fees-date");
        }
      } finally {
        this.savingCustomFeesDate = false;
      }
    },

    async saveSettings() {
      // console.log(this.settings);
      this.settings.lateFee = parseInt(this.settings.lateFee);
      this.settings.timelyDiscount = parseInt(this.settings.timelyDiscount);
      this.request = true;

      var status = await this.post({
        url:
          this.$store.state.domain +
          "FeeSettings/Save?db=" +
          this.$store.state.userData.db,
        body: this.settings,
        message: "Settings saved successfully.",
        context: this,
        token: this.$store.state.userData.token,
      });
      if (status) {
        this.showSettings = false;
        this.lateFee = this.settings.lateFee;
        this.timelyDiscount = this.settings.timelyDiscount;
      }
      this.request = false;

      if (
        this.noticeObj ||
        this.cHeadObj ||
        (this.taxObj && this.taxObj.valueBool) ||
        this.secondDueDate ||
        this.annualObj
      ) {
        let data = [];
        if (this.noticeObj) data.push(this.noticeObj);
        if (this.cHeadObj) data.push(this.cHeadObj);
        if (this.taxObj && this.taxObj.valueBool) {
          // format the taxObj.valueNumber
          let x = parseInt(this.taxObj.valueNumber);
          this.taxObj.valueNumber = isNaN(x) || x < 0 || x > 100 ? 0 : x;
          console.log("Debug - TaxObj after update:", this.taxObj);

          data.push(this.taxObj);
        }
        if (this.secondDueDate) data.push(this.secondDueDate);
        if (this.annualObj) data.push(this.annualObj);

        var sett = await this.post({
          url:
            this.$store.state.domain +
            "Settings/SaveNew?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: data,
          importing: true,
          context: this,
          token: this.$store.state.userData.token,
        });
        if (sett) {
          this.loadSubSetting();
        }
      }
    },
    showHistory() {
      // this.$root.$emit("bv::toggle::collapse", "collapse-1");
      this.$store.commit("setHistory", true);
      // console.log(this.$store.state.history);
    },
    hideHistory() {
      this.$store.commit("setHistory", false);
    },
    showForm() {
      if (this.myObj.gr == null || this.myObj.gr == "" || this.myObj.id == 0) {
        this.$bvToast.toast(this.$t("Please select the student first"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        if (this.isHeadOffice) {
          this.LoadCampusFeeType();
        }
        this.createForm = true;
      }
    },
    closeForm() {
      this.createForm = false;

      // clearing selected ids when form closed
      this.challanObj.feesIDs = [];
      this.receiveObj.feesIDs = [];
      this.paid = null;
      this.getBalance();
    },
    variantFeetype(id) {
      return this.collection.feesTypeIDs.includes(id);
    },
    selectFeetype(id, recurr) {
      if (this.collection.feesTypeIDs.length == 0) {
        this.collection.feesTypeIDs.push(id);
      } else {
        let data = this.collection.feesTypeIDs.filter((el) => {
          return el !== id;
        });
        // console.log("data", data);
        if (data.length == this.collection.feesTypeIDs.length) {
          this.collection.feesTypeIDs.push(id);
        } else {
          this.collection.feesTypeIDs = data;
        }
      }
      if (recurr == "after due date") {
        if (this.variantFeetype(id) == true) {
          this.showOnBehalf = true;
        } else {
          this.showOnBehalf = false;
          this.collection.onBehalf = 0;
        }
      }
      // console.log(this.collection.feesTypeIDs);
    },
    selectOnBehalf(id) {
      if (this.collection.onBehalf == id) this.collection.onBehalf = 0;
      else this.collection.onBehalf = id;
    },
    variantMonth(name) {
      return this.collection.months.includes(name);
    },
    selectMonth(name) {
      if (this.collection.months.length == 0) {
        this.collection.months.push(name);
      } else {
        let data = this.collection.months.filter((el) => {
          return el !== name;
        });
        // console.log("data", data);
        if (data.length == this.collection.months.length) {
          this.collection.months.push(name);
        } else {
          this.collection.months = data;
        }
      }
      // console.log(this.collection.months);
    },
    escapeHtml(value) {
      return String(value ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    },
    formatFeeSkipReasonLabel(reason) {
      const labels = {
        already_exists: this.$t("Already Exists"),
        zero_amount: this.$t("Zero Amount"),
      };
      return labels[reason] || reason || "-";
    },
    formatCreateFeeBannerMessage(message) {
      const normalized = String(message || "")
        .trim()
        .toLowerCase();
      if (!normalized) return "";
      if (normalized === "no fees created") {
        return this.$t(
          "No fees were created for the selected fee type and month."
        );
      }
      return message;
    },
    buildFeeSkipTableRowHtml(item, index) {
      const period = [item.month, item.year].filter(Boolean).join(" ");
      const reasonLabel = this.escapeHtml(
        this.formatFeeSkipReasonLabel(item.reason)
      );
      const feeTypeName = this.escapeHtml(item.feeTypeName || "-");
      const periodLabel = this.escapeHtml(period || "-");
      const existingFeeValue = item.existingFeeId
        ? `#${this.escapeHtml(item.existingFeeId)}`
        : "-";

      return `
        <tr>
          <td>${index + 1}</td>
          <td class="fee-view-cell-strong">${feeTypeName}</td>
          <td>${periodLabel}</td>
          <td><span class="fee-view-reason-tag">${reasonLabel}</span></td>
          <td>${existingFeeValue}</td>
        </tr>
      `;
    },
    showCreateFeeResult({
      feesCreated = 0,
      skipped = [],
      message = "",
      isSuccess = false,
    }) {
      const skippedCount = skipped.length;
      const bannerMessage = this.formatCreateFeeBannerMessage(message);
      const title = isSuccess
        ? this.$t("Fee Creation Summary")
        : this.$t("Fee Not Created");
      const subtitle =
        isSuccess && feesCreated > 0
          ? skippedCount > 0
            ? this.$t(
                "Fees were created, but some entries were skipped. Review details below."
              )
            : this.$t("All selected fees were created successfully.")
          : bannerMessage || this.$t("Review the skipped fee details below.");

      let html = `
        <div class="fee-view-sheet">
          <div class="fee-view-header-card">
            <div class="fee-view-header">
              <div class="fee-view-title-wrap">
                <div class="fee-view-title-row">
                  <h4 class="mb-0">${title}</h4>
                  ${
                    skippedCount
                      ? `<span class="fee-view-badge-pill">${this.$t(
                          "Skipped"
                        )} · ${skippedCount}</span>`
                      : ""
                  }
                </div>
                <small>${this.escapeHtml(subtitle)}</small>
              </div>
            </div>
          </div>
      `;

      if (isSuccess && feesCreated > 0) {
        html += `
          <div class="fee-view-summary-row">
            <div class="fee-view-summary-card">
              <span class="fee-view-summary-label">${this.$t(
                "Fees Created"
              )}</span>
              <span class="fee-view-summary-value">${feesCreated}</span>
            </div>
            ${
              skippedCount
                ? `
            <div class="fee-view-summary-card">
              <span class="fee-view-summary-label">${this.$t("Skipped")}</span>
              <span class="fee-view-summary-value">${skippedCount}</span>
            </div>`
                : ""
            }
          </div>
        `;
      }

      if (skippedCount) {
        html += `
          <div class="fee-view-table-wrap">
            <table class="fee-view-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>${this.$t("Fee Type")}</th>
                  <th>${this.$t("Period")}</th>
                  <th>${this.$t("Reason")}</th>
                  <th>${this.$t("Existing Fee")}</th>
                </tr>
              </thead>
              <tbody>
        `;
        skipped.forEach((item, index) => {
          html += this.buildFeeSkipTableRowHtml(item, index);
        });
        html += `
              </tbody>
            </table>
          </div>
        `;
      }

      html += `</div>`;

      Swal.fire({
        title: "",
        html,
        icon: undefined,
        showCloseButton: true,
        confirmButtonText: this.$t("Done"),
        width: skippedCount > 1 ? "40rem" : "34rem",
        padding: "0",
        customClass: {
          popup: "fee-view-popup",
          htmlContainer: "fee-view-container",
          actions: "fee-view-actions",
          confirmButton: "fee-view-btn",
          closeButton: "fee-view-close",
        },
      });
    },
    async saveFee() {
      this.CheckType();
      this.CheckMonths();
      this.CheckYear();
      if (
        this.CheckType() == false ||
        this.CheckMonths() == false ||
        this.CheckYear() == false
      ) {
        return this.$bvToast.toast(this.$t("Please fill the form correctly."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }

      this.saving = true;
      try {
        const { data } = await axios({
          method: "post",
          url:
            this.$store.state.domain +
            "Fees/CreateFee?db=" +
            this.$store.state.userData.db,
          headers: {
            Authorization: "bearer " + this.$store.state.userData.token,
            "Content-Type": "application/json",
          },
          data: this.collection,
        });

        const feesCreated = Number(data?.feesCreated) || 0;
        const skipped = Array.isArray(data?.skipped) ? data.skipped : [];
        const responseMessage =
          typeof data?.data === "string" ? data.data : data?.message || "";

        if (data?.status === "success" && feesCreated > 0) {
          if (skipped.length) {
            this.showCreateFeeResult({
              feesCreated,
              skipped,
              isSuccess: true,
            });
          } else {
            this.$bvToast.toast(this.$t("Fee created successfully."), {
              title: this.$t("Success"),
              variant: "success",
              toaster: "b-toaster-top-center",
            });
          }
          if (this.fromGr) this.loadGrid();
          else this.loadByFamily();
        } else if (skipped.length) {
          this.showCreateFeeResult({
            feesCreated,
            skipped,
            message: responseMessage || this.$t("No fees were created."),
            isSuccess: false,
          });
        } else {
          this.$bvToast.toast(responseMessage || this.$t("Request failed."), {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
        }
      } catch (error) {
        const apiMessage =
          error?.response?.data?.data ||
          error?.response?.data?.message ||
          error?.message ||
          this.$t("Request failed.");
        this.$bvToast.toast(apiMessage, {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } finally {
        this.saving = false;
      }
    },
    CheckPartialType() {
      var elem = this.$refs["type"];
      if (
        this.collection.feesTypeIDs.length == 0 ||
        this.collection.feesTypeIDs.length > 1
      ) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    openPartial() {
      this.CheckMonths();
      this.CheckYear();
      if (this.CheckMonths() != false && this.CheckYear() != false) {
        if (this.CheckPartialType() == false) {
          this.$bvToast.toast(
            "You can only create partial fee for 1 fee type at a time.",
            {
              title: this.$t("Error!"),
              variant: "danger",
              toaster: "b-toaster-top-center",
            }
          );
        } else {
          this.$bvModal.show("modal-partial");
        }
      }
    },
    CheckPerc() {
      var elem = this.$refs["perc"];
      let x = parseFloat(this.partialPerc);
      if (isNaN(x) || x <= 0 || x > 100) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async savePartialFee() {
      if (this.CheckPerc() == true) {
        let ftt = this.campusFeeType.find(
          (el) => el.id == this.collection.feesTypeIDs[0]
        );
        let ft = ftt ? ftt.feeType : "";

        let result = await Swal.fire({
          title: this.$t("Are you sure?"),
          text:
            "Do you want to create " + ft + " for " + this.partialPerc + "% ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("Yes"),
        });
        if (result.isConfirmed) {
          this.partialPerc = parseFloat(this.partialPerc);

          const obj = {
            classIDs: [],
            secIDs: [],
            year: this.collection.year,
            feesTypeIDs: this.collection.feesTypeIDs,
            months: this.collection.months,
            perc: this.partialPerc,
            campusID: this.myObj.campusID || this.$store.state.userData.cId,
            userID: this.$store.state.userData.userID,
          };

          this.partialrequest = true;
          var status = await this.post({
            url:
              this.$store.state.domain +
              "Fees/CreateFeePartialStudent?db=" +
              this.$store.state.userData.db +
              "&sID=" +
              this.myObj.id,
            body: obj,
            message: "Fee created successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.partialrequest = false;

          if (status) {
            this.$bvModal.hide("modal-partial");

            if (this.fromGr) this.loadGrid();
            else this.loadByFamily();
          }
        }
      }
    },

    async LoadFeeType() {
      this.dataLoading = true;

      var obj = {
        url:
          this.$store.state.domain +
          "FeeType?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.allfeeType = await this.get(obj);
      this.campusFeeType = [...this.allfeeType];
      // console.log("fee data", this.allfeeType);

      this.dataLoading = false;
    },
    async LoadCampusFeeType() {
      this.dataLoading = true;

      var obj = {
        url:
          this.$store.state.domain +
            "FeeType?db=" +
            this.$store.state.userData.db +
            "&cId=" +
            this.myObj.campusID || this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.campusFeeType = await this.get(obj);
      // console.log("fee data", this.campusFeeType);

      this.dataLoading = false;
    },

    async LoadCollectionLinks() {
      var obj2 = {
        url:
          this.$store.state.domain +
          "Settings/GetCollectionLinks?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.linkedAccounts = await this.get(obj2);
      // console.log("collection links", this.linkedAccounts);
    },
    async loadAccounts() {
      var obj2 = {
        url:
          this.$store.state.domain +
          "CollectionAccounts?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      let result = await this.get(obj2);
      // console.log("acc", result);
      if (result !== "NotFound") {
        const linked = Array.isArray(result) ? result : [];
        this.accTypes = this.filterCollectionAccountsByRole(linked);
      } else this.accTypes = [];

      if (
        this.reportDomain === "myskoolhpgs" &&
        this.$store.state.loggedUser.campusID != 1
      ) {
        this.accTypes = this.accTypes.filter((el) => [18, 20].includes(el.id));
      }

      if (this.reportDomain == "myskooliuss") {
        this.accTypes = this.accTypes.filter((el) =>
          this.accIDs.includes(el.id)
        );
      }
      // console.log("accTypes", this.accTypes);

      // if exists
      if (this.accTypes.find((el) => el.id == this.$store.state.accountType)) {
        this.accountType = this.$store.state.accountType;
      }
      // not exists then first record
      else if (this.accTypes.length > 0) {
        this.accountType = this.accTypes[0].id;
        this.$store.commit("setAccountType", this.accountType);
      }
      // no records of accounts then set to 0
      else {
        this.$store.commit("setAccountType", 0);
        this.accountType = this.$store.state.accountType;
      }
      this.challanObj.accountID = this.$store.state.accountType;
      this.receiveObj.accountID = this.$store.state.accountType;
    },
    openAccount() {
      this.accIcon = "PlusIcon";
      this.accountbar = true;
      this.accountObj = {
        id: 0,
        campusID: this.$store.state.userData.cId,
        account: "",
        status: "active",
        accountID: 0,
      };
      var elem = this.$refs["accname"];
      elem.state = undefined;

      this.linkObj = null;
      if (this.reportDomain === "myskooliuss") {
        this.linkObj = {
          id: 0,
          campusID: this.$store.state.userData.cId,
          key: "collection_links",
          value: "",
          valueBool: true,
          valueNumber: 0,
        };
      }
    },
    checkAccount() {
      var elem = this.$refs["accname"];
      if (this.accountObj.account == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async saveAcc() {
      if (this.checkAccount() == true) {
        if (this.reportDomain === "myskooliuss") this.saveWithLink();
        else {
          this.savingacc = true;
          if (this.accountObj.id == 0) {
            var status = await this.post({
              url:
                this.$store.state.domain +
                "CollectionAccounts?db=" +
                this.$store.state.userData.db,
              body: this.accountObj,
              message: "Account added successfully.",
              context: this,
              token: this.$store.state.userData.token,
            });
          } else {
            var status = await this.put({
              url:
                this.$store.state.domain +
                "CollectionAccounts/" +
                this.accountObj.id +
                "?db=" +
                this.$store.state.userData.db,

              message: "Account updated successfully.",
              context: this,
              body: this.accountObj,
              token: this.$store.state.userData.token,
            });
          }
          if (status) {
            this.loadAccounts();
            this.accountObj = {
              id: 0,
              campusID: this.$store.state.userData.cId,
              account: "",
              status: "active",
              accountID: 0,
            };
            var elem = this.$refs["accname"];
            elem.state = undefined;
          }
          this.savingacc = false;
        }
      }
    },
    async saveWithLink() {
      this.savingacc = true;

      let setting = null;
      if (this.linkObj) {
        this.linkObj.valueNumber = this.accountObj.accountID;
        if (this.linkObj.id == 0 && this.linkObj.valueNumber == 0) {
          setting = null;
        } else setting = this.linkObj;
      }

      var status = await this.post({
        url:
          this.$store.state.domain +
          "CollectionAccounts/SaveWithLinks?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: {
          collection: { ...this.accountObj, accountID: 0 },
          setting: setting,
        },
        message: "Account saved successfully.",
        context: this,
        token: this.$store.state.userData.token,
      });
      if (status) {
        this.loadAccounts();
        this.LoadCollectionLinks();
        this.accountObj = {
          id: 0,
          campusID: this.$store.state.userData.cId,
          account: "",
          status: "active",
          accountID: 0,
        };
        this.linkObj = {
          id: 0,
          campusID: this.$store.state.userData.cId,
          key: "collection_links",
          value: "",
          valueBool: true,
          valueNumber: 0,
        };
        var elem = this.$refs["accname"];
        elem.state = undefined;
      }
      this.savingacc = false;
    },
    async editAcc(acc) {
      this.accountObj = { ...acc };
      this.accIcon = "Edit2Icon";
      var elem = this.$refs["accname"];
      elem.state = undefined;
      // console.log(this.accountObj);
      this.linkObj = null;
      if (this.reportDomain === "myskooliuss") {
        const linkedAccount = this.linkedAccounts.find(
          (el) => el.value == acc.id
        );
        // console.log("linkedAccount", linkedAccount);
        if (linkedAccount) {
          this.accountObj.accountID = linkedAccount.valueNumber;
          this.linkObj = { ...linkedAccount };
        } else {
          this.accountObj.accountID = 0;
          this.linkObj = {
            id: 0,
            campusID: this.$store.state.userData.cId,
            key: "collection_links",
            value: `${acc.id}`,
            valueBool: true,
            valueNumber: 0,
          };
        }
      }
    },
    async deleteAcc(acc) {
      // console.log(acc);
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "CollectionAccounts/" +
            acc.id +
            "?db=" +
            this.$store.state.userData.db,

          message: "Account deleted successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.loadAccounts();
      }
    },
    async showAccBranch(item) {
      this.currentAccount = { ...item };
      this.modalTitle = "Account Branches - " + item.account;
      this.$bvModal.show("modal-account");
      // this.selectedCamp = [];
      // this.branchForm = false;

      // this.branchLoading = true;
      // var obj = {
      //   url:
      //     this.$store.state.domain +
      //     "CollectionAccountBranch/LoadData?db=" +
      //     this.$store.state.userData.db +
      //     "&accID=" +
      //     item.id +
      //     "&campID=" +
      //     this.$store.state.userData.cId,
      //   token: this.$store.state.userData.token,
      // };
      // this.branchItems = await this.get(obj);
      // // console.log(this.branchItems);
      // this.branchLoading = false;
    },
    addBranch() {
      this.branchObj = {
        id: 0,
        accountID: this.currentAccount.id,
        campusID: this.currentAccount.campusID,
        branch: "",
        accountNumber: "",
        linkedCampuses: "",
      };
      this.selectedCamp = [];
      this.branchForm = true;
    },
    editBranch(item) {
      this.branchObj = { ...item };
      this.selectedCamp = item.linkedCampuses
        .split(",")
        .filter((el) => el)
        .map(Number);
      this.branchForm = true;
    },
    setCampus() {
      if (this.selectedCamp.at(-1) == 0) {
        this.selectedCamp = [0];
      } else {
        this.selectedCamp = this.selectedCamp.filter((el) => el != 0);
      }
    },
    CheckBName() {
      var elem = this.$refs["b_name"];
      if (this.branchObj.branch == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckBNo() {
      var elem = this.$refs["b_no"];
      if (this.branchObj.accountNumber == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckBCamp() {
      var elem = this.$refs["b_camp"];
      if (this.selectedCamp.length == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async saveBranch() {
      this.CheckBName();
      this.CheckBNo();
      this.CheckBCamp();
      if (
        this.CheckBName() == false ||
        this.CheckBNo() == false ||
        this.CheckBCamp() == false
      ) {
        return this.$bvToast.toast("Please enter the fields correctly.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        this.savingBranch = true;
        if (this.selectedCamp[0] == 0) {
          this.branchObj.linkedCampuses = this.campuses
            .map((el) => el.id)
            .join(",");
        } else {
          this.branchObj.linkedCampuses = this.selectedCamp.join(",");
        }
        // console.log(this.branchObj);

        let status = false;
        if (this.branchObj.id == 0) {
          status = await this.post({
            url:
              this.$store.state.domain +
              "CollectionAccountBranch?db=" +
              this.$store.state.userData.db,
            body: this.branchObj,
            message: "Branch added successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
        } else {
          status = await this.put({
            url:
              this.$store.state.domain +
              "CollectionAccountBranch/" +
              this.branchObj.id +
              "?db=" +
              this.$store.state.userData.db,
            message: "Branch updated successfully.",
            context: this,
            body: this.branchObj,
            token: this.$store.state.userData.token,
          });
        }
        this.savingBranch = false;

        if (status) {
          this.branchForm = false;
          await this.showAccBranch(this.currentAccount);
        }
      }
    },

    async onRowSelected(row) {
      // console.log(row);
      this.myObj.gr = row[0].grNo;
      this.myObj.familyCode = row[0].family_code;
      // console.log(this.myObj);
      this.loadGrid(row[0].id);
    },
    async onChallanRowSelect(ch) {
      const rows = Array.isArray(ch) ? ch : [];
      this.paid = rows.reduce((total, c) => total + (c.fees.balance || 0), 0);
      // console.log(this.paid);

      // Track selected rows by selection order
      // Check if anything is newly selected or deselected
      if (rows.length !== this.selectedRows.length) {
        // Find newly selected items (in rows but not in selectedRows)
        const newlySelected = rows.filter(
          (item) =>
            !this.selectedRows.some(
              (existing) => existing.fees.id === item.fees.id
            )
        );

        // Find deselected items (in selectedRows but not in rows)
        const deselected = this.selectedRows.filter(
          (item) => !rows.some((selected) => selected.fees.id === item.fees.id)
        );

        // Add new selections to the end of the array
        if (newlySelected.length > 0) {
          this.selectedRows.push(...newlySelected);
        }

        // Remove deselected items
        if (deselected.length > 0) {
          this.selectedRows = this.selectedRows.filter(
            (item) =>
              !deselected.some((removed) => removed.fees.id === item.fees.id)
          );
        }
      }

      // Now use selectedRows which maintains selection order
      const orderedSelection = this.selectedRows.filter((item) =>
        rows.some((selected) => selected.fees.id === item.fees.id)
      );

      if (this.fromChallan) {
        this.challanObj.feesIDs = orderedSelection.map((c) => c.fees.id);
        // console.log("ch", this.challanObj.feesIDs);
      } else {
        this.receiveObj.feesIDs = orderedSelection.map((c) => c.fees.id);
        // console.log("rec", this.receiveObj.feesIDs);
      }

      // console.log(this.selectedRows.map((c) => c.fees.id));
      this.getBalance();
      await this.fetchCustomFeesDateLoadData();
      await this.openSettings(false);
    },
    checkSelect() {
      // console.log(this.allSelect);
      this.allSelect ? this.selectAllRows() : this.clearSelected();
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    getBalance() {
      var elem = this.$refs["paid"];
      if (this.paid > this.total || this.paid < 0) {
        elem.state = false;
      } else {
        this.balance = this.total - this.paid;
        elem.state = undefined;
      }
    },
    checkRecAmount() {
      var elem = this.$refs["paid"];
      if (this.paid <= 0 || this.paid == null || this.paid > this.total) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkRecAccount() {
      var elem = this.$refs["acc"];
      if (this.fromChallan) {
        if (this.challanObj.accountID == 0 || this.challanObj.accountID == "") {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else {
        if (this.receiveObj.accountID == 0 || this.receiveObj.accountID == "") {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      }
    },
    checkDate() {
      // console.log(this.receiveObj.rcvDate);
      this.challanObj.rcvDate = this.receiveObj.rcvDate;
      this.$store.commit("setDate", this.receiveObj.rcvDate);
      var elem = this.$refs["rcvDate"];
      if (this.receiveObj.rcvDate == "" || this.receiveObj.rcvDate == null) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckRcptNo() {
      if (this.reportDomain === "myskoolhpgs") {
        var elem = this.$refs["rcptNo"];
        let x = parseInt(this.receiveObj.barcode);
        if (isNaN(x) || x < 0) {
          return (elem.state = false);
        } else {
          this.receiveObj.barcode = x;
          return (elem.state = true);
        }
      } else return true;
    },
    setAccount() {
      this.$store.commit("setAccountType", this.accountType);
      this.challanObj.accountID = this.$store.state.accountType;
      this.receiveObj.accountID = this.$store.state.accountType;

      // console.log(this.$store.state.accountType);
    },
    async receiveFee(text) {
      if (
        this.fromShortcut &&
        (this.paid == 0 || this.paid == null || this.paid == "")
      )
        this.paid = this.total;
      if (
        this.checkRecAmount() == false ||
        this.checkRecAccount() == false ||
        this.checkDate() == false ||
        this.CheckRcptNo() == false
      ) {
        this.$bvToast.toast("Please enter the required details.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        // this.paid = null;
        this.fromShortcut = false;
        this.slipShortcut = false;
        this.check = 1;
      } else {
        if (this.fromChallan) text = "challan";
        if (text == "challan") {
          this.challanObj.amount = parseInt(this.paid);
          this.challanObj.challanNo = parseInt(this.myObj.challanNo);
          // this.challanObj.accountID = this.$store.state.accountType;

          // console.log(this.challanObj);

          this.receiving = true;
          var status = await this.post({
            url:
              this.$store.state.domain +
              "Fees/ReceiveFeesByChallan?db=" +
              this.$store.state.userData.db +
              "&campusID=" +
              this.$store.state.userData.cId,
            body: this.challanObj,
            message: "Fee received successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.receiving = false;
          if (status) {
            this.gridLoading = true;
            this.items = [];
            this.history = [];
            this.challanObj = {
              challanNo: 0,
              amount: 0,
              rcvDate: this.$store.state.date,
              userID: this.$store.state.userData.userID,
              campusID: this.$store.state.userData.cId,
              feesIDs: [],
              accountID: this.$store.state.accountType,
            };
            this.myObj = {
              grNo: null,
              familyCode: null,
              challanNo: null,
              id: 0,
            };
            this.total = null;
            this.balance = null;
            this.paid = null;

            this.gridLoading = false;
          }
        } else {
          this.receiveObj.amount = parseInt(this.paid);
          // this.receiveObj.accountID = this.$store.state.accountType;
          // this.receiveObj.grNo = this.myObj.gr;

          // console.log(this.receiveObj);
          this.receiving = true;
          let campID = this.myObj.campusID || this.$store.state.userData.cId;

          if (this.chDetails && this.chDetails.valueBool) {
            this.receiveObj.feesChequeDetails = {
              id: 0,
              billID: 0,
              organizationID: this.otherObj.organization,
              bank: this.otherObj.bank,
              cheque: this.otherObj.cheque,
              otherDetails: "",
              campusID: campID,
            };
          } else this.receiveObj.feesChequeDetails = null;

          this.receiveObj.campusID = campID;
          // "Fees/ReceiveFees?db=" +
          var status = await this.post({
            url:
              this.$store.state.domain +
              "Fees/ReceiveFeesNew?db=" +
              this.$store.state.userData.db +
              "&withLate=" +
              this.withLate,
            body: this.receiveObj,
            message: "Fee received successfully.",
            context: this,
            token: this.$store.state.userData.token,
            feeReceive: true,
          });
          // console.log(status);
          if (status) {
            this.slipNo = status;
            if (this.receiveObj.grNo == "") this.loadByFamily();
            else this.loadGrid();

            this.receiveObj.barcode = 0;
            this.receiveObj.receiveNote = "";
          }
        }
      }
    },
    CheckMobile() {
      // var re = /^(\+92|0|92)[0-9]{10}$/;
      // if (re.test(this.myObj.contact) && this.myObj.contact !== "") {
      //   return (this.contacterror = false);
      // } else {
      //   return (this.contacterror = true);
      // }
      // console.log(this.myObj.contact.length);
      if (this.myObj.contact.length == 12) {
        return (this.contacterror = false);
      } else {
        return (this.contacterror = true);
      }
    },
    CheckEmail() {
      var elem = this.$refs["email"];
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (
        re.test(String(this.myObj.email).toLowerCase()) &&
        this.myObj.email !== ""
      ) {
        return (elem.state = true);
      } else {
        return (elem.state = false);
      }
    },
    CheckType() {
      var elem = this.$refs["type"];
      if (this.collection.feesTypeIDs.length == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckMonths() {
      var elem = this.$refs["months"];
      if (this.collection.months.length == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckYear() {
      var elem = this.$refs["year"];
      if (this.collection.year == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    OpenModal() {
      // this.$bvModal.show("modal-upload");
      this.showUpload = true;
      this.uploadObj = {
        accountID: this.accountType,
        isTransport: true,
      };
    },
    showDeleted() {
      this.$bvModal.show("modal-receipt");
    },
    openSlipModal() {
      this.$bvModal.show("modal-slip");
    },
    checkSlipFrom() {
      var elem = this.$refs["slip_from"];
      if (this.slipObj.from == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkSlipTill() {
      var elem = this.$refs["slip_till"];
      if (this.slipObj.till == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkRange() {
      return parseInt(this.slipObj.from) <= parseInt(this.slipObj.till);
    },
    printBulk() {
      this.checkSlipFrom();
      this.checkSlipTill();
      if (this.checkSlipFrom() == true && this.checkSlipTill() == true) {
        if (this.checkRange() == true) {
          this.printingSlip = true;
          let url =
            `https://${this.reportDomain}.myskool.app/Fee/SlipRange?dbb=` +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&from=" +
            parseInt(this.slipObj.from) +
            "&till=" +
            parseInt(this.slipObj.till);

          // console.log(url);
          this.printingSlip = false;
          window.open(url, "_blank");
        } else {
          this.$bvToast.toast("Please enter correct range", {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
        }
      }
    },

    openEditDate(fees) {
      this.editFee = { ...fees, newDate: null };
      this.isEditDateModalVisible = true;
    },
    async handleEditDate() {
      // Validate date
      const dateElem = this.$refs.edit_date;
      if (!this.editFee.newDate) {
        dateElem.state = false;
        return;
      } else {
        dateElem.state = true;
      }

      const result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: "Do you want to update the received date?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Update it!",
      });

      if (result.isConfirmed) {
        this.isUpdatingDate = true;

        const status = await this.post({
          url:
            this.$store.state.domain +
            "Fees/UpdateRcvdDate?db=" +
            this.$store.state.userData.db +
            "&campusID=" +
            this.editFee.campusID +
            "&billID=" +
            this.editFee.billID +
            "&dt=" +
            this.editFee.newDate +
            "&userID=" +
            this.$store.state.userData.userID,
          message: "Received date updated successfully.",
          context: this,
          body: null,
          token: this.$store.state.userData.token,
        });

        this.isUpdatingDate = false;
        if (status) {
          this.isEditDateModalVisible = false;
          this.editFee = null;
          this.loadHistoryGrid(); // Refresh the grid to show updated data
        }
      }
    },

    getHoldReasonText(fees) {
      if (!fees || fees.holdReason == null || fees.holdReason === "") {
        return "";
      }
      return String(fees.holdReason).trim();
    },
    /** IOTA legacy: hold date lived in holdReason; newer API uses holdTill. */
    getIotaHoldDateValue(fees) {
      if (!fees) return null;
      if (fees.holdTill) return fees.holdTill;
      if (fees.holdReason == null || fees.holdReason === "") return null;
      const raw = String(fees.holdReason).trim();
      const parsed = Date.parse(raw);
      if (Number.isNaN(parsed)) return null;
      return raw;
    },
    truncateHoldReason(text, maxLen = 36) {
      if (!text) return "";
      if (text.length <= maxLen) return text;
      return `${text.slice(0, maxLen)}…`;
    },
    formatHoldTillDate(value) {
      if (!value) return "—";
      try {
        return new Date(value).toLocaleDateString("en-UK", {
          year: "numeric",
          day: "numeric",
          month: "short",
        });
      } catch (_) {
        return String(value);
      }
    },
    openHoldReasonModal(item) {
      const fees = item && item.fees;
      this.holdReasonModalText = this.getHoldReasonText(fees);
      const st = item && item.stdd;
      const name = st && st.name ? st.name : "";
      const gr = st && st.grNo != null ? `GR ${st.grNo}` : "";
      this.holdReasonModalStudent = [name, gr].filter(Boolean).join(" · ");
      this.holdReasonModalClassSection = item
        ? this.formatClassSection(item)
        : "";
      this.holdReasonModalHoldTill =
        fees && fees.holdTill ? fees.holdTill : null;
      this.holdReasonModalVisible = true;
    },

    formatClassSection(item) {
      if (!item) return "-";
      const className =
        (item.cls && (item.cls.name || item.cls.className)) || "";
      const sectionName = (item.sec && item.sec.section) || "";
      if (className && sectionName) return `${className} - ${sectionName}`;
      return className || sectionName || "-";
    },

    printFeeReminder(item) {
      const routeData = this.$router.resolve({
        name: "fee-reminder-print",
        query: {
          db: this.$store.state.userData.db,
          cID: item.fees.campusID || this.$store.state.userData.cId,
          classID: (item.cls && item.cls.id) || 0,
          secID: (item.sec && item.sec.id) || 0,
          search: item.stdd.grNo,
        },
      });
      window.open(routeData.href, "_blank");
    },

    openStudentProfile() {
      if (!this.canOpenStudentProfile) return;

      const studentId = String(this.myObj.id);
      const status = String(this.myObj.status || "present").toLowerCase();
      let route;

      if (["myskooltcfdemo", "myskooltcf"].includes(this.reportDomain)) {
        route = this.$router.resolve({
          name: "student-details",
          params: { id: studentId },
        });
      } else if (this.studentGridRights.edit) {
        route = this.$router.resolve({
          name: "manage-student",
          params: {
            id: studentId,
            readmit: false,
          },
          query: { status },
        });
      } else {
        route = this.$router.resolve({
          name: "apps-users-view",
          params: {
            id: studentId,
            item: "student",
          },
        });
      }

      window.open(route.href, "_blank", "noopener,noreferrer");
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
<style scoped>
.student-profile-block--clickable {
  cursor: pointer;
  border-radius: 0.5rem;
  transition: background-color 0.15s ease;
}

.student-profile-block--clickable:hover {
  background-color: rgba(115, 103, 240, 0.08);
}

.profileImg {
  width: 70px;
  height: 70px;
  object-fit: cover;
  margin: 0px 10px;
  transition: 1s ease-in-out;
}
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
.card {
  transition: 0.4s;
}
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
.rightCard {
  border: 1px solid lightgray;
  /* box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1); */
}
.setting {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid gray;
  cursor: pointer;
}
@media only screen and (max-width: 496px) {
  /* your CSS here */
  .topButtons {
    margin-top: 10px;
  }
}
.my-btn {
  color: #605757;
}
.swiper-button-next {
  right: 0px;
}
.swiper-button-prev {
  left: 0px;
}
.my-collapsing {
  height: 55px;
  overflow: hidden;
}
.my-buttons {
  position: absolute;
  top: 0px;
  right: 10px;
  cursor: pointer;
}
.v-select.set_multi::v-deep .vs__dropdown-toggle {
  max-height: 300px !important;
  overflow-y: auto;
}
</style>
<style>
.fee-view-popup {
  border-radius: 12px !important;
  max-width: calc(100vw - 1.5rem) !important;
  overflow: hidden !important;
  box-shadow: 0 12px 32px rgba(47, 43, 61, 0.12) !important;
}
.fee-view-container {
  padding: 0 !important;
  margin: 0 !important;
  overflow: hidden !important;
}
.fee-view-actions {
  margin: 0 !important;
  padding: 0.75rem 1.15rem 1rem !important;
  border-top: 1px solid #ebe9f1;
  background: #fff;
}
.fee-view-btn {
  min-width: 6.5rem !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
  padding: 0.5rem 1.25rem !important;
  background: #7367f0 !important;
  box-shadow: none !important;
}
.fee-view-close {
  color: #b9b9c3 !important;
  top: 0.75rem !important;
  right: 0.75rem !important;
}
.fee-view-sheet {
  text-align: left;
  background: #fff;
}
.fee-view-header-card {
  padding: 1rem 1.15rem 0.85rem;
  border-bottom: 1px solid #ebe9f1;
  background: #fff;
}
.fee-view-title-wrap {
  padding-right: 1.25rem;
}
.fee-view-title-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.45rem;
  margin-bottom: 0.3rem;
}
.fee-view-title-row h4 {
  font-size: 1rem;
  font-weight: 700;
  color: #2f2b3d;
}
.fee-view-title-wrap small {
  display: block;
  font-size: 0.82rem;
  color: #6e6b7b;
  line-height: 1.45;
}
.fee-view-badge-pill {
  display: inline-flex;
  align-items: center;
  padding: 0.15rem 0.55rem;
  border-radius: 999px;
  background: #f3f2f7;
  color: #6e6b7b;
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.fee-view-summary-row {
  display: flex;
  gap: 0.75rem;
  padding: 0.85rem 1.15rem 0;
  background: #fff;
}
.fee-view-summary-card {
  flex: 1;
  border: 1px solid #ebe9f1;
  border-radius: 8px;
  padding: 0.65rem 0.85rem;
  background: #fff;
}
.fee-view-summary-label {
  display: block;
  font-size: 0.68rem;
  font-weight: 600;
  color: #a8aaae;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 0.15rem;
}
.fee-view-summary-value {
  font-size: 1.15rem;
  font-weight: 700;
  color: #2f2b3d;
  line-height: 1.1;
}
.fee-view-table-wrap {
  padding: 0.85rem 1.15rem 1rem;
  max-height: 280px;
  overflow: auto;
}
.fee-view-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.84rem;
}
.fee-view-table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f8f8f8;
  color: #6e6b7b;
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 0.55rem 0.65rem;
  border-bottom: 1px solid #ebe9f1;
  white-space: nowrap;
}
.fee-view-table tbody td {
  padding: 0.6rem 0.65rem;
  border-bottom: 1px solid #f1f1f2;
  color: #5e5873;
  vertical-align: middle;
}
.fee-view-table tbody tr:last-child td {
  border-bottom: none;
}
.fee-view-table tbody td:first-child {
  width: 2rem;
  color: #b9b9c3;
  font-weight: 600;
}
.fee-view-cell-strong {
  font-weight: 600;
  color: #2f2b3d;
}
.fee-view-reason-tag {
  display: inline-block;
  padding: 0.12rem 0.45rem;
  border-radius: 4px;
  background: #f3f2f7;
  color: #6e6b7b;
  font-size: 0.76rem;
  font-weight: 600;
  white-space: nowrap;
}

.hold-reason-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  max-width: 100%;
  padding: 0.28rem 0.55rem;
  border: 1px solid rgba(234, 84, 85, 0.28);
  border-radius: 6px;
  background: rgba(234, 84, 85, 0.08);
  color: #ea5455;
  font-size: 0.78rem;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease,
    box-shadow 0.15s ease;
}
.hold-reason-chip:hover,
.hold-reason-chip:focus {
  background: rgba(234, 84, 85, 0.14);
  border-color: rgba(234, 84, 85, 0.45);
  box-shadow: 0 2px 8px rgba(234, 84, 85, 0.12);
  outline: none;
}
.hold-reason-chip__icon {
  flex-shrink: 0;
  opacity: 0.9;
}
.hold-reason-chip__text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 140px;
  text-align: left;
  color: #5e5873;
}
.hold-reason-chip--sm {
  padding: 0.2rem 0.45rem;
  font-size: 0.72rem;
}
.hold-reason-chip--sm .hold-reason-chip__text {
  max-width: 110px;
}

.hold-reason-modal__banner {
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
  padding: 1rem 1.25rem;
  background: linear-gradient(
    135deg,
    rgba(234, 84, 85, 0.1) 0%,
    rgba(234, 84, 85, 0.04) 100%
  );
  border-bottom: 1px solid rgba(234, 84, 85, 0.12);
}
.hold-reason-modal__banner-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 10px;
  background: #fff;
  color: #ea5455;
  box-shadow: 0 2px 8px rgba(234, 84, 85, 0.15);
  flex-shrink: 0;
}
.hold-reason-modal__banner-text {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;
}
.hold-reason-modal__banner-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: #2f2b3d;
  letter-spacing: 0.01em;
}
.hold-reason-modal__banner-date {
  font-size: 0.8rem;
  color: #6e6b7b;
}
.hold-reason-modal__banner-date strong {
  color: #ea5455;
  font-weight: 700;
}
.hold-reason-modal__content {
  padding: 1rem 1.25rem 0.25rem;
}
.hold-reason-modal__student {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin-bottom: 1rem;
  padding: 0.55rem 0.75rem;
  border-radius: 8px;
  background: #f8f8f8;
  border: 1px solid #ebe9f1;
  font-size: 0.84rem;
  font-weight: 600;
  color: #5e5873;
}
.hold-reason-modal__student svg {
  color: #7367f0;
  flex-shrink: 0;
}
.hold-reason-modal__reason-label {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #a8aaae;
  margin-bottom: 0.45rem;
}
.hold-reason-modal__reason-box {
  padding: 0.85rem 1rem;
  border-radius: 8px;
  border: 1px solid #ebe9f1;
  background: #fff;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 0.92rem;
  line-height: 1.55;
  color: #2f2b3d;
  min-height: 3.5rem;
}
</style>
